/* eslint-disable max-lines */

export default {
  translation: {
    // Generic
    INIT_KEY: 'Iniciando',
    AUTO_PANEL_TITLE_KEY: 'Autosky Console',
    EXTERNAL_INFO_KEY:
      'Código externo à plataforma do Autosky, utilizado para identificar um cliente',
    PANEL_KEY: 'Painel',
    CONFIG_KEY: 'Configurações',
    COLORS_KEY: 'Cores',
    FONTS_KEY: 'Fontes',
    VISUALIZE_EDITION_KEY: 'Visualizar edição',
    ADMIN_PANEL_KEY: 'Painel administração',
    LOGIN_KEY: 'Entrar',
    ADD_KEY: 'Adicionar',
    PRODUCT_KEY: 'Produto',
    FINALIZE_KEY: 'Finalizar',
    SUPPORT: 'Suporte',
    FAVORITES_KEY: 'Meus favoritos',
    PREPARATION: 'Preparação',
    NEWS_KEY: 'Novidades',
    ACTIVE_KEY: 'Ativo',
    PRIVACY_KEY: 'Privacidade',
    NOT_FOUND_NOTIFICATION_KEY: 'Nenhuma notificação encontrada',
    PASSWORD_MUST_CONTAIN_KEY: 'A senha deve conter',
    REQUIRE_MIN_LENGTH_TEXT_KEY: 'Mínimo de {{min_length}} caracteres',
    REQUIRE_MAX_LENGTH_TEXT_KEY: 'Máximo de {{max_length}} caracteres',
    REQUIRED_LETTER_UPPERCASE_KEY: 'Pelo menos um caractere em maiúsculo',
    REQUIRED_LETTER_LOWERCASE_KEY: 'Pelo menos um caractere em minúsculo',
    REQUIRED_LETTER_TO_NUMBER_KEY: 'Pelo menos um número',
    REQUIRED_LETTER_SPECIAL_CHARACTER_KEY: 'Pelo menos um caractere especial',
    REQUIRED_OPTION_KEY: 'Selecione pelo menos uma opção',
    EXTEND_KEY: 'Prorrogar',
    WORK_KEY: 'Tarefa',
    STATE_KEY: 'Estado',
    OF_DAY_KEY: 'de',
    AT_HOUR_KEY: 'às',
    APPLY_KEY: 'Aplicar',
    REVERT_KEY: 'Reverter',
    DO_NOT_APPLY_KEY: 'Não aplicar',
    SEE_DETAILS_KEY: 'Ver detalhes',
    SUCCESS_KEY: 'Sucesso',
    ATTENTION_KEY: 'Atenção',
    NOT_ENOUGH_DATA_KEY: 'Não há dados suficientes',
    COPY_KEY: 'Cópia',
    COPY_CLICK_HERE_KEY: 'Clique aqui para copiar',
    EDIT_KEY: 'Editar',
    DETAILS_KEY: 'Detalhes',
    ZOHO_ID_KEY: 'Zoho ID',
    CLONE_KEY: 'Clonar',
    STOP_KEY: 'Parar',
    REMOVE_KEY: 'Excluir',
    DELETE_KEY: 'Excluir',
    BLOCK_KEY: 'Bloquear',
    UNBLOCK_KEY: 'Desbloquear',
    CODE_KEY: 'Código',
    INCLUDE_APPLICATION_KEY: 'Incluir aplicação',
    OPERATOR_NAME_KEY: 'Nome do operador',
    OPERATOR_ID_KEY: 'ID do operador',
    DISABLE_KEY: 'Desativar',
    INACTIVATED_KEY: 'Desativado',
    ENABLE_KEY: 'Ativar',
    TERMINATE_KEY: 'Terminar',
    SIMPLE_KEY: 'Simples',
    GO_OUT_KEY: 'Sair',
    ENTER_KEY: 'Entrar',
    PLATFORM_KEY: 'Plataforma',
    SAVE_KEY: 'Salvar',
    REGISTER_KEY: 'Cadastrar',
    RECOVER_KEY: 'Recuperar',
    RESEND_KEY: 'Reenviar',
    CHANGE_KEY: 'Alterar',
    DUPLICATE_KEY: 'Duplicar',
    CANCEL_KEY: 'Cancelar',
    CLEAR_FORM_KEY: 'Limpar',
    CONFIRM_KEY: 'Confirmar',
    CONNECT_KEY: 'Conectar',
    DOWNLOAD_KEY: 'Baixar',
    EXPORT_KEY: 'Exportar',
    LOADING_KEY: 'Carregando',
    SEARCH_KEY: 'Procurar',
    ACTION_KEY: 'Ação',
    ACTIONS_KEY: 'Ações',
    ACTIVATE_KEY: 'Ativar',
    INACTIVE_KEY: 'Inativo',
    MFA_ACTIVE_KEY: 'MFA Ativo',
    MFA_CONFIGURED_KEY: 'MFA configurado',
    MFA_RESET_KEY: 'Redefinir MFA',
    ACTIVE_MFA_TO_ALL_KEY: 'Ativar MFA para todos os usuários',
    STARTED_KEY: 'Iniciada',
    REMOVING_KEY: 'Excluindo',
    RECOVERING_KEY: 'Recuperando',
    START_KEY: 'Iniciar',
    REINITIALIZE_KEY: 'Reiniciar',
    UNLINK_KEY: 'Desvincular',
    BACK_KEY: 'Voltar',
    STATUS_KEY: 'Status',
    OPERATION_MODE_KEY: 'Modo de operação',
    OPERATION_MODE_MANUAL_KEY: 'Manual',
    OPERATION_MODE_PERIOD_KEY: 'Período',
    OPERATION_MODE_MICRO_KEY: 'Micro',
    OPERATION_MODE_SPOT_PERIOD_KEY: 'Período (Spot)',
    FLAVOR_KEY: 'Sabor',
    ID_ZOHO_KEY: 'ID Zoho',
    ZOHO_ID_ALREADY_EXISTS:
      'ID Zoho informado já está associado à uma companhia',
    OTHERS_KEY: 'Outros',
    CLOSE_KEY: 'Fechar',
    CLOSED_KEY: 'Fechado',
    PROFILE_KEY: 'Perfil',
    INTERNAL_KEY: 'Interno',
    COMPANY_KEY: 'Companhia',
    COMPANIES_KEY: 'Companhias',
    PARTNERS_KEY: 'Contas',
    ENVIRONMENTS_KEY: 'Ambientes',
    ENVIRONMENT_KEY: 'Ambiente',
    PROVIDER_KEY: 'Provedor',
    CLIENTS_KEY: 'Clientes',
    CLIENT_KEY: 'Cliente',
    APPLICATIONS_KEY: 'Aplicações',
    REASON_KEY: 'Motivo',
    APPLICATIONS_TOOLTIP_KEY:
      'Para que as aplicações sejam configuradas no Autosky, elas precisam ser cadastradas no Autosky Platform',
    NO_ACTIONS_AVAILABLE_KEY: 'Sem ações disponíveis',
    NO_USERNAME_AVAILABLE_KEY: 'Sem usuário disponível',

    APPLICATIONS_REMOVED_KEY: 'Aplicações removidas com sucesso!',
    APPLICATIONS_INACTIVE_KEY: 'Aplicações desativadas com sucesso!',
    APPLICATIONS_ACTIVE_KEY: 'Aplicações ativadas com sucesso!',

    WANT_ACTIVATE_APPLICATIONS_KEY: 'Ativar aplicações',
    WANT_INACTIVATE_APPLICATIONS_KEY: 'Desativar aplicações',
    WANT_REMOVE_APPLICATIONS_KEY: 'Remover aplicações',

    ACTIVATE_APPLICATIONS_SELECTED_DESCRIPTION_KEY:
      'Tem certeza que deseja ativar as aplicações selecionadas?',
    INACTIVATE_APPLICATIONS_SELECTED_DESCRIPTION_KEY:
      'Tem certeza que deseja desativar as aplicações selecionadas?',
    REMOVE_APPLICATIONS_SELECTED_DESCRIPTION_KEY:
      'Tem certeza que deseja remover as aplicações selecionadas?',

    BUTTON_ACTIVATE_APPLICATIONS_KEY: 'Ativar selecionadas',
    BUTTON_INACTIVATE_APPLICATIONS_KEY: 'Desativar selecionadas',
    BUTTON_REMOVE_APPLICATIONS_KEY: 'Remover selecionadas',

    APPLICATION_KEY: 'Adicionar aplicação',
    USERS_KEY: 'Usuários',
    USER_KEY: 'Usuário',
    USER_AD_KEY: 'Código no AD',
    OPERATORS_KEY: 'Operadores',
    OPERATOR_KEY: 'Operador',
    GENERAL_KEY: 'Geral',
    ADMINISTRATION_KEY: 'Administração',
    DASHBOARD_KEY: 'Dashboard',
    INSTANCES_KEY: 'Instâncias',
    INSTANCE_KEY: 'Instância',
    SERVERS_KEY: 'Servidores',
    SERVER_KEY: 'Servidor',
    MODELS_KEY: 'Modelos',
    MODEL_KEY: 'Modelo primário',
    SESSIONS_KEY: 'Sessões',
    IMAGE_KEY: 'Imagem',
    IMAGES_KEY: 'Imagens',
    JPEG_PNG_KEY: 'JPEG ou PNG',
    ALL_KEY: 'Todos',
    PORT_KEY: 'Porta',
    ZONE_KEY: 'Zona',
    PRIMARY_PORT_KEY: 'Porta primária',
    SECONDARY_PORT_KEY: 'Porta secundária',
    ROWS_PER_PAGE_KEY: 'Linhas por página',
    DESCRIPTION_KEY: 'Descrição',
    FULL_NAME_KEY: 'Nome completo',
    NAME_KEY: 'Nome',
    OPERATOR_VIEW_NAME_KEY: 'Nome do cliente',
    NOT_FOUND_KEY: 'Não encontrado',
    LAST_NAME_KEY: 'Sobrenome',
    CELLPHONE_KEY: 'Celular',
    SUGGESTION_KEY: 'Sugestão',
    DESCRIBE_SUGGESTION_KEY: 'Insira sua sugestão',
    BUSINESS_PHONE_KEY: 'Telefone comercial',
    YES_KEY: 'Sim',
    SETTINGS_KEY: 'Configurações',
    MAINTENANCE_KEY: 'Manutenção',
    MAINTENANCE_DISPLAY_WARNING_KEY: 'Ambiente com aviso de manutenção',
    MAINTENANCE_WARNING_KEY: 'Ambiente em manutenção',
    CLIENT_MAINTENANCE_WARNING_KEY: 'Cliente em manutenção',
    MAINTENANCE_SCHEDULED_KEY: 'Manutenção programada',
    MAINTENANCE_MANUAL_KEY: 'Manutenção manual',
    LOGS_KEY: 'Logs',
    LOGS_LISTING_KEY: 'Listagem de logs do ambiente',
    DOMAIN_KEY: 'Domínio',
    SUBJECT_KEY: 'Assunto',
    NO_KEY: 'Não',
    GENERAL_ACTIONS_KEY: 'Ações gerais',
    REMOVE_SELECT_KEY: 'Excluir selecionadas',
    RESET_PASSWORD_KEY: 'Redefinir senha',
    MFA_ENABLE_KEY: 'Habilitar MFA',
    LANGUAGE_KEY: 'Idioma',
    EXTERNAL_KEY: 'Externo',
    MANAGED_KEY: 'Gerenciado',
    CREATION_DATE_KEY: 'Data de criação',
    EXPIRATION_DATE_KEY: 'Data de expiração',
    START_DATE_KEY: 'Data de início',
    END_DATE_KEY: 'Data de fim',
    INITIAL_DATE_KEY: 'Data inicial',
    FINAL_DATE_KEY: 'Data final',
    DATE_KEY: 'Data',
    TIME_KEY: 'Hora',
    MINUTE_KEY: 'Minuto',
    MINUTES_KEY: 'Minutos',
    TYPE_KEY: 'Tipo',
    MESSAGE_KEY: 'Mensagem',
    PERIOD_KEY: 'Período',
    PERIODS_KEY: 'Períodos',
    PERIOD_1_KEY: 'Período 1',
    PERIOD_2_KEY: 'Período 2',
    RESTRICTION_RULE_1_KEY: 'Regra de restrição 1',
    RESTRICTION_RULE_2_KEY: 'Regra de restrição 2',
    TIME_ZONE_KEY: 'Zona horária',
    GENERAL_INFORMATION_KEY: 'Informações gerais',
    MONITORING_KEY: 'Monitoramento',
    MEMORY_KEY: 'Memória',
    CONNECTIONS_KEY: 'Conexões',
    TEMPERATURE_KEY: 'Temperatura',
    DAILY_VARIATION_KEY: 'Variação diária',
    LAST_HOUR_KEY: 'Última Hora',
    LAST_HOUR_UNI_ONLY_KEY: 'Últimas',
    HOUR_KEY: 'Horas',
    LATTER_KEY: 'Últimos',
    DAYS_KEY: 'Dias',
    ACCESS_RATE_KEY: 'Taxa de acesso',
    VACANCIES_AVAILABLE_KEY: 'Vagas disponíveis',
    TOTAL_KEY: 'Total',
    OCCUPIED_KEY: 'Ocupadas',
    BLOCKED_KEY: 'Bloqueadas',
    UNAVAILABLE_KEY: 'Inacessível',
    MODIFIED_BY_KEY: 'Modificado por',
    CREATE_DATE_KEY: 'Data de criação',
    SHOW_ALERT_KEY: 'Exibir aviso',
    ENV_DISPLAY_WARNING_ENABLED_KEY: 'Habilitado no ambiente',
    ENV_DISPLAY_WARNING_ENABLED_TOOLTIP_KEY: 'Ambiente está com aviso ativo',
    ENV_DISPLAY_WARNING_ENABLED_TOOLTIP_DATE_KEY: 'até {{date}}',
    GENERAL_SETTINGS_KEY: 'Configurações gerais',
    COUNTRY_KEY: 'País',
    ENABLED_KEY: 'Habilitado',
    DISABLED_KEY: 'Desabilitado',
    COPIED_KEY: 'Copiado!',
    TEST_OPEN_KEY: 'Teste de abertura',
    CONNECT_LIKE_KEY: 'Conectar como',
    OBJECT_KEY: 'Objeto',
    START_TIME_KEY: 'Horário inicial',
    END_TIME_KEY: 'Horário final',
    COMING_SOON_KEY: 'Em breve',
    TEST_KEY: 'Testar',
    MIN_LENGTH_KEY: 'Mínimo de {{value}} caracteres',
    MAX_LENGTH_KEY: 'Máximo de {{value}} caracteres',
    NEXT_KEY: 'Próximo',
    PREVIOUS_KEY: 'Anterior',
    GROUPS_KEY: 'Grupos',
    CURRENT_KEY: 'Atual',
    FIRST_PERIOD_KEY: 'Primeiro período',
    SECOND_PERIOD_KEY: 'Segundo período',
    LISTING_KEY: 'Listagem',
    IGNORE_KEY: 'Ignorar',
    MAX_VALUE_KEY: 'O valor máximo para este campo é {{value}}',
    MIN_VALUE_KEY: 'O valor mínimo para este campo é {{value}}',
    ID_ZOHO_EXCEPTION: 'O ID Zoho não pode ser iniciado com 9',

    ADDITION_KEY: 'Adição',
    MODIFICATION_KEY: 'Alteração',
    REMOVAL_KEY: 'Exclusão',
    VISUALIZATION_KEY: 'Visualização',
    CLONING_REQUESTED_KEY: 'Clonagem solicitada',
    CLONING_STARTED_KEY: 'Clonagem iniciada',
    CLONING_FINISHED_KEY: 'Clonagem finalizada',
    CLONING_FAILED_KEY: 'Clonagem falhou',

    SHORT_WEEK_DAYS_KEY: 'D, S, T, Q, Q, S, S',

    // Errors
    UNEXPECTED_ERROR: 'Ocorreu um erro inesperado',
    OPERATOR_IS_BLOCKED: 'Operador bloqueado',
    OPERATOR_DOES_NOT_EXIST: 'Operador não existe',
    MULTICLOUD_PROVIDER_NOT_SUPPORTED:
      'Ambientes com provedor multicloud não oferecem suporte a servidores',

    BOOT_VOLUME_KEY: 'Volume de Boot',
    BOOT_VOLUME_BACKUP_KEY: 'Backup de Volume de Boot',
    CUSTOM_IMAGE_KEY: 'Imagem Customizada',

    CHANGES_SAVED: 'Alterações salvas com sucesso!',
    LIST_USERS_EXPORT_FILENAME: 'Lista_de_Usuarios',
    LIST_HISTORY_SESSION_EXPORT_FILENAME: 'Lista_de_historico_de_sessoes',

    // Coutries
    BRAZIL_KEY: 'Brasil',
    SPAIN_KEY: 'Espanha',
    USA_KEY: 'Estados Unidos',

    LANGUAGES: {
      PORTUGUESE_KEY: 'Português',
      ENGLISH_KEY: 'Inglês',
      SPANISH_KEY: 'Espanhol',
    },
    ROLE_KEY: 'Role',
    ROLES: {
      SUPERADMIN_KEY: 'Super admin Skyone',
      ADMIN_KEY: 'Admin Skyone',
      OPERATOR_KEY: 'Operador Skyone',
      CLIENT_OPERATOR_KEY: 'Operador cliente',
    },

    SESSION_EXPIRED:
      'Sua sessão expirou ou seu token está inválido. Por favor, faça login novamente.',
    EXPIRED_SESSION_MODAL: {
      TITLE: 'Sessão expirada!',
      HEADER: 'Sua sessão expirou',
      MESSAGE: 'Você será redirecionado para a tela de login.',
      BUTTON_LABEL: 'Ok',
    },

    CODE_NOT_FOUND: 'Código não encontrado',
    EXPIRED_CODE:
      "Código expirado. Solicite um novo link de registro de senha clicando em 'Esqueci a senha'",

    UPDATE_MODAL: {
      MODAL_VERSION_TITLE_KEY: 'Bem-vindo ao Autosky',
      MODAL_VERSION_CONTENT_KEY:
        'Bem-vindo ao Painel de Administração do Autosky. Clique no botão abaixo para continuar.',
      MODAL_BUTTON_KEY: 'Ok',
    },

    BACK_SELECTED_COMPANY_KEY: 'Trocar companhia',
    DO_NOT_SELECT_PARTNER_KEY: 'Não selecionar conta',
    DO_NOT_SELECT_COMPANY_KEY: 'Não selecionar companhia',
    DO_NOT_HAVE_DASHBOARD_KEY: 'Você ainda não possui itens nos favoritos',
    TO_LIST_SELECT_COMPANY_AND_PARTNER_KEY:
      'Para visualizar a lista, selecione uma companhia e uma conta',
    DO_NOT_HAVE_PERMISSIONS_KEY:
      'Você não tem permissão para acessar essa funcionalidade. Entre em contato com o administrador.',
    CREATE_ENVIRONMENT_COMPANY_AND_PARTNER_KEY:
      'Para criar um ambiente selecione uma companhia e uma conta',
    CREATE_CLIENT_COMPANY_AND_PARTNER_KEY:
      'Para criar um cliente selecione uma companhia e uma conta',
    TO_LIST_SELECT_COMPANY_KEY:
      'Para visualizar a lista, selecione uma companhia',
    SELECT_COMPANY_KEY: 'Selecione uma companhia',

    // TopBar
    NOTIFICATIONS_KEY: 'Notificações',
    ACTIVITY_LOG_KEY: 'Log de atividades',
    OPEN_TICKET_KEY: 'Abrir chamado',
    INCREASE_RESOURCES_KEY: 'Aumentar recursos',
    DOCUMENTATION_KEY: 'Documentação',
    TUTORIAL_KEY: 'Tutorial Autosky',
    REQUEST_SUPPORT_KEY: 'Solicitar suporte',
    SEND_SUGGESTIONS_KEY: 'Enviar sugestões',
    CONTRACT_LICENSES_KEY: 'Contratar Licenças',
    CHANGE_REGION_KEY: 'Troca de região',
    CHANGE_REGION_MSG_KEY: 'Entrar com senha e MFA',
    MY_PROFILE_KEY: 'Meu perfil',
    CHANGE_AVATAR_KEY: 'Alterar avatar',
    LOGOUT_KEY: 'Finalizar sessão',
    LOGOUT_MSG_KEY: 'A sua sessão será finalizada. Confirme para continuar',

    // SideBar
    PARTNER_TYPE_KEY: 'Tipo da conta',
    SIDEBAR: {
      MANAGE_COMPANIES_KEY: 'Gerenciar companhias',
      COMPANIES_LIST_KEY: 'Listar companhias',
      ADD_COMPANY_KEY: 'Adicionar companhia',

      MANAGE_PARTNERS_KEY: 'Gerenciar contas',
      PARTNERS_LIST_KEY: 'Listar contas',
      ADD_PARTNER_KEY: 'Adicionar conta',

      MANAGE_ENVIRONMENTS_KEY: 'Gerenciar ambientes',
      ENVIRONMENTS_LIST_KEY: 'Listar ambientes',
      ADD_ENVIRONMENT_KEY: 'Adicionar ambiente',

      MANAGE_CLIENTS_KEY: 'Gerenciar clientes',
      CLIENTS_LIST_KEY: 'Listar clientes',
      ADD_CLIENT_KEY: 'Adicionar cliente',

      MANAGE_OPERATORS_KEY: 'Gerenciar operadores',
      OPERATORS_LIST_KEY: 'Listar operadores',
      ADD_OPERATOR_KEY: 'Adicionar operador',

      MANAGE_ADVISORS_KEY: 'Gerenciar otimizações',
      ADVISORS_LIST_KEY: 'Listar otimizações',

      MANAGE_GROUPS_KEY: 'Gerenciar grupos',
      GROUPS_LIST_KEY: 'Listar grupos',
      ADD_GROUP_KEY: 'Adicionar grupo',
      OPTIMIZATION_DASHBOARD_KEY: 'Dashboard de otimizações',
      MANAGEMENT_KEY: 'Gerenciamento',
      OPERATORS_AND_PERMISSIONS_KEY: 'Operadores e permissões',
    },

    // Dialogs
    LAST_ACCESS_KEY: 'Últimos acessos',
    LAST_ACCESS_SINGULAR_KEY: 'Último acesso',
    LIST_GENERAL_KEY: 'Listagem geral',
    SINGLE_CORPORATE_NAME_KEY: 'Razão social',

    CHOOSE_COMPANY_KEY: 'Escolha uma companhia',
    NEW_COMPANY_KEY: 'Nova companhia',
    SEARCH_COMPANY_KEY: 'Pesquisar companhia',

    CHOOSE_PARTNER_KEY: 'Escolha uma conta',
    NEW_PARTNER_KEY: 'Nova conta',
    SEARCH_PARTNER_KEY: 'Pesquisar conta',

    CHOOSE_CLIENT_KEY: 'Escolha um cliente',

    CHOOSE_ENVIRONMENT_KEY: 'Escolha um ambiente',

    // Cloud providers
    AMAZON_WEB_SERVICES_KEY: 'Amazon Web Services',
    AMAZON_WEB_SERVICES_CONFIRM_KEY:
      'Configuração Amazon Web Services realizada com sucesso!',
    GOOGLE_CLOUD_PLATFORM_KEY: 'Google Cloud Platform',
    GOOGLE_CLOUD_PLATFORM_CONFIRM_KEY:
      'Configuração Google Cloud Platform realizada com sucesso!',
    ORACLE_CLOUD_KEY: 'Oracle Cloud Infrastructure',
    ORACLE_CLOUD_CONFIRM_KEY:
      'Configuração Oracle Cloud Infrastructure realizada com sucesso!',

    // Fields
    MUST_BE_A_NUMBER_KEY: 'Esse campo deve ser um número',
    LAST_LOGIN_DATE_KEY: 'Último login',
    STATUS_MFA_CONFIGURED_KEY: 'MFA',
    STATUS_MFA_CONFIGURED_ACTIVE_KEY: 'Ativo',
    STATUS_MFA_CONFIGURED_INACTIVE_KEY: 'Inativo',
    STATUS_MFA_CONFIGURED_PENDING_KEY: 'Pendente',
    STATUS_OPERATOR_ACTIVE_KEY: 'Ativo',
    STATUS_OPERATOR_BLOCKED_KEY: 'Bloqueado',
    LOGIN_DATE_KEY: 'Data de login',
    LOGOUT_DATE_KEY: 'Data de logout',
    IP_ORIGIN_KEY: 'IP de origem',
    IP_DESTINY_KEY: 'IP destino',
    IPS_VALID_KEY: 'IPs válidos',
    TERMINATE_RATE_KEY: 'Razão término',
    EMAIL_KEY: 'E-mail',
    PASSWORD_KEY: 'Senha',
    YOUR_PASSWORD_KEY: 'Sua senha',
    CURRENT_PASSWORD_KEY: 'Senha atual',
    NEW_PASSWORD_KEY: 'Nova senha',
    CONFIRM_NEW_PASSWORD_KEY: 'Confirme a nova senha',
    PASSWORD_NOT_MATCH_KEY: 'Senha não coincide',
    FORGOT_PASSWORD_KEY: 'Esqueci minha senha',
    EMAIL_INVALID_KEY: 'E-mail inválido',
    NUMBER_INVALID_KEY: 'Número inválido',
    REQUIRED_FIELD_KEY: 'Campo obrigatório!',
    NOT_HEX_FIELD_KEY: 'Esse valor não é válido, insira um valor hexadecimal',
    PASSWORD_MIN_LENGTH_OPERATOR_KEY: 'Digite no mínimo 8 caracteres',
    PASSWORD_MAX_LENGTH_OPERATOR_KEY: 'Digite no máximo 32 caracteres',
    LAST_ONE_CAPITAL_LETTER_KEY:
      'A senha precisa ter pelo menos uma letra maiúscula',
    MUST_CONTAIN_AT_LEST_ONE_NUMBER_KEY:
      'A senha deve conter pelo menos um número',
    MUST_CONTAIN_AT_LEST_ONE_SPECIAL_KEY:
      'A senha deve conter pelo menos um caractere especial',
    PASSWORD_MIN_LENGTH_KEY: 'Digite no mínimo 6 caracteres',
    PASSWORD_MAX_LENGTH_KEY: 'Digite no máximo 20 caracteres',
    ONLY_NUMBERS_KEY: 'Este campo só aceita números',
    ONLY_LETTERS_KEY: 'Este campo só aceita letras',
    EMAIL_NOTIFICATION_KEY: 'Deseja receber comunicações por este e-mail?',
    MIN_NUMBER_CANNOT_BE_LESS_THAN_ONE_KEY:
      'O número mínimo de dígitos não pode ser menor que 1',
    EMAIL_FICTITIOUS_KEY: 'E-mail fictício?',
    IS_INTEGRATION_USER_KEY: 'Usuário de integração?',
    DATE_GREATER_THAN_START_DATE_KEY:
      'A data deve ser maior que a data inicial',
    ENTER_YOUR_PASSWORD_BELOW_KEY: 'Informe sua senha abaixo',

    // Links
    PRIVACY_POLICY_KEY: 'Privacidade',
    CODE_OF_ETHICS_KEY: 'Ética e Conduta',

    // 404
    NOT_FOUND_PAGE: {
      TITLE_KEY: 'Página não encontrada',
      BUTTON_KEY: 'Voltar para a página principal',
    },

    // Login
    LOGIN_PAGE: {
      SUBTITLE_KEY: 'Entrar com e-mail e senha',
      DESCRIPTION_KEY: 'Sua jornada para a nuvem.',
    },
    INVALID_CREDENTIALS: 'E-mail ou senha do operador não coincidem!',
    CONFIGURE_MFA_KEY: 'Configure o seu código de autenticação MFA',
    INSERT_MFA_CODE_KEY: 'Insira o código de autenticação do seu MFA',
    AUTHENTICATION_CODE_KEY: 'Código de autenticação',
    INVALID_MFA_CODE: 'Código de autenticação inválido',

    // Reset password
    RESET_PASSWORD_PAGE: {
      TITLE_KEY: 'Esqueceu sua senha?',
      SUBTITLE_KEY: 'Digite o seu e-mail para iniciar a recuperação.',
      DESCRIPTION_KEY:
        'Digite seu e-mail e clique em Recuperar para receber um e-mail de recadastro de senha.',
    },

    // Register password
    REGISTER_PASSWORD_PAGE: {
      TITLE_KEY: 'Digite a sua nova senha',
      SUBTITLE_KEY:
        'Senhas de pelo menos 10 caracteres, com números e caracteres especiais.',
      DESCRIPTION_KEY:
        'Cadastre ao lado sua nova senha. Utilize letras, números e caracteres especiais para aumentar a segurança.',
    },

    // Partners
    ADD_PARTNER_KEY: 'Adicionar conta',
    PARTNER_NAME_KEY: 'Nome da conta',
    OPERATOR_VIEW_PARTNER_NAME_KEY: 'Conta',
    PARTNER_LANGUAGE_KEY: 'Idioma da conta',
    ALIAS_KEY: 'Alias',
    LDAP_TOOLTIP_KEY:
      'Aqui devem ser incluídas as configurações para acessar o AD',
    NOT_USE_AT_SIGN_KEY: "Não é necessário adicionar '@' neste campo",
    LDAP_EXTERNAL_KEY: 'LDAP externo',
    CLOUD_KEY: 'Cloud',
    USE_FRONT_KEY: 'Usar o front novo',
    PARTNER_BLOCKED_SUCCESSFULLY_KEY: 'Conta bloqueada com sucesso!',
    PARTNER_UNBLOCKED_SUCCESSFULLY_KEY: 'Conta desbloqueada com sucesso!',
    SUCCESS_PARTNER_EDIT_KEY: 'Conta editada com sucesso!',
    NO_PARTNER_KEY: 'Nenhuma conta encontrado!',

    PARTNER_PAGE: {
      NOT_EQUAL_COLOR_MAIN_KEY: 'Essa cor não pode ser igual a cor primária',
      PUBLIC_CUSTOM_KEY: 'Publicar customizações',
      PUBLIC_CUSTOM_MSG_KEY: 'Deseja publicar a customização?',
      CUSTOM_STATUS_NOT_DEFINE_KEY: 'Não definido',
      CUSTOM_STATUS_PUBLICATION_KEY: 'Status da publicação de customização',
      HAS_DRAFT_KEY: 'Você possui um rascunho salvo',
      SAVE_DRAFT_TITLE_KEY: 'Salvar rascunho',
      SAVE_DRAFT_DESCRIPTION_KEY:
        'O rascunho permite que você salve sua edição, para poder voltar mais tarde',
      MANUAL_COLORS_KEY: 'Manual de edição das cores',
      FIRST_COLOR_TITLE_KEY: '1. A cor principal do texto: ',
      SECOND_COLOR_TITLE_KEY: '2. A cor primária: ',
      THIRD_COLOR_TITLE_KEY: '3. A cor dos botões de login: ',
      FOUR_COLOR_TITLE_KEY: '4. As cores do banner de login: ',
      FIVE_COLOR_TITLE_KEY: '5. As cores do texto das mensagens: ',
      SIX_COLOR_TITLE_KEY: '6. As cores do texto ao passar o mouse: ',
      FIRST_COLOR_KEY:
        'Altera a cor dos títulos dos cards da listagem de ambientes no dashboard.',
      SECOND_COLOR_KEY:
        'É a principal responsável pela identidade visual. Altera as cores dos títulos, fundos de imagens, entre outras.',
      THIRD_COLOR_KEY:
        'Altera a cor de fundo dos botões de login, MFA e recuperação de senha.',
      FOUR_COLOR_KEY:
        'Altera a cor de fundo dos banners principais das telas de login, MFA e recuperação de senha.',
      FIVE_COLOR_KEY:
        'Altera as cores do texto das mensagens de aviso do sistema.',
      SIX_COLOR_KEY:
        'Altera a cor do título dos cards na listagem de ambientes ao passar o mouse.',
      CUSTOM_FRONT_PARTNER: 'Customizar front da conta',
      CUSTOM_FRONT_PARTNER_NAME: 'Customizar front da conta - {{name}}',
      LOGO_PARTNER_KEY: 'Logo da conta (L: 150 x A: 101)',
      IMAGE_LOGIN_BANNER_KEY: 'Banner de login (L: 630 x A: 960)',
      COLORS_BANNER_IMAGE_HELP_TEXT_KEY:
        'Cor de sobreposição da imagem de login',
      BACKGROUND_IMAGE_HELP_TEXT_KEY: 'Imagem de fundo da tela de login',
      MESSAGES_IMAGE_HELP_TEXT_KEY:
        'Imagem de fundo das telas de avisos e mensagens',
      TEXT_HOVER_COLOR_HELP_TEXT_KEY:
        'Cor do texto ao passar o mouse sobre os ambientes',
      USE_EXAMPLE_KEY: 'Exemplo de uso',
      RESET_IMAGES_KEY: 'Redefinir imagens',
      TEXT_PRINCIPAL_COLOR: 'Cor principal do texto',
      PRIMARY_COLOR_KEY: 'Cor primária',
      PARTNER_DELETED_KEY: 'Conta excluída com sucesso!',
      LOGIN_BUTTONS_COLORS_KEY: 'Cor dos botões de login',
      COLORS_BANNER_IMAGE: 'Cores do banner de login',
      MSG_COLORS_KEY: 'Cores do texto das mensagens',
      COLOR_HOVER_TEXT_KEY: 'Cores do texto ao passar o mouse',
      TITLE_KEY: 'Título',
      LOGIN_FONT_SIZE_KEY: 'Tamanho da fonte do login',
      DESCRIPTION_FONT_SIZE_KEY: 'Tamanho da fonte da descrição',
      CONNECT_TEXT_TITLE_KEY: 'Teste de conexão: Active Directory',
      CONNECT_TEXT_MSG_KEY: 'Conectado com sucesso!',
      EDIT_COMPANY_WARNING: 'Edição de companhia',
      CHANGE_COMPANY_KEY: 'As alterações serão aplicadas na companhia {{name}}',
      ADD_NEW_PARTNER_KEY: 'Adicionar conta',
      LDAP_SUCCESS_KEY: 'LDAP salvo com sucesso!',
      SEARCH_PARTNER_KEY: 'Digite o nome da conta',
      INIT_INCLUSION_PARTNER_KEY: 'Preencha os dados para incluir a conta',
      LIST_PARTNER_KEY: 'Lista de contas',
      LIST_PARTNER_AVAILABLE_KEY: 'Relação de contas disponíveis para consulta',
      EDIT_PARTNER_KEY: 'Editar conta',
      EDIT_BLOCK_KEY: 'Bloquear conta',
      EDIT_UNBLOCK_KEY: 'Desbloquear conta',
      REMOVE_PARTNER_KEY: 'Excluir conta',
      REMOVE_PARTNER_DESCRIPTION_KEY: 'A conta {{name}} será excluída.',
      NONE_PARTNER_KEY: 'Nenhuma conta encontrada.',
      REMOVE_PARTNER_QUESTION_KEY: 'Deseja excluir a conta {{name}}?',
      CLOUD_PROVIDER_PARTNER_KEY: 'Selecione o provedor de nuvem da conta',
      SELECT_LDAP_PARTNER_KEY: 'Selecione o tipo de LDAP da conta',
      SELECT_INTERFACE_USE_PARTNER_KEY: 'Selecione a interface de utilização',
      USER_NEW_FRONT_KEY: 'Utilizar nova interface?',
      CUSTOMER_EMAIL_KEY: 'Utilizar e-mail customizado?',
      CUSTOMER_PLUGIN_KEY: 'Utilizar plugin customizado?',
      TEMPLATE_EMAIL_PARTNER_KEY: 'Template de e-mail',
      TEMPLATE_AVAILABLE_PARTNER_KEY: 'Deseja habilitar este template?',
      SELECT_TEMPLATE_PARTNER_KEY: 'Escolha o template',
      SUBJECT_EMAIL_PARTNER_KEY: 'Assunto do e-mail',
      ADD_NEW_PARTNER_QUESTION_KEY:
        'Você deseja criar a conta {{name}} na companhia {{company}}?',
      EDIT_PARTNER_QUESTION_KEY:
        'Você deseja editar a conta {{name}} na companhia {{company}}?',
      EDIT_PARTNER_DATA_KEY: 'Preencha os dados para editar a conta',
      USE_NEW_FRONT_KEY: 'Usar front novo',
      NEW_FRONT_CONFIGURATION_KEY: 'Configuração do Portal 2.0',
      ENABLE_NEW_FRONT_KEY: 'Habilitar Portal 2.0',
      ENABLE_NEW_FRONT_MIGRATION_KEY: 'Habilitar migração para o Portal 2.0',
      ENABLE_NEW_FRONT_MIGRATION_CONFIRMATION_KEY:
        'Ao habilitar a migração para o Portal 2.0, a migração será automaticamente considerada concluída se todos os usuários acessarem o novo portal antes da data de migração. Deseja continuar?',
      NEW_FRONT_MIGRATION_DEADLINE_KEY: 'Data da migração',
      ENABLE_NEW_FRONT_EXPLANATION_KEY:
        'Ao ativar essa opção, os usuários desta conta serão redirecionados exclusivamente para o Portal 2.0.',
      ENABLE_NEW_FRONT_MIGRATION_EXPLANATION_KEY:
        'Agende a ativação do Portal 2.0 para esta conta, notificando os usuários sobre a migração e oferecendo acesso à nova plataforma. Se todos os usuários acessarem o Portal 2.0 antes da data final, a migração será considerada concluída.',
      NEW_FRONT_MIGRATION_DEADLINE_EXPLANATION_KEY:
        'Data final da migração, após essa data a migração será considerada concluída.',
      OPERATOR_VIEW_NEW_FRONT_KEY: 'Front novo',

      BLOCK_PARTNER_TITLE_KEY: 'Deseja bloquear a conta?',
      BLOCK_PARTNER_DESCRIPTION_KEY: 'A conta {{name}} será bloqueada.',
      UNBLOCK_PARTNER_TITLE_KEY: 'Deseja desbloquear a conta?',
      UNBLOCK_PARTNER_DESCRIPTION_KEY: 'A conta {{name}} será desbloqueada.',
      MAINTENANCE_MESSAGES_KEY: 'Aviso de manutenção (L: 1382 x A: 596)',
      MESSAGE_IMAGES_KEY: 'Mensagem (L: 1382 x A: 596)',
      FAVICON_KEY: 'Favicon (64 x 64)',
      DRAG_AND_DROP_KEY:
        'Arraste e solte uma imagem aqui ou clique para selecionar',
      HIGHLIGHT_COLOR_KEY: 'Cor de destaque principal',
      ENVIRONMENT_TITLE_COLOR_KEY: 'Cor do título dos ambientes',
      MESSAGES_BUTTON_COLOR_KEY: 'Cor do botão da tela de mensagem',
      MESSAGES_BUTTON_COLOR_HOVER_KEY:
        'Cor do botão da tela de mensagem ao passar o mouse',
      SUCCESS_SAVE_KEY: 'Configurações salvas com sucesso',
      SUCCESS_PUBLISH_KEY: 'Publicação realizada com sucesso',

      SSO_DEACTIVATED_TOGGLE: 'Permite configurar SSO',
      DUO_DEACTIVATED_TOGGLE: 'Permite configurar DUO',
      SSO_KEY: 'SSO',
      DUO_KEY: 'DUO',
      SUCCESS_CREATE_ACCOUNT: 'Conta cadastrada com sucesso!',
      SUBDOMAIN_KEY: 'Subdomínio',
      USE_CUSTOM_THEME_KEY:
        'Para utilizar esta função é necessário ter um alias único cadastrado',
      DELETE_CUSTOM_BUTTON_KEY: 'Excluir customização',
      DELETE_CUSTOM_SUBTEXT_KEY:
        'Ao confirmar a exclusão, todos os dados da customização serão excluídos: endereço customizado da página, subdomínio, título, cores, imagens e tamanhos de fonte.',
      DELETE_CUSTOM_TEXT_KEY:
        'Para confirmar a exclusão, digite sua senha de operador no campo abaixo:',
      DELETE_CUSTOM_MODAL_TITLE_KEY: 'Excluir customização de {{name}}',
      DELETE_CUSTOM_SUCCESS_KEY: 'Customização excluída com sucesso!',
      LOGO_BACKGROUND_COLOR_KEY: 'Cor de fundo do logo',
      NO_TEXT_KEY: 'Sem texto',
      CLONE_PARTNER_KEY: 'Clonar conta',
      CLONE_PARTNER_NAME_KEY: 'Nome da nova conta',
      CLONE_PARTNER_OBSERVATION_KEY:
        'Ao clonar uma conta, apenas as configurações são copiadas. Ambientes, clientes, usuários, customização de front-end e configuração de alias não são replicados na conta clonada.',
      CHANGE_AD_PASSWORD_KEY: 'Trocar senha do usuário AD',
      CHANGE_DUO_CLIENT_SECRET_KEY: 'Trocar Client Secret',
      CHANGE_AD_PASSWORD_CONFIRMATION_KEY:
        'Para confirmar a troca da senha, informe nos campos abaixo o motivo da ação e a sua senha',
      NEW_AD_PASSWORD_LABEL_FIELD_KEY: 'Informe a nova senha do usuário AD',
      ADMIN_BIND_PASS_KEY: 'Senha do usuário AD',
      ADMIN_DN_KEY: 'Usuário AD',
      AD_DOMAIN_KEY: 'Domínio usuário AD',
    },

    // Environments
    ENVIRONMENT_NAME_KEY: 'Nome do ambiente',
    OPERATOR_VIEW_ENVIRONMENT_NAME_KEY: 'Ambiente',
    ENVIRONMENT_ID_KEY: 'ID do ambiente',
    PROJECT_ID_SKY_KEY: 'ID do projeto Easy.Sky',
    REGION_KEY: 'Região',
    COMPARTMENT_ID_KEY: 'ID do compartimento',
    MODE_KEY: 'Modo',
    LICENSES_KEY: 'Licenças',
    ACTIVE_BEHAVIOR_KEY: 'Ativos',
    STOPPED_BEHAVIOR_KEY: 'Parados',
    ON_DEMAND_BEHAVIOR_KEY: 'Sob demanda',
    PARTNER_KEY: 'Conta',
    MARGIN_KEY: 'Margem',
    MARGIN_PERCENT_KEY: 'Margem (porcentagem)',
    PROVIDER_CLOUD_KEY: 'Provedor cloud',
    MODEL_TOOLTIP_KEY: 'Configuração principal utilizada pelas instâncias.',
    MODEL_TOOLTIP_BACKUP_KEY:
      'Configuração alternativa, utilizada quando há problemas para conseguir alocar máquinas do Modelo primário.',
    MODEL_TOOLTIP_SPOT_KEY:
      'Configuração utilizada pelas máquinas do tipo SPOT do provedor Amazon Web Services.',
    PROVIDER_CLOUD_TOOLTIP_KEY:
      'Estas opções definem quais configurações serão aplicadas em instâncias ativadas por meio do auto-scaling, como flavors, zonas de disponibilidades, AMI, entre outros.',
    CONNECTION_TYPE_TOOLTIP: 'Tipo de conexão do provedor pública / privada',
    ZONE_DEFAULT_TOOLTIP: 'Zona padrão do servidor',
    PUBLICATIONS_KEY: 'Publicações',
    PUBLICATION_ALREADY_IN_PROGRESS:
      'Já existe uma publicação de imagem em andamento.',
    TOGGLE_BLOCK_UNBLOCK_INSTANCE_KEY: 'Bloquear / desbloquear instâncias',
    TOGGLE_BLOCK_UNBLOCK_INSTANCE_MSG_KEY:
      'As instâncias selecionadas serão bloqueadas / desbloqueadas',
    SCHEDULE_PUBLICATIONS_KEY:
      'Agendamento de bloqueio de instâncias com versões antigas de modelo',
    SCHEDULE_PUBLICATIONS_TOOLTIP_KEY:
      'O agendamento afetará apenas as instâncias com versões antigas de modelo, não impactando as instâncias com versões atuais de modelo.',
    PERCENTAGE_SPOT_KEY: 'Porcentagem SPOT',
    TOTAL_LICENSES_KEY: 'Total de licenças',
    FAST_DETAILS_KEY: 'Detalhes rápidos',
    REMOVE_ENVIRONMENT_KEY: 'Excluir ambiente',
    ADD_MODEL_KEY: 'Adicionar modelo',
    REMOVE_MODELS_SELECTED_KEY: 'Excluir modelos selecionados',
    BASE_NAME_KEY: 'Nome base',
    BACKUP_SECONDARY_KEY: 'Secundário',
    MODEL_PRIMARY_KEY: 'Primário',
    VERSION_KEY: 'Versão',
    ACTIVE_INSTANCES_KEY: 'Instâncias ativas',
    CONNECTED_USERS_KEY: 'Usuários conectados',
    CREATE_MODEL_KEY: 'Criar modelo',
    EDIT_MODEL_KEY: 'Editar modelo',
    SECURITY_TAGS_KEY: 'Tags de segurança',
    TEMPERATURE_REFERENCE_KEY: 'Temperatura de referência',
    KEY_PAIR_KEY: 'Key pair',
    SECURITY_GROUP_KEY: 'Grupo de segurança',
    CREDIT_SPECIFICATIONS_KEY: 'Especificações de crédito',
    MEMORY_MAX_KEY: 'Máximo de memória',
    CPU_MAX_KEY: 'Máximo de CPU',
    CONNECTION_MAX_KEY: 'Máximo de conexões',
    EMPTY_KEY: 'Vazio',
    TURNED_OFF_KEY: 'Desligada',
    OFF_KEY: 'Desligado',
    OPERATIONAL_KEY: 'Operacional',
    TOP_KEY: 'Topo',
    BOOT_TIME_KEY: 'Tempo de boot',
    ACTIVE_INSTANCE_KEY: 'Ativar instância',
    REGISTER_INSTANCE_KEY: 'Registrar instância',
    TERMINATE_INSTANCE_KEY: 'Terminar instância',
    REMOVE_INSTANCE_KEY: 'Excluir instância',
    BLOCK_INSTANCE_KEY: 'Bloquear instância',
    UNBLOCK_INSTANCE_KEY: 'Desbloquear instância',
    PUBLIC_IP_KEY: 'IP público',
    PRIVATE_IP_KEY: 'IP privado',
    MONITOR_KEY: 'Monitor',
    ALARMS_LOGS_KEY: 'Alarmes / logs',
    ALARMS_KEY: 'Alarmes',
    SEARCH_INSTANCE_KEY: 'Pesquisar instância',
    REMOVE_SESSION_KEY: 'Excluir sessão',
    FINISH_SESSION_KEY: 'Encerrar sessão',

    MANUAL_KEY: 'Manual',
    TYPE_MANUAL_KEY: 'Manual - Descontinuado',
    TYPE_ROBOT_PERIOD_KEY: 'Robô - Períodos - Descontinuado',
    TYPE_ROBOT_PERIOD_SPOT_KEY: 'Robô - Períodos (Spot) - Descontinuado',
    TYPE_ROBOT_MICRO_KEY: 'Robô - Micro - Descontinuado',
    TYPE_DEDICATED_KEY: 'Dedicado',
    TYPE_SHARED_KEY: 'Compartilhado',
    TYPE_HAAS_KEY: 'HaaS - Descontinuado',
    TYPE_CCC_KEY: 'CCC - Descontinuado',
    MICRO_KEY: 'Micro',
    SPOT_KEY: 'Spot',
    MODEL_BACKUP_KEY: 'Modelo secundário',
    MODEL_SPORT_KEY: 'Modelo spot',
    PRIMARY_ZONE_KEY: 'Zona primária',
    SECONDARY_ZONE_KEY: 'Zona secundária',
    ZONE_DEFAULT_KEY: 'Zona padrão',
    REGION_DEFAULT_KEY: 'Região padrão',
    CONNECTION_TYPE_KEY: 'Tipo de conexão',
    FILE_KEY: 'Arquivo',
    QUALITY_KEY: 'Qualidade',
    HIGH_KEY: 'Alta',
    DEFAULT_KEY: 'Padrão',
    LOW_KEY: 'Baixa',
    ACCESS_PUBLIC_KEY: 'Acesso público (via IP público através da internet)',
    PRIVATE_PUBLIC_KEY:
      'Acesso privado (via IP privado através de uma VPN ou conexão privada)',

    USERS_ADMIN_KEY: 'Usuários administrativos',
    STATE_OPERATIONAL_KEY: 'Estado operacional',
    AVERAGE_MEMORY_USAGE_KEY: 'Uso médio de memória',
    AVERAGE_CPU_USAGE_KEY: 'Uso médio de CPU',
    AVERAGE_DISK_USAGE_KEY: 'Utilização média de disco',
    TOTAL_INSTANCES_KEY: 'Total de instâncias',
    TOTAL_LICENSES_USAGE_KEY: 'Licenças em uso',
    TOTAL_SESSIONS_KEY: 'Total de sessões',
    TOTAL_LICENSES_CONTRACT_KEY: 'Licenças contratadas',
    LICENSES_AVAILABLE_KEY: 'Licenças disponíveis',
    IMAGE_PUBLICATION_TYPE_KEY: 'Tipo de publicação de imagem',
    MAX_PUBLICATIONS_KEY: 'Limite de publicações mensal',
    MAX_DAILY_PUBLICATIONS_KEY: 'Limite de publicações diário',
    TOTAL_PUBLICATIONS_KEY: 'Quantidade de publicações mensais já efetuadas',
    TOTAL_DAILY_PUBLICATIONS_KEY:
      'Quantidade de publicações diárias já efetuadas',
    PUBLICATIONS_OLD_INSTANCES_KEY:
      'Bloquear instâncias com versões antigas de modelo?',
    BLOCK_TIME_KEY: 'Horário de bloqueio',
    REGISTER_THROUGH_KEY: 'Cadastro através de',
    REGISTER_MODE_KEY: 'Modo de cadastro',
    BEHAVIOR_KEY: 'Comportamento',
    PRODUCT_TYPE_KEY: 'Tipo do ambiente',
    ADVANCED_KEY: 'Avançado',
    SECURITY_KEY: 'Segurança',
    SCHEDULER_KEY: 'Agendador',
    GOVERNANCE_KEY: 'Governança',

    ADD_SERVER_PREPARATION_KEY: 'Adicionar servidor de preparação',
    ADD_SERVER_PREPARATION_SUBTITLE_KEY:
      'Insira os dados da instância para adicioná-la como servidor de preparação do ambiente {{environment}}.',
    ADD_SERVER_SUPPORT_KEY: 'Adicionar servidor de suporte',
    ADD_SERVER_SUPPORT_SUBTITLE_KEY:
      'Insira os dados da instância para adicioná-la como servidor de suporte do ambiente {{environment}}.',
    REMOVE_SERVER_SELECTED_KEY: 'Desvincular servidores selecionados',
    START_INSTANCE_KEY: 'Iniciar instância',
    INSTANCE_NAME_KEY: 'Nome da instância',
    INSTANCE_ID_KEY: 'ID da instância',
    SCHEDULED_STOP_KEY: 'Parada programada',
    SCHEDULED_STOP_DATETIME_KEY: 'Data e horário de parada',
    CANCEL_SCHEDULED_STOP_KEY: 'Cancelar parada programada',
    DISABLE_SCHEDULED_STOP_KEY: 'Desabilitar parada programada',
    EXTEND_EXECUTION_KEY: 'Prorrogar execução',
    INTERVAL_TIME_KEY: 'Intervalo de tempo',
    GENERATE_IMAGES_STOP_KEY: 'Gerar imagens sem parar a instância?',
    NEW_SCHEDULED_STOP_DATETIME_KEY: 'Novo data e horário de parada',
    NEW_SCHEDULED_STOP_KEY: 'Novo horário de parada',
    NEW_SCHEDULED_STOP_SUBTITLE_KEY: 'Adicione uma nova parada programada',
    SCHEDULED_BLOCK_INSTANCES_KEY: 'Agendar bloqueio de instâncias',

    DATA_REFERENCE_LAST_TIME_KEY: 'Dados referente à última hora',
    TOTAL_SESSIONS_ACTIVE_KEY: 'Sessões ativas',
    NUMBER_NEW_ACCESSES_KEY: 'Número de novos acessos',
    TOTAL_VACANCIES_KEY: 'Total de vagas',

    WANT_START_SERVER_KEY: 'Deseja iniciar o servidor?',
    WANT_STOP_SERVER_KEY: 'Deseja parar o servidor?',

    WANT_TERMINATE_INSTANCE_KEY: 'Deseja terminar a instância?',
    WANT_REMOVE_INSTANCE_KEY: 'Deseja excluir a instância?',
    WANT_TERMINATE_INSTANCE_DESCRIPTION_KEY:
      'A instância {{name}} será terminada, isso pode levar alguns minutos',

    WANT_START_INSTANCE_KEY: 'Deseja iniciar a instância?',
    WANT_START_INSTANCE_DESCRIPTION_KEY:
      'A instância I-0000 será iniciada, isso pode levar alguns minutos',
    WANT_REBOOT_INSTANCE_KEY: 'Deseja reiniciar instância?',
    WANT_REBOOT_SERVER_KEY: 'Deseja reiniciar servidor?',
    WANT_STOP_INSTANCE_KEY: 'Deseja parar a instância?',
    WANT_REBOOT_INSTANCE_DESCRIPTION_KEY:
      'A instância {{name}} será reiniciada, isso pode levar alguns minutos',

    WANT_DELETE_MODEL_KEY: 'Deseja deletar o modelo?',
    WANT_DUPLICATE_MODEL_KEY: 'Deseja duplicar o modelo?',
    WANT_DELETE_MODEL_DESCRIPTION_KEY: 'O modelo {{name}} será deletado',
    WANT_LOGOUT_SESSION_KEY: 'Deseja finalizar a sessão?',
    MODEL_SUCCESSFULLY_REMOVED_KEY: 'Modelo excluído com sucesso!',
    MODEL_SUCCESSFULLY_REGISTERED_KEY: 'Modelo adicionado com sucesso!',
    MODEL_SUCCESSFULLY_EDITED_KEY: 'Modelo editado com sucesso!',

    ADD_MESSAGE_MAINTENANCE_KEY: 'Adicionar mensagem de manutenção',
    ADD_MESSAGE_REMOVE_SESSION_KEY: 'Adicionar mensagem de remoção',
    START_ALERT_KEY: 'Iniciar manutenção',
    END_ALERT_KEY: 'Terminar manutenção',
    MANUAL_MAINTENANCE_KEY: 'Manutenção manual',
    TERMINATE_INSTANCES_KEY: 'Terminar instâncias',
    TERMINATE_SESSIONS_KEY: 'Terminar sessões',
    START_ENVIRONMENT_AT_KEY: 'Iniciar ambiente às',
    SCALING_KEY: 'Scaling',
    SERVER_SUP_KEY: 'Servidor SUP',
    PERCENTAGE_KEY: 'Porcentagem',
    TURNED_ON_KEY: 'Ligado',
    SUPPORT_SERVER_KEY: 'Servidor de suporte',
    STATUS_ENVIRONMENT_KEY: 'Status do ambiente',
    DISPLAY_TO_LOGGED_USERS_KEY: 'Exibir aviso para usuários logados',

    GOVERNANCE_INFORMATION_KEY: 'Governança de dados',
    PROJECT_CODE_KEY: 'Código do projeto (Zoho Projects)',
    PROJECT_TYPE_KEY: 'Tipo de projeto',
    PRODUCTION_KEY: 'Produção',
    DEVELOPMENT_KEY: 'Desenvolvimento',
    DEPARTMENT_KEY: 'Departamento',
    IMPLEMENTATION_KEY: 'Implementação',
    OPERATION_KEY: 'Operação',
    RESPONSIBLE_TECHNICAL_KEY: 'Responsável técnico',
    TECHNICAL_PHONE_KEY: 'Celular do técnico',
    TECHNICAL_EMAIL_KEY: 'E-mail do técnico',
    TECHNICAL_EMAIL_PLACEHOLDER_KEY: 'exemplo@email.com',
    RESPONSIBLE_IMPLEMENTATION_KEY: 'Responsável pela implementação',
    CREATION_DATE_ENVIRONMENT_KEY: 'Data de criação do ambiente',
    DELIVERY_DATE_ENVIRONMENT_KEY: 'Data de entrega do ambiente',
    COMMENTS_KEY: 'Comentários',

    LICENSE_LIMIT_KEY: 'Limite de licenças',
    INTERFACE_KEY: 'Interface',
    SET_INTERFACE_KEY: 'Configurar interface',
    USE_NEW_FRONT_KEY: 'Utilizar interface nova',
    USE_OLD_FRONT_KEY: 'Utilizar interface antiga',
    USE_PARTNER_TENANCY_KEY: 'Utilizar tenancy da conta',
    USE_IOS_BY_DEFAULT_EXPLANATION_KEY:
      'Habilita o uso de dispositivos iOS somente para novos clientes',
    BLOCK_MULTIPLE_SESSIONS_EXPLANATION_KEY:
      'Com esta funcionalidade habilitada no ambiente serão bloqueadas tentativas de login com o mesmo usuário',
    UNIQUE_USER_SESSION_VALIDATION_EXPLANATION_KEY:
      'Com esta funcionalidade habilitada no ambiente, tentativas de acesso usando a mesma sessão do usuário serão bloqueadas.',
    USE_REMOTE_DNS_EXPLANATION_KEY:
      'Com esta funcionalidade habilitada será mascarado o IP público da instâncias do AutoSky, utilizando DNS',
    LICENSE_LIMIT_PER_CLIENT_EXPLANATION_KEY:
      'Com esta funcionalidade habilitada será permitido restringir o número máximo de licenças que cada cliente poderá utilizar',
    AUTO_INCREASE_LICENSES_EXPLANATION_KEY:
      'Com esta opção habilitada, a quantidade total de licenças será automaticamente incrementada de forma temporária com o valor abaixo ao atingir o limite de utilização (30 dias).',
    AUTO_INCREASE_LICENSES_KEY:
      'Aumentar automaticamente de forma temporária as licenças antes de chegar no limite',
    ALWAYS_ACTIVE_RESOURCE_KEY: 'Sempre manter este recurso ativado',
    ALWAYS_ACTIVE_RESOURCE_TOOLTIP_KEY:
      'Com esta opção selecionada, o recurso sempre se manterá ativo',
    INCREASE_LICENSES_BY_KEY: 'Aumentar limite de licenças em:',
    LICENSE_LIMIT_PER_CLIENT_KEY: 'Limitar licenças por cliente',
    USE_REMOTE_DNS_KEY: 'Utilizar DNS para conexão remota?',
    USE_ALLOW_CLIENT_CONNECTION_TYPE_KEY:
      'Permitir tipo de conexão por cliente?',
    USE_ALLOW_CLIENT_CONNECTION_TYPE_TOOLTIP_KEY:
      'Habilita o cliente a escolher seu próprio tipo de conexão com o provedor (pública ou privada)',
    BLOCK_MULTIPLE_SESSIONS_KEY: 'Bloquear múltiplas sessões do mesmo usuário?',
    UNIQUE_USER_SESSION_VALIDATION_KEY: 'Validação de sessão do usuário',
    USE_IOS_BY_DEFAULT_KEY:
      'Habilitar uso de dispositivos iOS para novos clientes',
    USE_IOS_DEVICES_KEY: 'Utilizar dispositivos iOS?',
    LICENSE_LIMIT_MAX_KEY:
      'Este limite deve ser inferior ao limite de licenças disponíveis',

    DEFINE_PERIODS_TITLE_KEY: 'Defina os períodos que deseja configurar',
    DEFINE_PERIODS_SUBTITLE_KEY: 'É obrigatório escolher uma das opções abaixo',
    DEFINE_PERIODS_SUBTITLE_ONE_KEY: 'Configure ao menos um dos períodos',
    IN_THE_WEEK_KEY: 'Durante a semana',
    ON_THE_SATURDAY_KEY: 'Aos sábados',
    ON_THE_SUNDAY_KEY: 'Aos domingos',
    ADD_COMMENT_TITLE_KEY: 'Adicionar comentário',
    ADD_COMMENT_SUBTITLE_KEY: 'Comentários sobre as configurações do ambiente',
    ADD_COMMENT_KEY: 'Adicione comentário',

    USE_SPECIFIC_PASSWORD_KEY: 'Utilizar configurações especificas de senha?',
    MINIMUM_PASSWORD_LENGTH_KEY: 'Quantidade mínima de caracteres da senha',
    REQUIRE_UPPERCASE_KEY: '● Exigida uma letra maiúscula',
    REQUIRE_LOWERCASE_KEY: '● Exigida uma letra minúscula',
    REQUIRE_NUMBER_KEY: '● Exigido um caractere numérico',
    REQUIRE_SPECIAL_CHARACTER_KEY: '● Exigido um caractere não-alfanumérico',
    EXPIRATION_PASSWORD_KEY: 'Habilitar expiração de senha?',
    EXPIRATION_PASSWORD_DAYS_KEY: 'Expirar senhas a cada (dias):',
    NUMBER_MAX_LOGIN_TRIES_KEY: 'Limite de tentativas de login',
    BEHAVIOR_MESSAGE_KEY: 'Configurações de comportamento salvas com sucesso!',

    FILL_THE_REQUIRED_FIELDS_KEY: 'Preencha os campos obrigatórios!',
    FILL_THE_CORRECTLY_FIELDS_KEY: 'Preencha os campos corretamente!',

    ENVIRONMENTS_SUCCESS_KEY: 'Ambiente excluído com sucesso!',
    ENVIRONMENT_SUCCESSFULLY_EDITED_KEY: 'Ambiente editado com sucesso!',
    ADD_ENVIRONMENT_KEY: 'Adicionar ambiente',
    NO_ENVIRONMENT_KEY: 'Nenhum ambiente encontrado!',

    ENVIRONMENTS_PAGE: {
      LIMIT_MSG_IMAGE_PUBLICATION_KEY:
        'Limite mensal atingido: Este ambiente atingiu o limite de publicações de imagens mensal com bloqueio de instâncias (mantendo usuários conectados). A publicação padrão continua disponível.',
      LIMIT_DAILY_MSG_IMAGE_PUBLICATION_KEY:
        'Limite diário atingido: Este ambiente atingiu o limite de publicações de imagens diário com bloqueio de instâncias (mantendo usuários conectados). A publicação padrão continua disponível.',
      BOTH_LIMIT_MSG_IMAGE_PUBLICATION_KEY:
        'Os limites diário e mensal foram atingidos: Este ambiente atingiu o limite de publicações de imagens diário e mensal com bloqueio de instâncias (mantendo usuários conectados). A publicação padrão continua disponível.',
      EXECUTED_MONTHLY_PUBLICATION_KEY: 'Publicações restantes (mensal)',
      EXECUTED_DAILY_PUBLICATION_KEY: 'Publicações restantes (diário)',
      ERROR_CONFIG_SERVER_KEY:
        'Erro de configuração: O seu ambiente não possui uma instância configurada como servidor de aplicação, isso irá impossibilitar o funcionamento do ambiente',
      LOGS_PUBLICATION_KEY: 'Logs de publicação',
      REMOVE_INSTANCES_WARNING_KEY:
        'As instâncias selecionadas serão excluídas',
      REMOVE_NOT_INSTANCES_WARNING_KEY:
        'Você não selecionou instâncias para terminar',
      TERMINATE_MULTIPLE_INSTANCES_MSG_KEY:
        'As instâncias selecionados serão terminadas',
      BLOCK_MULTIPLE_INSTANCES_MSG_KEY:
        'As instâncias selecionados serão bloqueadas',
      UNBLOCK_MULTIPLE_INSTANCES_MSG_KEY:
        'As instâncias selecionadas serão desbloqueadas',
      REMOVE_MULTIPLE_MODELS_KEY: 'Os modelos selecionados serão excluídos',
      REMOVE_MULTIPLE_MODELS_WARNING_KEY:
        'Você selecionou um modelo primário. Este item será mantido, os demais serão removidos.',
      LOADING_OPTION_KEY: 'Carregando {{optionName}}...',
      NOT_HAVE_OPTION_KEY: 'Não há {{optionName}} disponível',
      TURN_INTO_APPLICATION_SERVER_KEY: 'Transformar em servidor de aplicação',
      TURN_INTO_APPLICATION_SERVER_MSG_KEY:
        'O servidor de suporte {{instanceId}} será transformado em servidor de aplicação',
      ALARMS_INSTANCE_NOT_FOUND:
        'Não foram encontrados alarmes para essa instância',
      STOPPED_INSTANCE_KEY: 'Parada',
      ON_INSTANCE_KEY: 'Ligada',
      OPERATIONAL_INSTANCE_KEY: 'Operacional',
      BLOCKED_INSTANCE_KEY: 'Bloqueada',
      INACCESSIBLE_INSTANCE_KEY: 'Inacessível',
      STOPPING_INSTANCE_KEY: 'Parando',
      ENDING_INSTANCE_KEY: 'Terminando',
      INITIALIZING_INSTANCE_KEY: 'Inicializando',
      ACTIVATING_INSTANCE_KEY: 'Ativando',
      INCLUDE_INSTANCE_LIKE_SERVER_APPLICATION:
        'Incluir instância como servidor de aplicação?',
      SEARCH_FOR_LOGS: 'Pesquisar por logs',
      NOT_STOP_TIME_KEY: 'Servidor sem parada programada definida',
      MODEL_SUCCESSFULLY_DUPLICATE_KEY: 'Modelo duplicado com sucesso!',
      PUBLICATION_IDENTIFICATION: 'Identificação de publicação',
      PUBLICATION_IMAGE_INIT_KEY: 'Publicação de imagens iniciada',
      TYPE_PUBLICATION_KEY: 'Tipo de publicação',
      WANT_EXTEND_SERVER_KEY: 'Deseja prorrogar a execução do servidor?',
      WANT_EXTEND_SERVER_MSG_KEY:
        'Seu servidor será prorrogado por mais 2 horas a partir da hora agendada, ou, caso não haja agendamento, a partir da hora atual.',
      CREATE_BOOT_VOLUME: ' Criando boot volume',
      CHECK_BOOT_VOLUME: 'Verificando boot volume',
      CREATE_AMI: 'Criando imagem',
      CHECK_AMI: 'Verificando imagem',
      REPLACE_INSTANCES: 'Calculando demandas',
      BLOCK_OLD_INSTANCES: 'Bloqueando instâncias',
      SEND_MAIL_TASK: 'Enviando e-mail',
      WARN_USERS_AND_BLOCK_INSTANCES:
        'Avisando usuários e bloqueando instâncias',
      CHECK_FIRST_OPERATIONAL_INSTANCE:
        'Verificando operacionalização da instância',
      CHECK_IF_TEMPLATE_SERVER_IS_STOPPED:
        'Verificando se instância de template está parada',
      START_MULTIPLE_NEW_INSTANCES: 'Iniciando novas instâncias',
      CHECK_MULTIPLE_INSTANCES_RESULT: 'Checando inicio de novas instâncias',
      KEEPUSERSCONNECTED: 'Manter usuários conectados',
      REQUESTING_USER_RECONNECTION_KEY: 'Solicitando reconexão dos usuários',
      STANDARD_KEY: 'Padrão',
      WANT_CREATE_ENVIRONMENTS_KEY: 'Deseja criar este ambiente?',
      LOGS_IMAGE_BACK_KEY: 'Voltar para lista de imagens',
      TIME_DISCONNECT_KEY: 'Tempo de desconexão dos usuários em minutos',
      USER_MSG_IMAGE_KEY: 'Mensagem ao usuário',
      EMAIL_NOTIFICATION_IMAGE_KEY: 'E-mail do aviso de notificação',
      YOUR_NAME_KEY: 'Seu nome',
      PUBLICATIONS_NEW_VERSION_KEY: 'Publicar nova versão',
      PUBLICATIONS_KEY: 'Publicar',
      IMAGE_NOT_FOUND: 'Nenhuma imagem encontrada',
      NEW_PUBLICATION: 'Nova publicação registrada com sucesso!',
      DO_NOT_EXIST_SERVER_PREPARATION_KEY:
        'Não existem servidores de preparação',
      START_KEY_SUPPORT_INSTANCE: ' Iniciar instância',
      KEEP_USERS_CONNECTED_KEY: 'Manter usuários conectados',
      REQUEST_USER_FEATURE_KEY: 'Solicitar reconexão de usuários',
      SCHEDULE_PUBLISH_KEY: 'Agendamento de publicação',
      PUBLICATION_SERVER_IMAGE_KEY:
        'Selecione um servidor para publicar uma nova imagem',
      CONFIRM_PUBLICATION_NEW_VERSION_KEY:
        'Clique em confirmar para publicar uma nova versão',
      KEEP_USER_LOG_MSG_KEY:
        'Este procedimento irá publicar uma nova versão da camada de cliente (acesso dos usuários) no AutoScaling da plataforma',
      REQUEST_USER_FEATURE_MSG: {
        TITLE_REQUEST_KEY:
          'Este procedimento irá publicar uma nova versão da camada de aplicação (acesso dos usuários) no AutoScaling da plataforma. Assim que a nova versão estiver disponível para acesso, a plataforma Autosky irá solicitar que todos os usuários conectados fechem suas sessões remotas e acessem novamente a plataforma para usar a nova versão publicada.',
        SUBTITLE_REQUEST_KEY:
          'Indicamos que este procedimento seja realizado somente em casos de atualizações críticas dos sistemas, em que todos os usuários necessitem obrigatoriamente acessar a nova versão publicada. Você poderá realizar este procedimento somente algumas vezes ao mês dentro dos limites de seu ambiente.',
      },
      START_SERVER_KEY: 'Iniciar servidor',
      STOP_SERVER_KEY: 'Parar servidor',
      CREATE_ENVIRONMENT_KEY: 'Criar ambiente',
      CREATE_ENVIRONMENT_SUBTITLE_KEY: {
        COMPANY_NAME_SUBTITLE_KEY: 'Criação para',
      },
      DETACH_SERVER_KEY: 'Deseja desvincular servidor?',
      DETACH_SERVER_MSG_KEY:
        'O servidor {{environment}} será desvinculado, tem certeza?',
      START_SERVER_MSG_KEY:
        'O servidor {{environment}} será iniciado, isso pode levar alguns minutos',
      STOP_SERVER_MSG_KEY:
        'O servidor {{environment}} será parado, isso pode levar alguns minutos',
      RESTART_SERVER_MSG_KEY:
        'O servidor {{environment}} será reiniciado, isso pode levar alguns minutos',
      LIST_ENVIRONMENTS_TITLE_KEY: 'Lista de ambientes',
      LIST_ENVIRONMENTS_SUBTITLE_KEY: 'Relação de ambientes disponíveis',
      NO_ENVIRONMENT_KEY: 'Nenhum ambiente encontrado.',

      LIST_INSTANCES_TITLE_KEY: 'Lista de instâncias',
      LIST_INSTANCES_SUBTITLE_KEY:
        'Visualize as informações e realize operações',
      LIST_SESSIONS_TITLE_KEY: 'Lista de sessões',
      LIST_SESSIONS_SUBTITLE_KEY:
        'Visualize as informações e realize operações',
      NO_INSTANCE_KEY: 'Nenhuma instância encontrada.',
      WISH_UNLINK_INSTANCE_KEY: 'Deseja desvincular instância?',

      WANT_BLOCK_INSTANCE_KEY: 'Deseja bloquear instância?',
      WANT_UNBLOCK_INSTANCE_KEY: 'Deseja desbloquear instância?',

      LIST_SERVERS_TITLE_KEY: 'Servidores',
      LIST_SERVERS_SUBTITLE_KEY:
        'Selecione um servidor para visualizar seus detalhes:',
      UNLINK_WARNING_KEY: 'A instância {{instance}} será desvinculada',
      BLOCK_INSTANCE_WARNING_KEY: 'A instância {{instance}} será bloqueada',
      UNBLOCK_INSTANCE_WARNING_KEY:
        'A instância {{instance}} será desbloqueada',
      LIST_MODELS_TITLE_KEY: 'Modelos',
      DUPLICATE_NAME_KEY: 'Nome do modelo',
      LIST_MODELS_SUBTITLE_KEY:
        'Configure os modelos a serem utilizados no ambiente',
      NO_MODEL_KEY: 'Nenhum modelo encontrado.',

      LIST_LOGS_TITLE_KEY: 'Logs',
      LIST_LOGS_SUBTITLE_KEY:
        'Visualize as informações do ambiente a partir dos filtros abaixo',
      NO_LOG_KEY: 'Nenhum log encontrado.',
      NO_LOG_INSTANCE_KEY: 'Não foram encontrados logs para a instância.',

      GENERAL_VISION_TITLE_KEY: 'Visão geral',
      GENERAL_VISION_SUBTITLE_KEY: 'Visão rápida das informações dos ambientes',

      DASHBOARD_TITLE_KEY: 'Dashboard',

      MAINTENANCE_TITLE_KEY: 'Configurações de manutenção',
      MAINTENANCE_SUBTITLE_KEY:
        'Defina as configurações de manutenção do ambiente',

      WANT_REMOVE_SHUTDOWN_TITLE_KEY: 'Deseja excluir parada programada?',
      WANT_REMOVE_SHUTDOWN_MSG_KEY:
        'A instância está programada para ser desligada em',

      WANT_SCHEDULE_NEW_STOP_TIME_MSG_KEY:
        'A instância será programada para ser desligada em {{time}}.',

      CONFIGURATION_TITLE_KEY: 'Configurações',
      CONFIGURATION_SUBTITLE_KEY: '> Edição de configurações',

      BEHAVIOR_TITLE_KEY: 'Modo de comportamento do ambiente',
      BEHAVIOR_SUBTITLE_KEY: 'Defina o modo de comportamento do ambiente',

      SECURITY_DEFAULTS_SUCCESS_KEY:
        'Padrões de segurança alterados com sucesso!',

      ZERO_TRUST_NEW_FRONTEND_KEY:
        'Zero Trust não pode ser ativado até que a conta utilize o novo frontend',
      INVALID_IP_KEY: 'IP inválido inserido na Allow List',

      NEW_GOVERNANCE_SUCCESS_KEY:
        'Informações de governança cadastradas com sucesso',

      GOVERNANCE_DEFAULTS_SUCCESS_KEY:
        'Informações de governança alteradas com sucesso!',

      REMOVE_DESCRIPTION_KEY: 'As informações do ambiente serão perdidas.',

      MODAL_CONNECT_LIKE_TITLE_KEY:
        'Por questão de segurança, digite sua senha de acesso ao Portal de Administração Autosky:',
      MODAL_CONNECT_LIKE_RDP_KEY:
        'O plugin de conexão do Autosky será utilizado. Caso ainda não tenha o plugin instalado, clique no botão abaixo para prosseguir com a instalação.',
      OPEN_DETAILS_KEY: 'Abrir',
      CHECK_BOOT_VOLUME_BACKUP: 'Verificando boot volume backup',
      CREATE_BOOT_VOLUME_BACKUP: 'Criando boot volume backup',

      SYNC_WITH_PROVIDER: 'Forçar atualização com provedor',
      PREPARATION_SERVER_KEY: 'Servidor de preparação',
      NO_PREPARATION_SERVER_KEY: 'Nenhum servidor de preparação encontrado.',
      NO_SUPPORT_SERVER_KEY: 'Nenhum servidor de suporte encontrado.',
      SERVER_STATUS_KEY: 'Status servidor',
      IMAGE_STATUS_KEY: 'Status imagem',
      APPLICATION_KEY: 'Aplicação',

      STATUS: {
        PENDING_KEY: 'Pendente',
        RUNNING_KEY: 'Operacional',
        STOPPING_KEY: 'Parando',
        STOPPED_KEY: 'Parado',
        GENERATING_KEY: 'Gerando',
        PUBLISHING_KEY: 'Publicando',
        REPLACING_KEY: 'Substituindo',
        BLOCKING_KEY: 'Bloqueando',
        DISCONNECTING_KEY: 'Desconectando',
        ERROR_KEY: 'Erro',
        FINISHED_KEY: 'Finalizado',
        INITIALIZING_KEY: 'Inicializando',
        NOT_FOUND: 'Não encontrado',
        COMPLETED_KEY: 'Concluído',
        EXECUTING_KEY: 'Executando',
        CANCELLED_KEY: 'Cancelado',
        RETRYING_KEY: 'Tentando novamente',
        EXPIRED_KEY: 'Expirado',
      },
    },
    STOPPED_KEY: 'Parado',
    ENVIRONMENT_STATUS_NOTIFICATION_KEY: 'Ambiente não possui status definido',
    ENVIRONMENT_STATUS_NOTIFICATION_ACTION_KEY: 'Definir status',
    ENVIRONMENT_STATUS: {
      DEMONSTRATION_KEY: 'Demonstração',
      DEPLOYMENT_KEY: 'Implantação',
      DEVELOPMENT_KEY: 'Desenvolvimento',
      HOMOLOGATION_KEY: 'Homologação',
      MIGRATION_KEY: 'Migração',
      PENDING_KEY: 'Pendente',
      PRODUCTION_KEY: 'Produção',

      DEMONSTRATION_DESCRIPTION_KEY: 'Ambiente em fase de demonstração',
      DEPLOYMENT_DESCRIPTION_KEY: 'Ambiente em fase de implantação',
      DEVELOPMENT_DESCRIPTION_KEY: 'Ambiente utilizado para desenvolvimento',
      HOMOLOGATION_DESCRIPTION_KEY: 'Ambiente em fase de homologação',
      MIGRATION_DESCRIPTION_KEY: 'Ambiente em fase de migração',
      PENDING_DESCRIPTION_KEY: 'Ambiente sem status definido',
      PRODUCTION_DESCRIPTION_KEY: 'Ambiente produtivo',
    },

    // Applications
    APPLICATIONS_PAGE: {
      CONNECTED_KEY_SIMULATE_KEY:
        'Se surgir o pop-up, clique em Abrir AutoSky Plugin',
      EXECUTE_KEY: 'execute aqui',
      FIRST_ACCESS_KEY: 'Caso seja seu primeiro acesso ao portal',
      EXECUTE_PLUGIN_KEY: 'baixe e execute o plugin',
      DOWNLOAD_FILE_RDP_KEY:
        'Baixe o arquivo de conexão, execute-o e entre novamente com sua senha de acesso',
      WAIT_EXECUTE_APP_KEY:
        'Caso sua aplicação ainda não tenha sido aberta, aguarde mais alguns minutos',
      DOWNLOAD_FILE_CONNECTION_KEY: 'Baixar arquivo de conexão',
      CONNECTION_FILE_KEY: 'Realizar download do arquivo RDP de conexão',
      RDP_HELP_KEY:
        'Precisa de Ajuda? Clique aqui para obter mais informações.',
      ACCESS_TRAINING_APP_KEY:
        'O acesso ao seu ambiente de treinamento já está pronto!',
      CONNECTED_KEY_SIMULATE_CONTENT_HELP_KEY:
        'Se o AutoSky Plugin estiver instalado e não exibiu nenhum pop-up',
      TEST_REMOTE_APP_LOADING_KEY: 'Carregando sua aplicação. Aguarde...',
      TEST_REMOTE_APP_FINISH_KEY: 'Conexão foi concluída!',
      TEST_REMOTE_APP_MSG_KEY:
        ' Caso sua aplicação ainda não tenha sido aberta',
      TEST_REMOTE_APP_CLICK_HERE_KEY: 'clique aqui',
      TEST_REMOTE_APP_INSTALL_PLUGIN_TITLE_KEY:
        'Instalação do plugin Autosky de conexão',
      TEST_REMOTE_APP_INSTALL_PLUGIN_STEP1_KEY:
        '1. Clique no botão baixar plugin.',
      TEST_REMOTE_APP_INSTALL_PLUGIN_KEY: 'Baixar plugin',
      TEST_REMOTE_APP_INSTALL_PLUGIN_STEP2_KEY:
        '2. Prossiga com o processo de instalação do plugin.',
      TEST_REMOTE_APP_INSTALL_PLUGIN_STEPS_TITLE_KEY:
        'Siga com o passo a passo de instalação abaixo:',
      TEST_REMOTE_APP_INSTALL_DOWNLOAD_NOT_INIT_KEY:
        'Caso o download não seja realizado',
      TEST_REMOTE_APP_INSTALL_MANUAL_KEY:
        'para efetuar a instalação manualmente',
      TEST_REMOTE_APP_KEEP_GOING_KEY: 'Continuar >>',
      TEST_REMOTE_APP_CONFIRM_KEY: 'para confirmar a instalação do plugin.',
      CLIENT_APPLICATIONS_CODE: 'Código',
      APPLICATION_NAME_KEY: 'Nome da aplicação',
      SEARCH_APPLICATION_KEY: 'Pesquisar aplicação',
      APPLICATION_ADDRESS_KEY: 'Endereço da aplicação',
      YOUR_APPLICATIONS_KEY: 'Suas aplicações',
      STARTUP_PARAMETER_KEY: 'Parâmetro de inicialização',
      OPEN_APPLICATIONS_TEST_KEY: 'Testar abertura das aplicações',
      CREDENTIALS_USER_KEY: 'Credenciais para simulação de conexão do usuário',
      SELECT_CLIENT_TO_SIMULATE_APP_KEY:
        'Selecione o cliente que deseja fazer o teste de abertura da aplicação:',
      SIMULATE_APP_EXPLANATION_KEY:
        'Este recurso permite que você teste as configurações do cliente antes de realizar a publicação para os usuários.',
      ADD_APPLICATIONS_KEY: 'Adicionar aplicações',
      ADD_APPLICATION_KEY: 'Adicionar aplicação',
      APPLICATION_ADDED_SUCCESS_KEY: 'Aplicação adicionada com sucesso!',
      APPLICATION_EDITED_SUCCESS_KEY: 'Aplicação editada com sucesso!',
      REMOVED_APPLICATION_KEY: 'Aplicação excluída com sucesso!',
      SELECT_APPLICATION_KEY: 'Selecione as aplicações que deseja incluir',
      DISABLE_SELECT_KEY: 'Desativar selecionadas',
      DISABLE_APLICATIONS_KEY: 'Desativar aplicações',
      EDIT_APLICATIONS_KEY: 'Editar aplicações',
      APPLICATIONS_WILL_BE_DISABLE_KEY:
        'As aplicações serão desativadas, isso pode levar alguns minutos',
      REMOVE_APPLICATIONS_KEY: 'Deseja excluir as aplicações?',
      IRREVERSIBLE_ACTION_APPLICATION_KEY:
        'Esta ação é irreversível, as informações não poderão ser recuperadas',
      DISABLE_APPLICATIONS_KEY: 'Deseja desativar estas aplicações?',
      DISABLE_APPLICATIONS_MINUTES_KEY: 'A aplicação será desativada',
      ENABLE_APPLICATIONS_KEY: 'Deseja ativar estas aplicações?',
      ENABLE_APPLICATIONS_MINUTES_KEY: 'A aplicação será ativada',
      NO_APPLICATIONS_FOUND_KEY: 'Nenhuma aplicação encontrada.',
      DISPLAY_APPLICATION_NAME_KEY: 'Nome de exibição do aplicativo',
      DISABLE_PLUGIN_KEY: 'Desativar o status de conexão do plugin?',
      KEEP_ALIVE_PARAMETER_KEY: 'Ativar parâmetro KeepAlive?',
      OPEN_APPLICATION_KEY: 'Abrir aplicação com HTML5',
      OPEN_APPLICATION_WITH_REMOTE_APP_KEY: 'Abrir aplicação com Remote App',
      USE_EXISTING_USER_KEY: 'Utilizar usuário existente',
      USE_TEMPORARY_USER_KEY: 'Utilizar usuário temporário',
      DISABLE_APPLICATION_KEY: 'Deseja desativar esta aplicação?',
      ENABLE_APPLICATION_KEY: 'Deseja ativar esta aplicação?',
      REMOVE_APPLICATION_KEY: 'Deseja excluir esta aplicação?',
      EDIT_APPLICATION_KEY: 'Editar aplicação',
      WEB_CLIENT_APP_KEY: 'Aplicações Web',
      DEFAULT_APP_KEY: 'Aplicações padrão',
    },
    // Users
    USER_NAME_KEY: 'Nome do usuário',

    // Company
    COMPANY_NAME_KEY: 'Nome da companhia',
    OPERATOR_VIEW_COMPANY_NAME_KEY: 'Companhia',
    CORPORATE_NAME_KEY: 'Razão social da companhia',
    ADD_COMPANY_KEY: 'Adicionar companhia',
    EDIT_COMPANY_KEY: 'Editar companhia',
    REMOVE_COMPANY_KEY: 'Excluir companhia',
    BLOCK_COMPANY_KEY: 'Bloquear companhia',
    UNBLOCK_COMPANY_KEY: 'Desbloquear companhia',
    NO_COMPANY_KEY: 'Nenhuma companhia encontrada.',
    COMPANY_UPDATED_SUCCESSFULLY_KEY: 'Companhia atualizada com sucesso!',
    COMPANY_BLOCKED_SUCCESSFULLY_KEY: 'Companhia bloqueada com sucesso!',
    COMPANY_UNBLOCKED_SUCCESSFULLY_KEY: 'Companhia desbloqueada com sucesso!',

    RESPONSIBLE_KEY: 'Responsável',
    RESPONSIBLE_NAME_KEY: 'Nome do responsável',
    RESPONSIBLE_EMAIL_KEY: 'E-mail do responsável',
    RESPONSIBLE_PHONE_KEY: 'Telefone de contato do responsável',

    COMPANIES_PAGE: {
      LIST_COMPANIES_TITLE_KEY: 'Lista de companhias',
      LIST_COMPANIES_SUBTITLE_KEY: 'Relação de companhias disponíveis',
      ADD_COMPANY_TITLE_KEY: 'Adicionar companhia',
      ADD_COMPANY_SUBTITLE_KEY:
        'Preencha os dados para iniciar a inclusão de uma nova companhia',
      DETAILS_COMPANY_TITLE_KEY: 'Detalhes da companhia',
      DETAILS_COMPANY_SUBTITLE_KEY: 'Informações gerais da companhia',
      CONSULT_COMPANY_TITLE_KEY: 'Recursos da companhia',
      CONSULT_COMPANY_SUBTITLE_KEY: 'Consulte os dados da companhia {{name}}',

      REMOVE_COMPANY_DESCRIPTION_KEY:
        'As informações da companhia serão perdidas.',

      BLOCK_COMPANY_TITLE_KEY: 'Deseja bloquear a companhia?',
      BLOCK_COMPANY_DESCRIPTION_KEY: 'A companhia {{name}} será bloqueada.',
      UNBLOCK_COMPANY_TITLE_KEY: 'Deseja desbloquear a companhia?',
      UNBLOCK_COMPANY_DESCRIPTION_KEY:
        'A companhia {{name}} será desbloqueada.',
      PORTAL_DELETED_TEXT_KEY:
        'Companhia não está mais ativa no portal. Entre em contato com o administrador',
    },

    // panel
    PANEL_PAGE: {
      TOTAL_ENVIRONMENT_KEY: 'Ambientes',
      TOTAL_ENVIRONMENT_INSTANCE_KEY: 'Amb. com instâncias',
      PERCENT_ACTIVE_INSTANCE_KEY: 'Ambientes ativos',
      TOTAL_PARTNER_KEY: 'Contas',
      TOTAL_CLIENTS_KEY: 'Clientes',
      TOTAL_USERS_KEY: 'Usuários',
      TOTAL_SESSIONS_KEY: 'Sessões',
      PANEL_AUTO_KEY: 'Painel Autosky',
      ADD_OR_EDIT_KEY: 'Adicionar ou editar',
      LIST_CLIENTS_ACESS_KEY: 'Acessar listagem de clientes',
      LIST_PARTNER_ACESS_KEY: 'Acessar listagem de contas',
      LIST_ENVIRONMENTS_ACESS_KEY: 'Acessar listagem de ambientes',
      CLIENTS_AUTO_SKY_KEY: 'Clientes Autosky',
      ENVIRONMENTS_AUTO_SKY_KEY: 'Ambientes Autosky',
      ADMINISTRATION_AUTO_SKY_KEY: 'Administração Autosky',
      PIN_VIEW_DEFAULT: 'Favorite um card para adicionar ao seu dashboard',
      FAVORITES_CARDS_KEY: 'Seus cards favoritados são exibidos abaixo',
      QUALITY_ENVIRONMENTS_KEY: 'Ambientes',
      ACTIVE_ENVIRONMENTS_KEY: 'Ambientes ativos no momento',
      ENVIRONMENTS_PARTNER_KEY: 'Ambientes utilizados por contas',
      ACTIVE_USERS_KEY: 'Usuários ativos',
      QUICK_MENU: 'Quick menu',
      AMOUNT_PARTNER_KEY: 'Quantidade de contas',
      COUNT_CLIENTS_KEY: 'Quantidade de clientes',
      ACTIVE_CLIENTS_KEY: 'Quantidade de clientes ativos',
      AVERAGE_CLIENTS_KEY: 'Média de utilização dos clientes',
      PUSH_PIN_BUTTON_KEY: 'Pin para visualização padrão',
      AUTO_KEY_DOCUMENTATION: 'Acessar documentação Autosky',
      ACCESS_LIST_PARTNER_KEY: 'Acessar listagem de contas',
      MY_PROFILE_AUTO_SKY_KRY: 'Acessar o meu perfil Autosky',
      OPEN_CALL_KEY: 'Abrir um chamado',
      SEND_SUGGESTION: 'Enviar sugestão',
      SEND_SUGGESTION_DESCRIPTION_KEY:
        'Tem alguma sugestão para melhorar o Autosky? Basta preencher o formulário abaixo, e em breve entraremos em contato."',
    },

    // Operators
    ADD_OPERATOR_KEY: 'Adicionar operador ao grupo',
    EDIT_OPERATOR_KEY: 'Editar operador',
    REMOVE_OPERATOR_KEY: 'Excluir operador',
    RESET_PASSWORD_MSG_KEY: 'Será enviado um e-mail para o endereço {{email}}',
    SUCCESS_RESET_PASSWORD: 'Reset de senha solicitado com sucesso!',
    BLOCK_FALSE_OPERATOR_KEY: 'Bloquear operador',
    BLOCK_TRUE_OPERATOR_KEY: 'Desbloquear operador',
    NO_OPERATOR_KEY: 'Nenhum operador encontrado.',
    OPERATOR_BLOCKED_SUCCESSFULLY_KEY: 'Operador bloqueado com sucesso!',
    OPERATOR_UNBLOCKED_SUCCESSFULLY_KEY: 'Operador desbloqueado com sucesso!',
    OPERATOR_ADDED_SUCCESSFULLY_KEY: 'Operador cadastrado com sucesso!',
    OPERATOR_UPDATED_SUCCESSFULLY_KEY: 'Operador atualizado com sucesso!',
    OPERATOR_REMOVED_SUCCESSFULLY_KEY: 'Operador excluído com sucesso!',

    RESET_PASSWORD_OPERATOR_KEY: 'Redefinir senha do operador',
    SEND_BY_EMAIL_KEY: 'Enviar por e-mail',
    EMAIL_SENT_KEY: 'E-mail enviado para o endereço de e-mail do operador!',
    INSERT_MANUALLY_KEY: 'Inserir a senha manualmente',

    OPERATORS_PAGE: {
      RESET_MFA_OPERATOR_KEY:
        'Deseja redefinir o MFA do operador {{firstName}} {{lastName}}?',
      LIST_OPERATORS_TITLE_KEY: 'Lista de operadores',
      LIST_OPERATORS_SUBTITLE_KEY: 'Relação de operadores disponíveis',
      ADD_OPERATOR_TITLE_KEY: 'Adicionar operador',
      ADD_OPERATOR_TOOLTIP_KEY:
        'A companhia escolhida não irá refletir no permissionamento, é usado apenas para fins organizacionais',
      ADD_OPERATOR_SUBTITLE_KEY:
        'Preencha os dados para iniciar a inclusão do operador',
      EDIT_OPERATOR_TITLE_KEY: 'Editar operador',
      EDIT_OPERATOR_SUBTITLE_KEY: 'Altere os dados do operador',

      REMOVE_OPERATOR_TITLE_KEY: 'Excluir {{name}}',
      REMOVE_OPERATOR_DESCRIPTION_KEY:
        'As informações do operador serão perdidas.',

      BLOCK_OPERATOR_TITLE_KEY: 'Deseja bloquear o operador?',
      BLOCK_OPERATOR_DESCRIPTION_KEY: 'O operador {{name}} será bloqueado.',
      UNBLOCK_OPERATOR_TITLE_KEY: 'Deseja desbloquear o operador?',
      UNBLOCK_OPERATOR_DESCRIPTION_KEY:
        'O operador {{name}} será desbloqueado.',
      APIS_OPERATOR_NOT_FOUND: 'Sem dados de integração com API',
      REQUIRES_IP_VALIDATION: 'Requer validação de IP',
      EDIT_TOKEN_KEY: 'Editar token',
      ADD_TOKEN_KEY: 'Adicionar token',
      API_INTEGRATION_IPS_KEY: 'Integração API',
      FILTER_TO_IPS: 'Filtrar por IPs',

      REMOVE_TOKEN_TITLE_KEY: 'Excluir token',
      REMOVE_TOKEN_DESCRIPTION_KEY:
        'O token {{name}} será excluído. Essa ação é definitiva.',

      TOKEN_UPDATED_SUCCESSFULLY_KEY: 'Token atualizado com sucesso!',
      CREATED_AT_KEY: 'Criado em',
      CREATED_BY_KEY: 'Criado por',
      TIME_AT_KEY: 'às',
      MANAGE_PERMISSIONS_KEY: 'Gerenciar grupos de permissão',
    },

    // Clients
    CLIENT_NAME_KEY: 'Nome do cliente',
    ADD_CLIENT_KEY: 'Adicionar cliente',
    ADD_CLIENT_DESCRIPTION_KEY:
      'Preencha os dados para incluir um novo cliente',
    REMOVE_CLIENT_KEY: 'Excluir cliente',
    REMOVE_SESSIONS_KEY: 'Excluir sessões',
    REMOVE_SESSIONS_SELECTED_KEY: 'Excluir sessões selecionadas',
    VIEW_LOGS_KEY: 'Ver logs',
    CLIENT_ID_KEY: 'Cliente ID',
    ADMIN_EMAIL_KEY: 'E-mail do administrador',
    CLIENT_EXTERNAL_CODE_KEY: 'Código externo do cliente',
    SORT_ADMIN_EMAIL_KEY: 'E-mail admin',
    LIMIT_LICENSES_KEY: 'Limite licenças',
    ACTIVE_SESSIONS_KEY: 'Sessões ativas',
    PERMANENT_KEY: 'Permanente',
    STATUS_REQUESTED_KEY: 'Solicitado',
    STATUS_FINISHED_KEY: 'Permanente',
    STATUS_STARTED_KEY: 'Clonando',
    REMOTE_PROFILE_KEY: 'Perfil remoto',
    ADDRESS_REMOTE_PROFILE_KEY: 'Endereço do perfil remoto',
    ACTIVE_REMOTE_PROFILE_KEY: 'Ativar perfil remoto',
    DISABLE_REMOTE_PROFILE_KEY: 'Desativar perfil remoto',
    ACTIVE_DISABLE_PROFILE_MSG_KEY:
      'Deseja {{active}} o perfil remoto para o usuário {{name}}?',
    VIRTUALIZER_KEY: 'Virtualizador',
    PROFILE_PATH_KEY: 'Caminho do perfil',
    MAIN_PORT_KEY: 'Porta principal',
    WEB_PORT_KEY: 'Porta web',
    RESTRICTIONS_KEY: 'Restrições de acesso',
    BY_TIME_KEY: 'Por horário',
    BY_IP_KEY: 'Por endereço de IP',
    RELEASED_IP_ADDRESSES_KEY: 'Endereços IP liberados',
    START_RESTRICTION_AT_KEY: 'Iniciar restrição às',
    ERROR_PERIOD_KEY: 'É necessario selecionar ao menos um dia',
    END_RESTRICTION_AT_KEY: 'Terminar restrição às',
    CONFIGURE_PASSWORD_KEY: 'Configurar senha',
    IMPORT_FILE_KEY: 'Importar arquivo',
    DELETE_SUCCESS_MESSAGE_KEY: 'Cliente excluído com sucesso!',
    LICENSES_PER_CLIENTS: 'Limite de licenças por cliente',
    INVALID_PAYLOAD_APPLICATION_MODE_KEY: 'O campo "Modo" é inválido.',
    NO_CLIENT_KEY: 'Nenhum cliente encontrado',
    USE_ENVIRONMENT_VIRTUALIZER_KEY:
      'Utilizar o mesmo virtualizador do ambiente',
    USE_PARTNER_NEW_FRONT_KEY: 'Utilizar a mesma interface da conta do cliente',
    USE_ENVIRONMENT_CONNECTION_TYPE_KEY:
      'Utilizar o mesmo tipo de conexão do ambiente',
    ENVIRONMENT_CONNECTION_TYPE_DISABLED_EXPLANATION_KEY:
      'Não é possível configurar o tipo de conexão do cliente enquanto a opção “Permitir tipo de conexão por cliente“ estiver desativada no ambiente',

    IMPORT_USER_ALERT_KEY:
      'Ao selecionar a opção de Configurar Senha, o sistema utilizará o campo de senha da planilha para registrar a senha do usuário. Se essa opção não for selecionada, o usuário será apenas registrado e um e-mail de registro será enviado para o endereço eletrônico configurado.',

    ADD_USER_KEY: 'Adicionar usuário',
    ADD_NEW_USER_KEY: 'Adicionar novo usuário',
    USER_ADDED_SUCCESSFULLY_KEY: 'Usuário cadastrado com sucesso!',
    USER_DELETE_SUCCESS_MESSAGE_KEY: 'Usuário excluído com sucesso!',
    USER_DELETE_PERMANENTLY_SUCCESS_MESSAGE_KEY:
      'Usuário excluído permanentemente com sucesso!',
    IMPORT_USERS_KEY: 'Importar usuários',
    IMPORT_USERS_SUCCESS_KEY: 'Usuários importados com sucesso!',

    ACTIVATE_SELECTED_KEY: 'Ativar selecionados',
    INACTIVATE_SELECTED_KEY: 'Desativar selecionados',
    WANT_ACTIVATE_USERS_KEY: 'Deseja ativar os usuários selecionados?',
    WANT_INACTIVATE_USERS_KEY: 'Deseja desativar os usuários selecionados?',
    ACTIVATE_SELECTED_DESCRIPTION_KEY:
      'Os usuários selecionados voltaram a ter acesso às informações do cliente ao qual estão associados.',
    INACTIVATE_SELECTED_DESCRIPTION_KEY:
      'Os usuários selecionados não terão acesso às informações do cliente ao qual estão relacionados.',
    ACTIVE_USER_KEY: 'O usuário {{id}} será ativado!',
    ACTIVATE_USERS_SUCCESS_KEY: 'Usuários ativados com sucesso!',

    REMOVE_SELECTED_KEY: 'Excluir selecionados',
    WANT_REMOVE_SELECTED_KEY: 'Deseja excluir os usuários selecionados?',
    REMOVE_SELECTED_DESCRIPTION_KEY:
      'Está ação é irreversível e as informações não poderão ser recuperadas.',
    REMOVE_SELECTED_SUCCESS_KEY: 'Usuários excluídos com sucesso!',
    ACTIVE_USER_SELECTED_SUCCESS_KEY: 'Usuários ativados com sucesso!',
    INACTIVATE_USERS_SUCCESS_KEY: 'Usuários desativados com sucesso!',

    IMPORT_CUSTOM_USERS_KEY: 'Importar usuários customizados',
    IMPORT_USUER_CUSTOM_MSG_KEY: 'Usuários com clientes personalizados',
    CHOOSE_CSV_FILE_KEY:
      'Escolha um arquivo CSV para importar usuários. Certifique-se de enviar o arquivo com codificação UTF-8.',
    IMPORT_CLIENTS_KEY: 'Importar clientes',
    IMPORT_CLIENT_SUCCESS_KEY: 'Cliente importado com sucesso!',

    SCHEDULED_USER_IMPORT_SUCCESSFULLY:
      'Arquivo enviado para a fila de importação. Uma vez importado, um e-mail de confirmação será enviado para o administrador.',
    SCHEDULED_CLIENTS_IMPORT_SUCCESSFULLY:
      'Arquivo enviado para a fila de importação. Uma vez importado, um e-mail de confirmação será enviado para o administrador.',
    INVALID_CSV_FILE:
      'Arquivo CSV inválido. Verifique o arquivo CSV e tente novamente.',

    EXPORT_CSV_KEY: 'Exportar CSV',
    WANT_EXPORT_CSV_KEY: 'Deseja exportar CSV?',
    EXPORT_CSV_DESCRIPTION_KEY:
      'Deseja exportar as informações em um arquivo no formato CSV?',
    EXPORT_CSV_SUCCESS_KEY: 'Dados exportados com sucesso!',

    RESEND_PASSWORD_KEY: 'Reenviar senha',
    WANT_RESEND_PASSWORD_KEY: 'Deseja reenviar a senha?',
    RESEND_PASSWORD_DESCRIPTION_KEY:
      'A senha será reenviada para o e-mail {{email}}',
    RESEND_PASSWORD_SUCCESS_KEY: 'Senha reenviada com sucesso!',

    RESEND_PASSWORD_WITH_COPY_KEY: 'Reenviar senha (c/ cópia)',
    WANT_RESEND_PASSWORD_WITH_COPY_KEY:
      'Deseja reenviar a senha com cópia para o administrador?',
    RESEND_PASSWORD_WANT_COPY_DESCRIPTION_KEY:
      'Um e-mail para a redefinição da senha será enviado para o e-mail {{email}} com cópia para o administrador cadastrado para o cliente',
    RESEND_PASSWORD_TO_FICTITIOUS_EMAIL_KEY:
      'Este usuário possui um e-mail fictício. A senha será enviada para o e-mail do administrador cadastrado para o cliente',
    WANT_DISABLE_USER_KEY: 'Deseja desativar o usuário?',
    DISABLE_USER_DESCRIPTION_KEY:
      'O usuário não terá mais acesso às informações do cliente',
    DISABLE_USER_SUCCESS_KEY: 'Usuário desativado com sucesso!',

    EDIT_USER_KEY: 'Editar usuário',
    EDIT_USER_SUCCESS_KEY: 'Usuário editado com sucesso!',

    WANT_REMOVE_USER_KEY: 'Deseja excluir o usuário {{name}}?',
    REMOVE_USER_DESCRIPTION_KEY:
      'Esta ação é irreversível e as informações não poderão ser recuperadas',
    REMOVE_USER_SUCCESS_KEY: 'Usuário excluído com sucesso!',

    WANT_REMOVE_SESSION_KEY: 'Deseja excluir a sessão?',
    WANT_REMOVE_SESSION_MSG_KEY: 'Deseja excluir a sessão do usuário {{name}}?',
    REMOVE_SESSION_DESCRIPTION_KEY:
      'A sessão do usuário será excluída {{name}}',
    REMOVE_SESSION_SUCCESS_KEY: 'Sessão excluída com sucesso!',
    REMOVE_SESSION_ERROR_KEY:
      'Erro ao excluir sessão. Tente novamente mais tarde!',

    CLIENTS_PAGE: {
      LOADING_LIST_CLIENTES: 'Carregando lista de clientes',
      REMOVE_MULTIPLE_SESSIONS_TITLE_KEY: 'Excluir múltiplas sessões',
      REMOVE_MULTIPLE_SESSIONS_DESCRIPTION_KEY:
        'As sessões selecionadas serão excluídas',
      SESSION_REMOVAL_TIMEOUT_KEY: 'Tempo limite de remoção da sessão excedido',
      EXPIRED_SESSION_HISTORY_KEY: 'Sessão expirada',
      CLOSED_SESSION_HISTORY_KEY: 'Sessão encerrada',
      REMOVE_SESSION_HISTORY_KEY: 'Instância terminada',
      SESSION_HISTORY_KEY: 'Histórico de sessões',
      NO_SESSION_HISTORY_KEY: 'Sem registro de histórico de sessões',
      ENABLED_MFA_ALL_USERS_TITLE_KEY: 'Ativar o MFA para todos os usuários',
      DISABLED_MFA_ALL_USERS_TITLE_KEY:
        'Desativar o MFA para todos os usuários',
      ENABLED_MFA_ALL_USERS_MSG_KEY:
        'O MFA será ativado para todos os usuários do cliente {{name}}',
      DISABLED_MFA_ALL_USERS_MSG_KEY:
        'O MFA será desativado para todos os usuários do cliente {{name}}',
      MFA_USER_RESET_TITLE_KEY: 'Deseja redefinir o MFA?',
      MFA_USER_RESET_MSG_KEY: 'O MFA será redefinido para o usuário {{name}}!',
      USER_NO_LINKED_INSTANCE_KEY: 'Usuário não vinculado a uma instância',
      NEW_CLONE_CLIENT_KEY: 'Nome do novo cliente',
      CLONE_CLIENT_KEY: 'Clonar cliente',
      LIST_CLIENTS_TITLE_KEY: 'Lista de clientes',
      NO_CLIENTS_KEY: 'Nenhum cliente encontrado.',
      WANT_REMOVE_CLIENT_KEY: 'Deseja excluir o cliente?',
      REMOVE_CLIENT_WARNING_MSG_KEY:
        'O Cliente {{name}} será excluído e suas informações não poderão ser recuperadas.',
      CREATED_CLIENT: 'Cliente criado com sucesso!',

      LIST_LOGS_TITLE_KEY: 'Logs',
      LIST_LOGS_SUBTITLE_KEY:
        'Visualize as informações do ambiente a partir dos filtros abaixos',
      NO_LOGS_KEY: 'Nenhum log encontrado.',

      LIST_SESSIONS_TITLE_KEY: 'Sessões',
      NO_SESSIONS_KEY: 'Nenhuma sessão encontrada.',

      RESTRICTIONS_TITLE_KEY: 'Restrições de acesso',
      RESTRICTIONS_SUBTITLE_KEY: 'Restrições de acesso',

      LIST_USERS_TITLE_KEY: 'Usuários',
      LIST_USERS_SUBTITLE_KEY: 'Gerencie todos os usuários registrados',
      NO_USERS_KEY: 'Nenhum usuário encontrado.',

      EDIT_CLIENT_KEY: 'Editar cliente',
      UPDATED_SUCCESSFULLY_KEY: 'Cliente atualizado com sucesso!',

      REMOVE_CLIENT_KEY: 'Excluir cliente',
      REMOVE_CLIENT_DESCRIPTION_KEY: 'O cliente {{name}} será excluído.',

      // Form
      ALWAYS_COPY_ADMIN_KEY:
        'Sempre copiar o administrador cadastrado para o cliente nas comunicações por e-mail',
      SORT_ALWAYS_COPY_ADMIN_KEY: 'Sempre copiar administrador',
      BLOCK_MULTIPLE_SESSIONS_KEY:
        'Bloquear múltiplas sessões do mesmo usuário?',
      USE_IOS_DEVICES_KEY: 'Utilizar dispositivos iOS?',

      FIELD_INVALID_IP_ADDRESS_KEY:
        'O campo acima possui Endereços IP inválidos',
      ALLOWED_IPS_UPDATED_KEY: 'Endereços IP atualizados com sucesso!',

      ACCESS_CONTROL_UPDATED_KEY: 'Controle de Acesso atualizado com sucesso!',
    },
    LICENSE_LIMIT: 'Limite de licenças excedido',

    // Groups
    ADD_GROUP_KEY: 'Adicionar grupo',
    EDIT_GROUP_KEY: 'Editar grupo',
    EDIT_INFO_KEY: 'Editar informações',
    REMOVE_SELECTED_GROUPS_KEY: 'Excluir grupos selecionados',
    GROUP_KEY: 'Nome do grupo',
    CREATED_BY_KEY: 'Criado por',
    CREATED_AT_KEY: 'Data de criação',
    UPDATED_AT_KEY: 'Data de atualização',
    UPDATED_BY_KEY: 'Modificado por',
    ACTIVATED_KEY: 'Ativado',
    RESTRICTED_OPERATORS_KEY: 'Operadores restritos',
    ITEMS_TO_ADD_KEY: 'Itens a serem adicionados',
    NO_ADDED_COMPANY_KEY: 'Nenhuma companhia adicionada',
    NO_ADDED_PARTNER_KEY: 'Nenhuma conta adicionada',
    NO_ADDED_ENVIRONMENT_KEY: 'Nenhum ambiente adicionado',
    NO_ADDED_CLIENT_KEY: 'Nenhum cliente adicionado',
    NO_ADDED_OPERATOR_KEY: 'Nenhum operador adicionado',
    ACTIVATE_USER: 'Ativar usuário',
    CLIENT_ACCESS_CONTROL: 'Controle de acesso para clientes',
    CREATE_NEW_USER: 'Criar novo usuário',
    DELETE_USER: 'Excluir usuário',
    DELETE_USER_PERMANENTLY: 'Excluir usuário permanentemente',
    INACTIVATE_USER: 'Desativar usuário',
    LIST_AVAILABLE_APPLICATIONS: 'Listar aplicações disponíveis',
    LIST_SESSION_HISTORY: 'Visualizar histórico de sessões',
    RESET_USER_MFA: 'Resetar MFA',
    CAN_IMPORT_USERS_IN_ALL_CLIENTS: 'Importar usuários em todos os clientes',
    CLONE_CLIENT: 'Clonar cliente',
    DELETE_APPLICATION: 'Deletar aplicação',
    EDIT_APPLICATION: 'Editar aplicação',
    EDIT_CLIENT_SCHEDULED_WARNINGS: 'Editar alertas agendados para clientes',
    INCLUDE_APPLICATION: 'Incluir aplicação',
    LIST_CLIENT: 'Listar clientes',
    LIST_CLIENT_SCHEDULED_WARNINGS: 'Listar alertas agendados para clientes',
    LIST_CLIENT_INSTANCE_SESSIONS: 'Listar sessões',
    DELETE_CLIENT_INSTANCE_SESSIONS: 'Terminar sessões',
    LIST_USERS: 'Listar usuários',
    RESET_USER_PASSWORD: 'Redefinir senha do usuário',
    CAN_SIMULATE_APPLICATIONS: 'Teste de abertura de aplicações',
    CREATE_NEW_APPLICATION: 'Criar aplicação',
    DELETE_CLIENT: 'Deletar cliente',
    EDIT_CLIENT: 'Editar cliente',
    EDIT_USER_DETAILS: 'Editar usuário',
    LIST_APPLICATIONS: 'Listar aplicações',
    LIST_APPLICATIONS_ENVIRONMENT: 'Listar aplicações por ambiente',
    CREATE_APPLICATIONS_ENVIRONMENT:
      'Incluir aplicações de clientes do ambiente - modo Autosky',
    CHANGE_APPLICATIONS_NAME_ENVIRONMENT:
      'Renomear aplicações de clientes do ambiente - modo Autosky',
    REMOVE_APPLICATIONS_ENVIRONMENT:
      'Remover aplicações de clientes do ambiente - modo Autosky',
    CHANGE_APPLICATIONS_STATE_ENVIRONMENT:
      'Ativar/inativar aplicações de clientes do ambiente - modo Autosky',
    CHANGE_APPLICATIONS_ATTACHMENT_ENVIRONMENT:
      'Vincular/desvincular aplicações de clientes do ambiente - modo Platform',
    LIST_INCLUDED_APPLICATIONS: 'Listar aplicações incluídas',
    REMOVE_INCLUDED_APPLICATION: 'Excluir aplicações',
    ATTACH_PREPARATION_SERVER: 'Adicionar servidor de preparação',
    CAN_BLOCK_ENVIRONMENT_INSTANCES: 'Bloquear instância scaling',
    DELETE_USER_THEME_CONFIG: 'Excluir dados de front customizado',
    CAN_LIST_ENV_SCHEDULED_WARNINGS_DETAILS:
      'Listar detalhes de avisos de manutenção agendada',
    CAN_REGISTER_ENVIRONMENT_INSTANCES: 'Registrar nova instância',
    CAN_UNBLOCK_ENVIRONMENT_INSTANCES: 'Desbloquear instância scaling',
    CREATE_NEW_CLIENT: 'Criar cliente',
    DELETE_MODELS: 'Deletar modelo',
    EDIT_BEHAVIOR: 'Editar configurações de comportamento',
    EDIT_MODELS: 'Editar modelos',
    LIST_ENVIRONMENT_DASHBOARD: 'Exibir dashboard do ambiente',
    LIST_ENVIRONMENT_INSTANCES: 'Listar instâncias do ambiente',
    LIST_PROVIDER_RESOURCES: 'Listar recursos do provedor',
    START_PREPARATION_SERVER: 'Ligar servidor de preparação',
    STOP_SUPPORT_SERVER: 'Desligar servidor de suporte',
    ATTACH_SUPPORT_SERVER: 'Adicionar servidor de suporte',
    CAN_CONNECT_INSTANCE: 'Conectar como',
    CAN_EDIT_ENV_SCHEDULED_WARNINGS: 'Gerenciar agendamento de avisos',
    CAN_RESTART_ENVIRONMENT_INSTANCES: 'Reiniciar instância',
    CAN_UNREGISTER_ENVIRONMENT_INSTANCES: 'Desvincular instâncias',
    UNREGISTER_INSTANCES: 'Desvincular instância',
    DELETE_ENVIRONMENT: 'Deletar ambiente',
    DETACH_PREPARATION_SERVER: 'Desvincular servidor de preparação',
    EDIT_ENVIRONMENT: 'Editar ambiente',
    EDIT_PASSWORD_REQS: 'Gerenciar políticas de senha',
    LIST_ENVIRONMENT_DETAILS: 'Listar detalhes do ambiente',
    LIST_MODELS: 'Listar modelos',
    LIST_SUPPORT_SERVERS: 'Listar servidores de suporte',
    EDIT_SCALING_ADVISOR: 'Editar Scaling Advisor',
    LIST_SCALING_ADVISORS: 'Listar Scaling Advisor',
    LIST_SCALING_ADVISOR_DETAILS: 'Listar detalhes do Scaling Advisor',
    LIST_SCALING_ADVISOR: 'Listar Scaling Advisor',
    DELETE_SELF_OPERATOR: 'Deletar seu próprio operador',
    CREATE_SELF_API_TOKEN: 'Criar seu próprio token API',
    LIST_SELF_OPERATOR_TOKEN: 'Listar seu próprio token API',
    LIST_SELF_OPERATOR: 'Listar seu próprio operador',
    DELETE_SELF_API_TOKEN: 'Deletar seu próprio token API',
    EDIT_SELF_OPERATOR_DETAILS: 'Editar detalhes do seu próprio operador',
    LIST_SELF_OPERATOR_DETAILS: 'Listar detalhes do seu próprio operador',
    RESET_SELF_OPERATOR_MFA: 'Redefinir seu próprio MFA',
    EDIT_SELF_API_TOKEN: 'Editar seu próprio token API',
    START_SUPPORT_SERVER: 'Ligar servidor de suporte',
    CAN_ACTIVATE_ENVIRONMENT_INSTANCES: 'Iniciar instância scaling',
    CAN_IMPORT_CLIENTS: 'Importação de clientes',
    CAN_TERMINATE_ENVIRONMENT_INSTANCES: 'Terminar instância scaling',
    CREATE_MODELS: 'Criar modelo',
    DELETE_ENVIRONMENT_INSTANCE_SESSIONS: 'Terminar sessão',
    DETACH_SUPPORT_SERVER: 'Desvincular servidor de suporte',
    EDIT_GOVERNANCE: 'Editar governança',
    LIST_ENVIRONMENT: 'Listar ambientes',
    LIST_ENVIRONMENT_INSTANCE_SESSIONS: 'Listar sessões das instâncias',
    LIST_PREPARATION_SERVERS: 'Listar servidores de preparação',
    PUBLISH_IMAGE: 'Publicar imagem',
    PUBLISH_IMAGE_V2: 'Publicar imagem (otimizado)',
    PUBLISH_IMAGE_PARTNER_SERVERS:
      'Publicar imagem nos servidores na conta (otimizado)',
    STOP_PREPARATION_SERVER: 'Desligar servidor de preparação',
    CREATE_NEW_PARTNER: 'Criar conta',
    LIST_ALL_COMPANIES: 'Listar todas as companhias',
    LIST_COMPANY_USERS: 'Visualizar usuários da companhia',
    DELETE_COMPANY: 'Deletar companhia',
    EDIT_COMPANY_DETAILS: 'Editar companhia',
    LIST_COMPANY_DETAILS: 'Ver detalhes da companhia',
    LIST_COMPANY_DASHBOARD: 'Dashboard de companhia',
    CAN_TEST_LDAP: 'Testar LDAP',
    CAN_CHANGE_EXTERNAL_AD_PASSWORD:
      'Alterar senha do usuário administrativo do AD',
    EDIT_PARTNER_DETAILS: 'Editar conta',
    LIST_PARTNER_DETAILS: 'Listar detalhes da conta ',
    LIST_USER_THEME_CONFIG: 'Listar customização de frontend para conta',
    CREATE_USER_THEME_CONFIG: 'Criar customização de frontend para conta',
    EDIT_USER_THEME_CONFIG: 'Editar customização de frontend para conta',
    DELETE_USER_THEME_IMAGE: 'Deletar customização de frontend para conta',
    PUBLISH_USER_THEME_CONFIG: 'Publicar customização de frontend para conta',
    CREATE_NEW_ENVIRONMENT: 'Criar novo ambiente',
    LIST_ALL_PARTNERS: 'Listar contas',
    LIST_ALL_USERS: 'Listar todos os usuários',
    USERS_RECOVERY: 'Recuperação de usuários',
    DELETE_PARTNER: 'Deletar conta',
    LIST_PARTNER_DASHBOARD: 'Dashboard',
    LIST_ENVIRONMENT_INCIDENTS: 'Dashboard de acompanhamento',
    CREATE_ALL_ROLES: 'Criar grupo de permissão',
    CREATE_NEW_OPERATOR: 'Criar operador',
    DELETE_OPERATOR: 'Deletar operador',
    EDIT_OPERATOR_DETAILS: 'Editar operador',
    LIST_ALL_ROLES: 'Listar grupo de permissão',
    CREATE_API_TOKEN: 'Criar token API',
    DELETE_ALL_ROLES: 'Deletar grupo de permissão',
    EDIT_ALL_ROLES: 'Editar grupo de permissão',
    CAN_CLONE_ROLE: 'Clonar grupo de permissão',
    LIST_ALL_OPERATOR_TOKEN: 'Listar tokens do operador',
    LIST_ALL_OPERATORS_AUDIT_LOGS: 'Listar auditoria de logs',
    EDIT_IFRAME_MAX_LENGTH:
      'Editar tamanho máximo da string de conexão com o Autosky Plugin',
    LIST_IFRAME_MAX_LENGTH:
      'Ver tamanho máximo da string de conexão com o Autosky Plugin',
    LIST_OPERATOR_DETAILS: 'Listar detalhes do operador',
    CREATE_NEW_COMPANY: 'Criar companhia',
    DELETE_API_TOKEN: 'Deletar token API',
    EDIT_API_TOKEN: 'Editar token API',
    LIST_ALL_OPERATORS: 'Listar operadores',
    RESET_OPERATOR_MFA: 'Redefinir MFA',
    DOWNLOAD_CSV_TOKEN_KEY: 'Download token CSV',
    CREATED_TOKEN_TITLE_KEY: 'Token de operador',
    LIST_ENVIRONMENT_COST: 'Listar custo do ambiente',
    CAN_VIEW_ENVIRONMENT_LICENSES: 'Exibir quantidade de licenças',
    MIGRATE_ENVIRONMENT: 'Migrar ambiente',
    INACTIVATE_USER_RESET_PASSWORD_AT_LOGIN:
      'Inativar redefinição de senha no login',
    ACTIVATE_USER_RESET_PASSWORD_AT_LOGIN:
      'Ativar redefinição de senha no login',
    DISABLE_USER_DEVICES: 'Desativar dispositivos do usuário',
    LIST_USER_DEVICES: 'Listar dispositivos do usuário',
    ENABLE_DEVICE_VALIDATION_BYPASS:
      'Habilitar ignorar validação de dispositivo',
    DISABLE_DEVICE_VALIDATION_BYPASS:
      'Desabilitar ignorar validação de dispositivo',

    EDIT_ENV_AUTO_REMOVE_USER_SESSION_MAINTENANCE:
      'Editar detalhes de remoção de sessão de usuários',
    LIST_ENV_AUTO_REMOVE_USER_SESSION_DETAILS:
      'Exibir detalhes de remoção de sessão de usuários',
    EDIT_OPERATOR_ROLE: 'Editar permissão do operador',

    ADMIN_KEY: 'Administrador',
    SUPERADMIN_KEY: 'SuperAdmin',
    EMAIL_ADMIN_KEY: 'E-mail do administrador',

    SEARCH_ENVIRONMENT_KEY: 'Pesquisar ambiente',
    SEARCH_CLIENT_KEY: 'Pesquisar cliente',
    SEARCH_OPERATOR_KEY: 'Pesquisar operador',

    PERMISSIONS_KEY: 'Permissões',
    PERMISSION_ROLES_KEY: 'Grupos de permissão',
    DO_NOT_HAVE_PERMISSION_KEY: 'Ação restrita',
    DO_NOT_HAVE_PERMISSION_MSG_KEY:
      'Você não tem permissão para executar essa ação',
    REMOVE_SELECTED_COMPANIES_KEY: 'Excluir companhias selecionadas',
    REMOVE_SELECTED_PARTNERS_KEY: 'Excluir contas selecionados',
    REMOVE_SELECTED_ENVIRONMENTS_KEY: 'Excluir ambientes selecionados',
    REMOVE_SELECTED_CLIENTS_KEY: 'Excluir clientes selecionados',
    REMOVE_SELECTED_OPERATORS_KEY: 'Excluir operadores selecionados',
    INFO_AUTOMATICALLY_ADDED_KEY:
      'Atenção! A opção habilitada automaticamente adiciona novos itens ao grupo',
    NEW_COMPANIES_KEY: 'novas companhias',
    NEW_PARTNERS_KEY: 'novas contas',
    NEW_ENVIRONMENTS_KEY: 'novos ambientes',
    NEW_CLIENTS_KEY: 'novos clientes',

    SELECT_ALL_COMPANIES_KEY: 'Selecionar todas as companhias para este grupo',
    SELECT_ALL_PARTNERS_KEY: 'Selecionar todas as contas para este grupo',
    SELECT_ALL_ENVIRONMENTS_KEY:
      'Selecionar todos os Ambientes para este grupo',
    SELECT_ALL_CLIENTS_KEY: 'Selecionar todos os clientes para este grupo',

    MONITOR: {
      INCIDENTS_PANEL_TITLE: 'Dashboard geral de acompanhamento',
      INCIDENTS_PANEL_FOLLOW_UP: 'Acompanhamento',
      INCIDENTS_PANEL_SUBTITLE:
        'Listagem de ambientes com possíveis problemas para análise',
      PARTNER_NAME: 'Conta',
      ENVIRONMENT_NAME: 'Ambiente',
      PROVIDER: 'Provedor',
      SEC_PROCESSED: 'Segundos processando',
      BLOCKED_ENVIRONMENTS_TITLE: 'Ambientes travados',
      NO_BLOCKED_ENVIRONMENTS: 'Nenhum ambiente travado',
      ROBO_TYPE: 'Tipo robô',
      STATUS: 'Status',
      INSTANCES: 'Instâncias',
      TEMPERATURE: 'Temperatura',
      CONNECTED: 'Conectados',
      LICENSES_TOTAL: 'Total de licenças',
      VACANCIES: 'Vagas',
      ENVIRONMENT_HEALTH_TITLE:
        'Consulta se existem ambientes com possível falta de máquina a serem analisados',
      NO_RESULTS_ENVIRONMENT_HEALTH: 'Nenhum ambiente a ser analisado',
      FLAVOR: 'Flavor',
      ZONE: 'Zona',
      COUNT: 'Quantidade',
      INSTANCES_STATUS_TITLE:
        'Instâncias com problemas na ativação na última hora para análise',
      INSTANCES_WITH_SESSION_TIMEOUT_TITLE:
        'Instâncias com múltiplas sessões expiradas',
      NO_RESULTS_INSTANCES: 'Sem resultados',
      CARD_ENVIRONMENT_HEALTH: 'Ambientes para análise',
      CARD_BLOCKED_ENVIRONMENTS: 'Ambientes travados',
      CARD_INSTANCES: 'Instâncias para análise',
      RELOAD: 'Recarregar',

      ENVIRONMENTS_TOTAL: 'Total de ambientes',
      INSTANCES_TOTAL: 'Total de instâncias',
      SESSIONS_TOTAL: 'Total de sessões',
      BLOCKED_QUEUES: 'Filas bloqueadas',
      ENVIRONMENTS_WITH_FAILED_ZERO_TRUST: 'Ambientes com falha no Zero Trust',
      BLOCKED_QUEUES_LIST_TITLE: 'Listagem de filas bloqueadas',
      BLOCKED_QUEUES_DESCRIPTION: 'Filas bloqueadas:',
      ANY_QUEUE_BLOCKED: 'Todas as filas estão operantes',

      ANALYZE_STATUS_KEY: 'Analizar',
      NORMAL_STATUS_KEY: 'Normal',
      TOTAL_FAILED_SESSIONS_KEY: 'Sessões com falhas',
      TOTAL_FAILED_SESSIONS_PERCENTAGE_KEY: 'Porcentagem com falha',
    },

    GROUPS_PAGE: {
      REMOVE_WARNING_MSG_KEY:
        '{{name}} será excluído e suas informações não poderão ser recuperadas.',
      ACTION_IS_IRREVERSIBLE_KEY:
        'Esta ação é irreversível, as informações não poderão ser recuperadas',

      LIST_GROUPS_TITLE_KEY: 'Grupos de permissões',
      LIST_GROUPS_SUBTITLE_KEY: 'Listagem de grupos de permissões',
      LIST_GROUPS_CONTENT_TITLE_KEY: 'Seus grupos',
      LIST_GROUPS_CONTENT_SUBTITLE_KEY:
        'Adicione grupos para gerenciar suas permissões',
      WANT_REMOVE_GROUP_KEY: 'Deseja excluir o grupo?',
      WANT_REMOVE_SELECTED_GROUPS_KEY: 'Deseja excluir os grupos selecionados?',
      NO_GROUPS_KEY: 'Nenhum grupo encontrado.',
      ADDED_GROUP_KEY: 'Grupo adicionado com sucesso!',
      REMOVED_GROUP_KEY: 'Grupo excluído com sucesso!',
      UPDATED_GROUP_KEY: 'Grupo atualizado com sucesso!',

      REMOVED_ITEMS_KEY: 'Itens excluídos com sucesso!',

      LIST_COMPANIES_TITLE_KEY: 'Lista de companhias',
      LIST_COMPANIES_SUBTITLE_KEY: 'Gerencie suas companhias',
      ADD_COMPANIES_KEY: 'Adicionar companhias',
      ADD_COMPANIES_SUBTITLE_KEY: 'Selecione e clique em adicionar',
      WANT_REMOVE_COMPANY_KEY: 'Deseja excluir a companhia?',
      WANT_REMOVE_SELECTED_COMPANIES_KEY:
        'Deseja excluir as companhias selecionadas?',
      LIST_COMPANY_PERMISSIONS_KEY: 'Gerencie as permissões de companhia',
      ADDED_COMPANIES_KEY: 'Companhias adicionadas com sucesso!',
      REMOVED_COMPANIES_KEY: 'Companhias excluídas com sucesso!',
      UPDATED_COMPANIES_KEY: 'Companhias atualizadas com sucesso!',

      LIST_PARTNERS_TITLE_KEY: 'Lista de contas',
      LIST_PARTNERS_SUBTITLE_KEY: 'Gerencie suas contas',
      ADD_PARTNERS_KEY: 'Adicionar contas',
      ADD_PARTNERS_SUBTITLE_KEY: 'Selecione e clique em adicionar',
      WANT_REMOVE_PARTNER_KEY: 'Deseja excluir a conta?',
      WANT_REMOVE_SELECTED_PARTNERS_KEY:
        'Deseja excluir as contas selecionadas?',
      LIST_PARTNER_PERMISSIONS_KEY: 'Gerencie as permissões da conta',
      ADDED_PARTNERS_KEY: 'Contas adicionadas com sucesso!',
      REMOVED_PARTNERS_KEY: 'Contas excluídas com sucesso!',
      UPDATED_PARTNERS_KEY: 'Contas atualizadas com sucesso!',

      LIST_ENVIRONMENTS_TITLE_KEY: 'Lista de ambientes',
      LIST_ENVIRONMENTS_SUBTITLE_KEY: 'Gerencie seus ambientes',
      ADD_ENVIRONMENTS_KEY: 'Adicionar ambientes',
      ADD_ENVIRONMENTS_SUBTITLE_KEY: 'Selecione e clique em adicionar',
      WANT_REMOVE_ENVIRONMENT_KEY: 'Deseja excluir o ambiente?',
      WANT_REMOVE_SELECTED_ENVIRONMENTS_KEY:
        'Deseja excluir os ambientes selecionados?',
      LIST_ENVIRONMENT_PERMISSIONS_KEY: 'Gerencie as permissões de ambiente',
      ADDED_ENVIRONMENTS_KEY: 'Ambientes adicionados com sucesso!',
      REMOVED_ENVIRONMENTS_KEY: 'Ambientes excluídos com sucesso!',
      UPDATED_ENVIRONMENTS_KEY: 'Ambientes atualizados com sucesso!',

      LIST_CLIENTS_TITLE_KEY: 'Lista de clientes',
      LIST_CLIENTS_SUBTITLE_KEY: 'Gerencie seus clientes',
      ADD_CLIENTS_KEY: 'Adicionar clientes',
      ADD_CLIENTS_SUBTITLE_KEY: 'Selecione e clique em adicionar',
      WANT_REMOVE_CLIENT_KEY: 'Deseja excluir o cliente?',
      WANT_REMOVE_SELECTED_CLIENTS_KEY:
        'Deseja excluir os clientes selecionados?',
      LIST_CLIENT_PERMISSIONS_KEY: 'Gerencie as permissões de clientes',
      ADDED_CLIENTS_KEY: 'Clientes adicionados com sucesso!',
      REMOVED_CLIENTS_KEY: 'Clientes excluídos com sucesso!',
      UPDATED_CLIENTS_KEY: 'Clientes atualizados com sucesso!',

      LIST_OPERATORS_TITLE_KEY: 'Lista de operadores',
      LIST_OPERATORS_SUBTITLE_KEY: 'Gerencie seus operadores',
      ADD_OPERATORS_KEY: 'Adicionar operadores',
      ADD_OPERATORS_SUBTITLE_KEY: 'Selecione e clique em adicionar',
      WANT_REMOVE_OPERATOR_KEY: 'Deseja excluir o operador?',
      WANT_REMOVE_SELECTED_OPERATORS_KEY:
        'Deseja excluir os operadores selecionados?',
      LIST_OPERATOR_PERMISSIONS_KEY: 'Gerencie as permissões de operador',
      ADDED_OPERATORS_KEY: 'Operadores adicionados com sucesso!',
      REMOVED_OPERATORS_KEY: 'Operadores excluídos com sucesso!',
      UPDATED_OPERATORS_KEY: 'Operadores atualizados com sucesso!',
      SELECT_ALL_KEY: 'Selecionar todas',
      FRONTEND_CUSTOMIZATION_KEY: 'Customização de front end',
      PREPARATION_SERVERS_KEY: 'Servidores de preparação',
      SUPPORT_SERVERS_KEY: 'Servidores de suporte',
      ALERTS_KEY: 'Alertas',
      MONITORS_KEY: 'Monitores',
      ASSOCIATE_KEY: 'Associado',
      NOT_ASSOCIATE_KEY: 'Não associado',

      CLONE_GROUP_KEY: 'Clonar grupo',
      CLONE_GROUP_NAME_KEY: 'Nome do novo grupo',
      CLONE_GROUP_TO_CLONE_KEY: 'Grupo a ser clonado',
      GROUP_CLONE_MESSAGE_KEY: 'O grupo foi clonado com sucesso',
    },
    LIST_ALL_MONITORS: 'Listar todos os monitores',
    CAN_APPLY_SCALING_ADVISOR: 'Aplicar Scaling Advisor',
    CAN_IGNORE_SCALING_ADVISOR: 'Ignorar Scaling Advisor',
    CAN_REVERT_SCALING_ADVISOR: 'Reverter Scaling Advisor',

    PENDING_ADVISORS_KEY: 'Otimizações pendentes',
    SUGGESTED_ADVISORS_KEY: 'Otimizações sugeridas',
    APPLIED_ADVISORS_KEY: 'Otimizações aplicadas',
    NEW_PENDING_ADVISORS_KEY: 'Novas otimizações pendentes',
    HISTORY_APPLIED_ADVISORS_KEY: 'Histórico de otimizações aplicadas',
    HISTORY_NOT_APPLIED_ADVISORS_KEY: 'Histórico de otimizações Não aplicadas',
    NO_ADVISOR_KEY: 'Nenhuma otimização encontrada.',
    EMPTY_INSTANCES_SUNDAY_KEY: 'Domingo',
    EMPTY_INSTANCES_SATURDAY_KEY: 'Sábado',
    EMPTY_INSTANCES_WEEKDAY_NIGHT_KEY: 'Semanal (noturno)',
    EMPTY_INSTANCES_WEEKDAY_KEY: 'Semanal',
    EMPTY_INSTANCES_ANY_DAY_KEY: 'Quinzenal',
    PENDING_KEY: 'Pendente',
    IGNORED_KEY: 'Ignorado',
    APPLIED_KEY: 'Aplicado',
    REVERTED_KEY: 'Revertido',
    NOT_APPLIED_KEY: 'Não aplicado',
    DEPRECIATED_KEY: 'Depreciado',
    EXPIRED_KEY: 'Depreciado',
    SUGGESTED_KEY: 'Sugerido',
    DEACTIVATED_KEY: 'Desativado',
    ON_DEMAND_KEY: 'Sob demanda',
    SUPPORT_SERVERS_KEY: 'Servidores de suporte',
    ENVIRONMENT_STATUS_KEY: 'Status do ambiente',
    ENVIRONMENTS_STATUS_KEY: 'Status dos ambientes',
    APPLIED_BY_KEY: 'Aplicado por',
    APPLIED_AT_KEY: 'Aplicado em',
    IGNORED_BY_KEY: 'Ignorado por',
    IGNORED_AT_KEY: 'Ignorado em',
    REVERTED_BY_KEY: 'Revertido por',
    REVERTED_AT_KEY: 'Revertido em',

    ADVISOR_PAGE: {
      LIST_ADVISORS_TITLE_KEY: 'Lista de otimizações',
      LIST_ADVISORS_SUBTITLE_KEY: 'Gerencie suas otimizações',

      DASHBOARD_TITLE_KEY: 'Otimizações de ambientes',
      DASHBOARD_SUBTITLE_KEY:
        'Gerencie a otimização dos ambientes em um único lugar',

      ENVIRONMENTS_WITH_PENDING_ADVISORS_KEY:
        'Ambientes com otimizações pendentes',
      TOTAL_ADVISORS_SUGGESTED_KEY: 'Total de otimizações',
      TOTAL_ADVISORS_APPLIED_KEY: 'Total de otimizações aplicadas (30 dias)',
      ESTIMATED_SAVINGS_FROM_SUGGESTED_KEY:
        'Economia estimada das otimizações sugeridas',

      WANT_APPLY_ADVISOR_KEY: 'Deseja aplicar a otimização?',
      CONFIRM_APPLY_ADVISOR_KEY:
        'Confirme abaixo para aplicar a otimização selecionada.',
      WANT_IGNORE_ADVISOR_KEY: 'Deseja ignorar a otimização?',
      CONFIRM_IGNORE_ADVISOR_KEY: 'Informe abaixo o motivo:',
      WANT_REVERT_ADVISOR_KEY: 'Deseja reverter a otimização?',
      CONFIRM_REVERT_ADVISOR_KEY:
        'Confirme abaixo para reverter a otimização selecionada.',
      ADVISOR_TYPE_DETAILS_KEY: 'Tipo de otimização',
      OPERATION_MODE_DETAILS_KEY: 'Modo de operação do ambiente',
      PERIOD_KEY: 'Períodos',
      MANUAL_KEY: 'Manual',
      MICRO_KEY: 'Micro',
      SPOT_PERIOD_KEY: 'Períodos (Spot)',
      OPTIMIZATION_DETAILS_KEY: 'Detalhes de otimização',
      ESTIMATED_COST_SAVINGS_KEY: 'Economia estimada',
      ADVISOR_TYPE_EXPLANATION_BUTTON_KEY: 'Entenda os tipos das otimizações',
      ADVISOR_TYPE_EXPLANATION_KEY:
        'Verifica se há instâncias em execução sem sessões de usuários durante os seguintes períodos para cada tipo de otimização:',
      ADVISOR_WEEKDAY_KEY: 'Otimização semanal:',
      ADVISOR_WEEKDAY_EXPLANATION_KEY:
        'Durante a noite nos últimos 15 dias úteis (segunda a sexta), das 22:00 às 06:00.',
      ADVISOR_SATURDAY_KEY: 'Otimização sábado:',
      ADVISOR_SATURDAY_EXPLANATION_KEY:
        'Durante os últimos 4 sábados, das 06:00 às 06:00 do domingo.',
      ADVISOR_SUNDAY_KEY: 'Otimização domingo:',
      ADVISOR_SUNDAY_EXPLANATION_KEY:
        'Durante os últimos 4 domingos, das 06:00 às 06:00 da segunda.',
      ADVISOR_ANYDAY_KEY: 'Otimização quinzenal:',
      ADVISOR_ANYDAY_EXPLANATION_KEY:
        'Durante os últimos 15 dias, das 00:00 às 23:59.',
      ADVISOR_COST_EXPLANATION_KEY:
        'Custo associado á não aplicação das otimizações pendentes',
      ADVISOR_MONTHLY_SAVINGS_KEY: 'Economia mensal estimada',
      ENVIRONMENTS_COST_TITLE_KEY: 'Custo total dos ambientes',
      MONTHLY_ENVIRONMENTS_COST_TITLE_KEY: 'Custo acumulado dos ambientes',
    },

    // API Advisor
    ADVISOR_APPLIED: 'Otimização aplicada com sucesso!',
    ADVISOR_IGNORED: 'Otimização ignorada com sucesso!',
    ADVISOR_REVERTED: 'Otimização revertida com sucesso!',
    SCALING_ADVISOR_APPLY_INCONSISTENT_PERIODS:
      'Este ambiente apresenta períodos inconsistentes no banco de dados',
    SCALING_ADVISOR_APPLY_INVALID_STATUS:
      'Status inválido do advisor, não foi possível aplicar otimização. Status deve ser "pendente".',
    SCALING_ADVISOR_APPLY_UNKNOWN_ENVIRONMENT:
      'Ambiente desconhecido para aplicação de otimização',
    SCALING_ADVISOR_APPLY_INVALID_ENVIRONMENT_OPERATION_MODE:
      'Modo de operação de ambiente inválido para aplicação de otimização',
    SCALING_ADVISOR_APPLY_UNKNOWN_BEHAVIOR_CALENDAR:
      'Calendário de comportamento desconhecido para aplicação de otimização',

    // API partner
    CANNOT_DELETE_PARTNER_WITH_ENVIRONMENT_ASSOCIATED:
      'Não é possivel excluir uma conta associada a um ambiente',

    // API companies
    CANNOT_DELETE_COMPANY_WITH_PARTNER_ASSOCIATED:
      'Não é possível excluir uma companhia associada a uma conta',
    ADD_COMPANY_SUCCESS_KEY: 'Companhia cadastrada com sucesso!',
    REMOVE_COMPANY_SUCCESS_KEY: 'Companhia excluída com sucesso!',

    // API clients
    OPERATOR_PASSWORD_TOO_WEAK: 'A senha escolhida é fraca',
    OPERATOR_ALREADY_EXISTS: 'Operador já existe',
    REMOVE_MULTIPLE_SESSIONS_KEY: 'As sessões selecionadas foram excluídas!',
    ENABLE_OR_DISABLE_SUCCESS_KEY: 'Perfil remoto {{activate}} com sucesso!',
    MFA_OPERATOR_ENABLE_KEY: 'O MFA foi ativado com sucesso!',
    MFA_OPERATOR_DISABLE_KEY: 'O MFA foi desativado com sucesso!',
    MFA_OPERATOR_RESET: 'O MFA foi redefinido com sucesso!',
    CANNOT_EDIT_USER_FIELDS: 'Usuário já cadastrado!',
    FICTITIOUS_USER_ADMINS_EMAILED:
      'O e-mail de redefinição de senha foi enviado aos administradores do cliente porque o usuário é fictício!',
    INVALID_USER: 'Usuário inválido',
    ENVIRONMENT_WITHOUT_VALID_VIRTUALIZER:
      'Ambiente sem um virtualizador válido',
    MISSING_FILTER_PARAMETER: 'Falta parâmetro de filtro',
    TEST_CONNECT_SUCCES_KEY: 'Teste de conexão realizado com sucesso!',
    ERROR_ON_VALIDATE_USER:
      'Erro ao validar o usuário. Entre em contato com o administrador da conta',
    ENVIRONMENT_WITHOUT_VALID_INSTANCE:
      'Ambiente não possui um servidor de preparação cadastrado, ou servidor de preparação está não operacional. Não é possível simular a aplicação. Verifique os servidores de preparação do ambiente.',
    USER_NOT_FOUND:
      'Usuário não encontrado, verifique se o e-mail fornecido está correto',
    USER_DISABLED: 'Esse usuário está desativado',
    LICENSES_LIMIT_KEY: 'O limite de licenças do cliente foi excedido',
    CLIENT_CLONE_MESSAGE_KEY: 'O cliente solicitado foi clonado com sucesso',
    PARTNER_CLONE_MESSAGE_KEY: 'A conta foi clonada com sucesso',
    CHANGE_AD_PASSWORD_MESSAGE_KEY:
      'A senha do usuário AD foi alterada com sucesso',
    CLIENT_REMOVED_KEY: 'O cliente foi excluído com sucesso!',
    WRONG_PARAMETERS:
      'Erro na solicitação. Por favor, entre em contato com o administrador.',
    CLIENT_WITH_USER_CANNOT_BE_DELETED:
      'Não é possível excluir um cliente com usuários associados a ele. Por favor, exclua os usuários deste cliente antes de solicitar a exclusão do cliente.',
    AD_GROUP_NOT_CREATED_KEY:
      'Não foi possível criar um grupo do Active Directory (AD) para este cliente',
    INVALID_PAYLOAD_APPLICATION_MODE:
      'Este cliente possui o cadastro de aplicativos configurado no modo "simples" e só pode aceitar argumentos de nome e estado. Se você precisar de configurações avançadas, primeiro altere o modo de aplicativo do ambiente do cliente para "avançado".',
    CLIENT_REALM_ID_ALREADY_EXISTS:
      'ID de domínio já está associado a um cliente',

    // API Authenticate
    PASSWORD_CHANGE_KEY:
      'Senha alterada com sucesso! Você será redirecionado para a página de login…',
    INVALID_TOKEN_KEY: 'Token inválido ou expirado',
    EMAIL_RECOVER_KEY:
      'Caso seu e-mail esteja cadastrado em nosso banco de dados, você receberá um e-mail para recuperar sua senha.',

    // API environment
    TOGGLE_BLOCK_UNBLOCK_INSTANCE_SUCCESS_KEY:
      'As instâncias foram bloqueadas / desbloqueadas com sucesso!',
    INSTANCE_IS_NOT_RUNNING: 'A instância não está em execução!',
    TERMINATE_MULTIPLE_INSTANCES_KEY:
      'As instâncias selecionadas foram terminadas com sucesso!',
    BLOCK_MULTIPLE_INSTANCES_KEY:
      'As instâncias selecionadas foram bloqueadas com sucesso!',
    UNBLOCK_MULTIPLE_INSTANCES_KEY:
      'As instâncias selecionadas foram desbloqueadas com sucesso!',
    SUCCESS_REMOVE_MULTIPLE_MODELS_KEY:
      'Os modelos selecionados foram excluídos com sucesso!',
    ENVIRONMENT_WITHOUT_GOVERNANCE:
      'Ambiente sem informações de governança cadastradas',
    TURNED_SERVER_MSG_KEY: 'Servidor transformado com sucesso!',
    ENABLE_MFA_TO_ALL_USERS_SUCCESS_KEY:
      'O MFA de todos os usuários foi ativado com sucesso!',
    DISABLE_MFA_TO_ALL_USERS_SUCCESS_KEY:
      'O MFA de todos os usuários foi desativado com sucesso!',
    FORBIDDEN_PROVIDER: 'Provedor não autorizado a realizar esta ação',
    SET_NEW_STOP_TIME_PREPARATION_SERVER:
      'Tempo de parada definido com sucesso!',
    CANCELED_SCHEDULED_STOP_PREPARATION_SERVER:
      'Cancelar parada programada do servidor de preparação',
    PREPARATION_SERVER_WITHOUT_STOP_TIME:
      'Servidor de preparação sem tempo de parada definido',
    CANNOT_DELETE_ENVIRONMENT_WITH_CLIENTS_ASSOCIATED:
      'Não é possível excluir um ambiente com clientes associados a ele. Por favor, remova os clientes do ambiente antes de solicitar a exclusão do ambiente.',
    ENVIRONMENT_ALREADY_WITH_PREPARATION_SERVER:
      'O ambiente já tem um servidor de preparação',
    CREATED_ENVIRONMENT: 'Ambiente criado com sucesso!',
    PROVIDER_RESOURCE_NOT_AVAILABLE_IN_PROVIDER:
      'Os recursos do provedor não está disponível no provedor deste ambiente',
    OPERATION_UNSUPPORTED: 'Operação não suportada',
    INSTANCE_OPERATION_ERROR: 'Erro de operação da instância',
    INIT_INSTANCE_MSG_SINGULAR_KEY: 'Iniciando {{numInstances}} instância...',
    INIT_INSTANCE_MSG_PLURAL_KEY: 'Iniciando {{numInstances}} instâncias...',
    CREATED_PREPARATION_SERVER: 'Servidor de preparação criado com sucesso!',
    CREATED_SUPPORT_SERVER: 'Servidor de suporte criado com sucesso!',
    DETACHED_SERVER: 'Servidor desvinculado com sucesso!',
    ATTACHED_SERVER: 'Servidor vinculado com sucesso!',
    ENVIRONMENTS_NOT_FOUND: 'Ambiente não encontrado para este operador',
    INVALID_TIME_RANGE: 'A data final deve ser superior à data inicial',
    INVALID_PERIOD_ERROR:
      'Período inválido, insira um período inferior a 6 horas.',
    ELASTICSEARCH_CONNECTION_ERROR: 'Erro ao conectar-se ao Elasticsearch.',

    INSTANCE_ACTIVATE_REQUESTED:
      'Requisição de ativação de instância enviada com sucesso!',
    INSTANCE_ACTIVATE_NOT_ALLOWED:
      'Erro ao ativar uma nova instância. Tente novamente mais tarde!',

    INSTANCE_ACTIVATE_ENVIRONMENT_BLOCKED:
      'O ambiente está ocupado com outra tarefa',
    UNREGISTER_INSTANCE_REQUESTED: 'Instância desvinculada com sucesso!',
    UNLINK_ERROR_KEY:
      'Erro ao desvincular uma instância. Tente novamente mais tarde!',
    SENT_WRONG_PARAMETERS:
      'Informações incorretas. Por favor, revise as informações e tente novamente!',

    INSTANCE_NOT_FOUND: 'Instância não encontrada',
    ENVIRONMENT_NOT_FOUND: 'Ambiente não encontrado',

    INSTANCE_REBOOT_REQUESTED:
      'Solicitação de reinicialização da instância enviada com sucesso!',
    INSTANCE_REBOOT_NOT_ALLOWED:
      'O ambiente não permite esta forma de reinicialização de instâncias',
    DISPLAY_ENV_WARNING:
      'A exibição do aviso de Manutenção foi {{active}} com sucesso!',
    MANUAL_ENV_WARNING:
      'A exibição do aviso de Manutenção Manual foi {{active}} com sucesso!',
    SCHEDULE_ENV_WARNING:
      'A exibição do aviso de Manutenção Programada foi {{active}} com sucesso!',
    CANCELED_SCHEDULED_STOP: 'Parada programada cancelada com sucesso',
    SET_NEW_STOP_TIME: 'Novo horário de parada definido com sucesso!',

    SECURITY_DEFAULTS_ERROR_KEY:
      'Erro ao cadastrar os padrões de segurança. Revise as informações e tente novamente mais tarde!',
    NEW_GOVERNANCE_ERROR_KEY:
      'Erro ao cadastrar as informações de governança. Por favor, revise as informações e tente novamente mais tarde!',
    GOVERNANCE_DEFAULTS_ERROR_KEY:
      'Erro ao editar governança. Tente novamente mais tarde!',

    SERVER_START_REQUESTED: 'Início do servidor solicitado com sucesso!',
    SERVER_STOP_REQUESTED: 'Parada do servidor solicitada com sucesso!',
    SERVER_RESTART_REQUESTED:
      'Reinicialização do servidor solicitada com sucesso!',
    EXTENDED_PREPARATION_SERVER: 'Horário de parada prorrogado com sucesso!',
    SERVER_NOT_FOUND:
      'Servidor não encontrado. Sincronize os dados com o provedor para garantir a integridade e atualiadade das informações.',
    SERVER_NOT_FOUND_ON_PROVIDER:
      'Servidor não encontrado no provedor. Desvincule o servidor ou crie no provedor.',
    SERVERS_NOT_FOUND_ON_PROVIDER:
      'Servidor(es) não encontrado(s) no provedor. Desvincule o servidor ou crie no provedor.',
    SERVER_IS_NOT_STOPPED: 'Servidor não está parado.',
    SERVER_IS_NOT_RUNNING: 'Servidor não está operacional.',
    SERVER_PROVIDER_TAG_CONFLICT:
      'A tag "{{tag}}" do servidor no provedor está incorreta ou não existe.',
    SERVER_TYPE_NOT_ALLOWED:
      'Você não tem permissão para executar esta ação neste tipo de servidor, ou esta ação não pode ser executada.',
    SERVER_BELONGS_TO_OTHER_ENVIRONMENT:
      'Este servidor já está vinculado a outro ambiente ({{environment_uuid}}). Desvincule-o antes de prosseguir.',
    MODEL_NOT_FOUND_AT_SERVER_START:
      'Publique uma imagem antes de iniciar o servidor.',
    INVALID_SERVER_STOP_TIME:
      'O horário de parada deve ser maior que o horário atual.',
    INVALID_PROVIDER_FOR_MODEL_TYPE_PUBLICATION:
      'Provedor inválido para o tipo de modelo de publicação.',
    CUSTOM_IMAGE_NOT_FOUND: 'Imagem customizada não encontrada',
    INVALID_ENVIRONMENT_MODEL: 'O modelo duplicado não é válido',
    CANNOT_DELETE_ENVIRONMENT_WITH_INSTANCES_ASSOCIATED:
      'Não é possível remover um ambiente com instâncias associadas. Por favor, remova as instâncias do ambiente antes de solicitar a exclusão do ambiente',
    INVALID_OPERATOR_PASSWORD: 'Senha de operador inválida',
    OPERATOR_WITHOUT_PERMISSION:
      'Seu operador não faz parte de nenhum grupo de permissão. Entre em contato com o administrador da conta.',

    API_TOKEN_CREATED: 'Token de API criado com sucesso: {{token}}',
    TOKEN_REMOVE_SUCCESS_KEY: 'Token excluído com sucesso!',
    INVALID_PARTNER: 'Conta inválida',
    INVALID_IPS_ADDRESS: 'Endereços de IP inválidos',
    OPERATOR_PASSWORD_DOES_NOT_MATCH: 'Senha do operador não coincide',
    CLIENT_APPLICATIONS_TYPE_IS_NOT_PLATFORM:
      'O tipo de aplicativo do cliente não é plataforma',

    // API group
    AD_GROUP_NOT_CREATED: 'Não foi possível adicionar grupo no AD',
    SALT: {
      SALT_TOGGLE_KEY: 'Ignorar Salt',
      FALSE_ACTIVATE_SALT_KEY: 'Ativar Salt nos usuários',
      WARNING_FALSE_ACTIVATE_SALT_KEY:
        'Ao ativar o Salt, a senha dos usuários receberá um complemento aumentando o nível de segurança mitigando o risco de invasões.',
      TRUE_ACTIVATE_SALT_KEY: 'Desativar Salt nos usuários',
      WARNING_TRUE_ACTIVATE_SALT_KEY:
        'Ao desativar o Salt, o Salt não será mais considerado durante as autenticações de acesso nas instâncias pelos usuários, aumentando o risco de invasão.',
      REASON_SALT_KEY: 'Motivo',
      SHORT_WARNING_TRUE_ACTIVATE_SALT_KEY:
        'Ao desativar o Salt, o Salt não será mais considerado durante as autenticações de acesso nas instâncias.',
      REASON_TO_SKIP_KEY: 'Motivo da inativação do Salt',
    },
    INVALID_PASSWORD: 'Senha inválida',
    ACCESS_KEY: 'Acessar',

    // AdminView
    SEARCH_ALL_KEY: 'Pesquisar',
    LIST_ALL_KEY: 'Listar todos',

    ENVIRONMENT_DASHBOARD: {
      LAST_1D: 'Últimas 24 horas',
      LAST_2D: 'Últimas 48 horas',
      LAST_7D: 'Últimos 7 dias',
      LAST_15D: 'Últimos 15 dias',
      LAST_30D: 'Últimos 30 dias',
      LAST_60D: 'Últimos 60 dias',
      LAST_90D: 'Últimos 90 dias',
      LAST_180D: 'Últimos 180 dias',

      SESSIONS_AVG_KEY: 'Sessões (média)',
      VACANCIES_AVG_KEY: 'Vagas (média)',
      SESSIONS_MAX_KEY: 'Sessões',
      VACANCIES_MAX_KEY: 'Vagas',

      ENVIRONMENT_USE_KEY: 'Detalhes de utilização do ambiente',

      ENVIRONMENT_COST_TITLE_KEY: 'Custo do ambiente',
      ENVIRONMENT_COST_DETAILS_KEY: 'Detalhes do custo do ambiente',
      ENVIRONMENT_COST_TOTAL_KEY: 'Custo total',

      SESSION_HISTORY_TITLE_KEY: 'Histórico de sessões',
    },
    ERROR_AD_GROUP_NOT_DELETED:
      'Erro ao deletar o grupo relacionado ao Active Directory. Por favor, contacte o administrador.',
    USERS_PAGE: {
      LIST_ALL_USERS_KEY: 'Lista de usuários',
      LIST_ALL_USERS_SUBTITLE_KEY:
        'Relação de todos os usuários de todos os clientes disponíveis',
      USERS_MANAGEMENT_TITLE_KEY: 'Gerenciamento de usuários',
      USERS_MANAGEMENT_SUBTITLE_KEY:
        'Gerencie os usuários inativos ou recupere os excluídos',
      SELECTED_USERS_KEY: 'Usuários selecionados',
      NO_USERS_KEY: 'Nenhum usuário encontrado',
      MANAGE_USERS_KEY: 'Gerenciar usuários',
      DELETE_ALL_BUTTON_KEY: 'Excluir em todos os clientes',
      DELETE_BUTTON_KEY: 'Excluir usuário neste cliente',
      DELETE_ALL_MODAL_TITLE_KEY: 'Excluir usuário em todos os clientes?',
      DELETE_ALL_MODAL_CONTENT_KEY:
        'Este usuário será excluído de todos os clientes em que você possui permissão de gerenciamento.',
      DELETE_MULTIPLE_USERS_ACTION_KEY: 'Excluir usuários selecionados',
      DELETE_MULTIPLE_USERS_PERMANENTLY_ACTION_KEY:
        'Excluir permanentemente os selecionados',
      DELETE_MULTIPLE_USERS_MODAL_TITLE_KEY:
        'Exclusão dos usuários nos clientes',
      DELETE_MULTIPLE_USERS_MODAL_CONTENT_KEY:
        'Deseja excluir os {{ count }} usuários selecionados nos clientes?',
      DELETION_REQUESTED_KEY: 'As exclusões foram solicitadas com sucesso.',
      LIST_USER_RECOVERIES_KEY: 'Listar recuperações de usuários',
      DELETED_USERS_TITLE_KEY: 'Lista de usuários excluídos',
      DELETED_USERS_SUBTITLE_KEY: 'Lista de usuários excluídos nos clientes',
      SELECTED_REGISTERS_KEY: 'Registros selecionados',
      RECOVER_USER_ACTION_KEY: 'Recuperar usuário no cliente',
      RECOVER_USER_MODAL_TITLE_KEY: 'Recuperação do usuário no cliente',
      RECOVER_USER_MODAL_CONTENT_KEY:
        'Deseja recuperar o usuário selecionado no cliente?',
      RECOVER_MULTIPLE_USERS_ACTION_KEY: 'Recuperar os selecionados',
      RECOVER_MULTIPLE_USERS_MODAL_TITLE_KEY:
        'Recuperação dos usuários nos clientes',
      RECOVER_MULTIPLE_USERS_MODAL_CONTENT_KEY:
        'Deseja recuperar os {{ count }} usuários selecionados nos clientes?',
      RECOVER_USER_BY_REQUEST_ACTION_KEY:
        'Recuperar todos os usuários da requisição',
      RECOVER_USER_BY_REQUEST_MODAL_TITLE_KEY:
        'Recuperação dos usuários excluídos na requisição',
      RECOVER_USER_BY_REQUEST_MODAL_CONTENT_KEY:
        'A requisição {{ requestUuid }} possui {{ count }} recuperações disponíveis. Deseja continuar?',
      RECOVERY_REQUESTED_KEY: 'As recuperações foram solicitadas com sucesso',
      REMOVE_USER_PERMANENTLY_KEY: 'Excluir usuário permanentemente',
      REMOVE_USER_PERMANENTLY_MODAL_TITLE_KEY: 'Exclusão permanente do usuário',
      REMOVE_USER_PERMANENTLY_DESCRIPTION_KEY:
        'Esta ação é irreversível e as informações não poderão ser recuperadas',
      REMOVE_MULTIPLE_USERS_PERMANENTLY_DESCRIPTION_KEY:
        'Você está prestes a excluir permanentemente {{ counter }} usuários únicos associados aos registros selecionados. Deseja continuar?',
    },

    LIST_ALL_MENU: {
      LIST_ALL_ENVIRONMENTS_KEY: 'Listar ambientes',
      LIST_ALL_COMPANIES_KEY: 'Listar companhias',
      LIST_ALL_PARTNERS_KEY: 'Listar contas',
      LIST_ALL_CLIENTS_KEY: 'Listar clientes',
      LIST_ALL_USERS_KEY: 'Listar usuários',
    },

    ACTIVE_SSO_DESCRIPTION: 'Login por SSO (Single Sign On)',
    SSO_KEY_LONG: 'Single Sign On',

    SSO: {
      FEDERATION_TYPE: 'Tipo de federação',
      CLIENT_REALM_ID: 'ID de domínio do cliente',

      SAML_URL_SECTION_TITLE:
        'SAML - Configurações de redirecionamento de site para login externo (URLs)',
      IDP_ENTITY_IDP: 'ID da entidade do (IdP)',
      SAML_IDP_SINGLE_SIGN_ON_URL: 'URL de login do (IdP)',
      SAML_IDP_SINGLE_LOGOUT_URL: 'URL de logout do (IdP)',
      SAML_X509_CERTIFIED: 'Certificado público x509 do (IdP)',

      SAML_ACCESS_TITLE: 'SAML - Configurações de restrições de acesso',
      RESTRICT_ACCESS_BY_GROUPS:
        'Restringir o acesso apenas para usuários de um grupo específico?',
      ALLOW_USERS_FROM_GROUP: 'UUID do grupo de usuários permitidos',

      SAML_CLAIM_TYPES_TITLE:
        'SAML - Configurações de atributos dos usuários (Claim types)',
      SAML_IDP_CLAIM_NAME_ID: 'URL do atributo [Name ID] (IdP)',
      SAML_IDP_CLAIM_NAME_GIVEN_NAME: 'URL do atributo [Given name] (IdP)',
      SAML_IDP_CLAIM_SURNAME: 'URL do atributo [Surname] (IdP)',
      SAML_IDP_CLAIM_EMAIL_ADDRESS: 'URL do atributo [Email] (IdP)',
      SAML_IDP_CLAIM_GROUPS: 'URL do atributo [Groups] (IdP)',
    },

    WEIGHT_KEY: 'Peso',

    // USER THEME ERRORS

    CANNOT_DELETE_PARTNER_WITH_PARTNER_ENVIRONMENT_ASSOCIATED:
      'Não é possível excluir um parceiro com um ambiente associado',
    USER_THEME_CONFIG_NOT_FOUND:
      'Configuração de tema do usuário não foi encontrada',
    SUBDOMAIN_NOT_AVAILABLE: 'Subdomínio não disponível',
    SUBDOMAIN_DNS_NOT_CREATED: 'Subdomínio DNS não foi criado',
    SUBDOMAIN_ALTERNATE_DOMAIN_NOT_CREATED:
      'Domínio alternativo do subdomínio não foi criado',
    SUBDOMAIN_DNS_NOT_REMOVED: 'Subdomínio DNS não foi removido',
    SUBDOMAIN_ALTERNATE_DOMAIN_NOT_REMOVED:
      'Domínio alternativo do subdomínio não foi removido',
    EMAIL_KEY_WARNING_APPLICATION: 'Emails para aviso de conclusão',
    INSTANCES_HISTORY_GRAPH_KEY: 'Histórico de instâncias',
    CREATED_CLIENTS_BY_PERIOD_KEY: 'Crescimento no período: {{percentage}}',
    CREATED_CLIENTS_KEY: 'Clientes criados:',
    CREATED_USERS_KEY: 'Usuários criados:',
    HISTORY_SOP_KEY: 'Histórico',

    INVALID_CAPTCHA_TOKEN: 'Erro no login. Por favor, tente novamente',
    INVALID_PERIODS: 'Período inválido. Por favor, tente novamente',
    ACCOUNT_INFORMATION_KEY: 'Informações da conta',

    NO_PERMISSIONS_IN_GROUP_KEY:
      'Este template não possui autorização para gerenciar permissões',

    ACTIVATE_MFA_KEY: 'Ativar MFA',
    MFA_ACTIVATED_SUCCESSFULLY_KEY: 'MFA ativado!',
    MFA_INACTIVATED_SUCCESSFULLY_KEY: 'MFA desativado!',
    ACTIVATE_MFA_MODAL_MESSAGE_KEY:
      'Deseja ativar o MFA do operador {{firstName}} {{lastName}}?',

    REMOVE_USER_SESSION_KEY: 'Remover sessões de usuários',

    MINIMUM_SESSION_AGE_KEY: 'Tempo mínimo da sessão (horas)',
    RUN_TIME_KEY: 'Horário de execução',

    AUDIT_SESSION: {
      AUDIT_KEY: 'Auditoria',
      OS_KEY: 'SO',
      BROWSER_KEY: 'Navegador',
      UPDATED_BY_KEY: 'Atualizado por',
      TIME_AT_KEY: 'às',
      AT_KEY: 'à',
      ON_KEY: 'em',
    },

    MANAGE_PERMISSIONS_OPERATOR_KEY:
      'Selecione uma role para poder selecionar o grupo de permissão correspondente',

    OPERATOR_HAS_UPPER_ROLE_PERMISSION:
      'Este operador está presente em um grupo com template de permissão maior do que a role selecionada. Remova o grupo selecionado primeiro.',
    SELECT_PARTNER_DASHBOARD:
      'Selecione uma conta para visualizar os dados do dashboard',

    CLIENT_DATA_KEY: 'Dados do cliente',
    CLIENT_DATA_SUMMARY_KEY: 'Resumo',
    GENERATE_PDF: 'Gerar PDF',
    EXPORT_PDF_KEY: 'Exportar PDF',

    LOGS_PAGE: {
      LIST_LOGS_KEY: 'Auditoria',
      LIST_LOGS_TITLE_KEY: 'Auditoria',
      LIST_LOGS_SUBTITLE_KEY: 'Detalhes de ações nos recursos',
      NO_LOGS_KEY: 'Nenhum registro encontrado',
      RESOURCE_KEY: 'Recurso',
      RESOURCE_TYPE_KEY: 'Tipo de recurso',
      FILTERS_KEY: 'Filtros',
      DETAILS_KEY: 'Detalhes',
      MODAL_DETAILS_TITLE_KEY: 'Detalhes do registro',
      CHANGES_KEY: 'Alterações',
      CHANGED_FIELD_KEY: 'Campo alterado',
      PUBLISHED_SETTINGS_KEY: 'Configurações publicadas',
      OLD_VALUE_KEY: 'Valor anterior',
      NEW_VALUE_KEY: 'Novo valor',
      ACTIVE_KEY: 'Ativo',
      INACTIVE_KEY: 'Inativo',
      VALUE_KEY: 'Valor',
      LIST_LOGS_ENVIRONMENT_KEY: 'Detalhes de ações no ambiente',
      LIST_LOGS_CLIENTS_KEY: 'Detalhes de ações no cliente',
      EVERY_USER_ALREADY_USING_REASON_KEY:
        'Todos os usuários estão acessando o Portal 2.0',

      RESOURCES: {
        CLIENT_KEY: 'Cliente',
        COMPANY_KEY: 'Companhia',
        ENVIRONMENT_KEY: 'Ambiente',
        OPERATOR_KEY: 'Operador',
        PARTNER_KEY: 'Conta',
        USER_KEY: 'Usuário',
        MODEL_KEY: 'Modelo',
        ENVIRONMENT_APPLICATION_KEY: 'Aplicação do ambiente',
        CLIENT_APPLICATION_KEY: 'Aplicações do cliente',
        USER_SESSION_KEY: 'Sessões do usuário',
        PARTNER_USER_THEME_CONFIG_KEY: 'Front customizado do parceiro',
        OPERATOR_ROLE_KEY: 'Grupo',
        OPERATOR_ROLE_OBJECTS_KEY: 'Contexto de grupo',
        OPERATOR_ROLE_PERMISSION_KEY: 'Permissão de grupo',
      },

      ACTIONS: {
        CREATE_RESOURCE_KEY: 'Criação',
        UPDATE_RESOURCE_KEY: 'Edição',
        DELETE_RESOURCE_KEY: 'Exclusão',
        PUBLISH_RESOURCE_KEY: 'Publicação',
        MIGRATE_RESOURCE_KEY: 'Migração de ambiente',
      },

      FIELDS: {
        CODES_ADDED_KEY: 'Permissão adicionada',
        CODES_REMOVED_KEY: 'Permissão removida',
        COMPANY_UUID_KEY: 'ID da companhia',
        CLOUD_PROVIDERS_KEY: 'Provedor de nuvem',
        PLUGIN_KEY: 'Utilizar plugin customizado?',
        FRONTEND_KEY: 'Utilizar nova interface?',
        ALLOW_SSO_CONFIGURATION_KEY: 'Permite configurar SSO',
        SCALE_INSTANCES_KEY: 'Modelo',
        TRUSTED_USERS_KEY: 'Usuários administrativos',
        ZERO_TRUST_KEY: 'Zero Trust',
        EXTERNAL_CLIENT_CODE_KEY: 'Código externo do cliente',
        COPY_ADMIN_KEY:
          'Sempre copiar o administrador cadastrado para o cliente nas comunicações por e-mail',
        AUDITING_KEY: 'Bloquear múltiplas instâncias do mesmo usuário?',
        AD_PASSWORD_SALT_KEY: 'Ignorar Salt',
        USE_PROFILE_KEY: 'Perfil Remoto',
        BLOCKED_KEY: 'Bloquear operador',
        UPDATED_DATE_KEY: 'Data da última atualização',
        MFA_REQUIRED_KEY: 'Ativar MFA',
        FAVICON_IMAGE_KEY: 'Favicon',
        MESSAGES_IMAGE_KEY: 'Mensagem',
        USE_BROWSER_LANGUAGE_KEY: 'Usar idioma do navegador',
        REGISTRATION_SOURCE_KEY: 'Cadastro através de',
        REGISTRATION_MODE_KEY: 'Modo de cadastro',
        UPDATED_BY_OPERATOR_KEY: 'Atualizado por',
        OPERATOR_UUID_KEY: 'Uuid do operador',
        CLIENT_UUID_KEY: 'ID do cliente',
        PARTNER_UUID_KEY: 'ID da conta',
        ENVIRONMENT_UUID_KEY: 'ID do ambiente',
        LOGO_IMAGE_KEY: 'Logo da conta',
        SECONDARY_COLOR_KEY: 'Cor secundária',
        SECONDARY_DARK_COLOR_KEY: 'Cor secundária escura',
        SECONDARY_LIGHT_COLOR_KEY: 'Cor secundária clara',
        BACKGROUND_IMAGE_KEY: 'Banner de login',
        MAINTENANCE_IMAGE_KEY: 'Imagem de manutenção',
        PRIMARY_DARK_COLOR_KEY: 'Cor primária escura',
        PRIMARY_LIGHT_COLOR_KEY: 'Cor primária clara',
        SECONDARY_CONTRAST_TEXT_COLOR_KEY:
          'Cor secundária do título dos ambientes',
      },
    },
    PERMISSION_KEY: 'Permissão',

    ACTIVE_DNS_WARN_KEY:
      'A opção de DNS está ativada e o virtualizador selecionado é o {{virtualizer}}. Deseja continuar?',

    CANT_DELETE_MODEL_KEY:
      'Não é possível excluir o modelo primário. Altere-o nas configurações do ambiente.',
    MFA_RESET_SUCCESS_KEY: 'MFA resetado com sucesso!',
    COSTS_PAGE: {
      DASHBOARD_TITLE_KEY: 'Dashboard de custos',
      ENVIRONMENTS_COST_TITLE_KEY: 'Custo dos ambientes',
      FLAVORS_COST_TITLE_KEY: 'Custo dos flavors',
      NO_RESULTS: 'Sem resultados',
      COST_KEY: 'Custo',
      COSTS_KEY: 'Custos',
      COST_PERCENTAGE_KEY: 'Porcentagem do custo',
      FLAVOR_DETAILS_KEY: 'Detalhes do flavor',
      SELECTED_FLAVOR_KEY: 'Flavor selecionado',
    },

    INSTANCE_SECONDS_KEY: '{{seconds}} segundos',
    INSTANCE_DATE_STATUS_KEY: 'Dados de tempo da instância',
    DATE_TIME_START_KEY: 'Data de inicialização',
    DATE_TIME_OPERATIONAL_KEY: 'Data de operacionalização',
    TIME_TO_START_OPERATIONAL_KEY: 'Tempo para operacionalização',
    TIME_OPERATIONAL_KEY: 'Tempo operacional',
    INSTANCE_DAY_KEY: 'dia',
    INSTANCE_HOUR_KEY: 'hora',
    INSTANCE_MINUTE_KEY: 'minuto',
    INSTANCE_SECOND_KEY: 'segundo',

    SELECT_KEY: 'Selecionar',
    APPLY_DATE_FILTERS_KEY: 'Aplicar filtro de data',

    APPLICATIONS_CLIENTS_COUNT_KEY: 'Quantidade de clientes',
    APPLICATIONS_CLIENTS_MODAL_TITLE_KEY: 'Lista de clientes de {{app_name}}',
    APPLICATIONS_NAME_KEY: 'Aplicação',
    PDF_GENERATED_AT_KEY: 'PDF gerado em',
    PDF_GENERATED_SUCCESSFULLY_KEY: 'PDF gerado com sucesso!',
    RENAME_KEY: 'Renomear',
    RENAME_APP_KEY: 'Renomear aplicação {{app_name}}',
    CURRENT_NAME_KEY: 'Nome atual',
    NEW_NAME_KEY: 'Novo nome',
    RENAME_APP_SUCCESSFULLY_KEY: 'Aplicação renomeada com sucesso!',
    ENVIRONMENT_APPS_LISTING_KEY: 'Aplicações do ambiente',
    ENVIRONMENT_APPS_LISTING_SUBTITLE_KEY:
      'Listagem de todas as aplicações de todos os clientes deste ambiente',
    REMOVE_APP_KEY: 'Remover',
    REMOVE_APP_NAME_KEY: 'Remover aplicação {{app_name}}',
    REMOVE_APP_CONFIRMATION_KEY:
      'Tem certeza que deseja remover a aplicação {{app_name}}?',
    REMOVE_APP_SUCCESSFULLY_KEY: 'Aplicação removida com sucesso!',
    ACTIVATE_INACTIVATE_KEY: 'Ativar/Inativar',
    INACTIVATE_KEY: 'Inativar',
    ACTIVATE_IN_ALL_CLIENTS_KEY: 'Ativar aplicação em todos os clientes?',
    INACTIVATE_IN_ALL_CLIENTS_KEY: 'Inativar aplicação em todos os clientes?',
    ACTIVATED_SUCCESSFULLY_KEY: 'Ativação realizada com sucesso!',
    INACTIVATED_SUCCESSFULLY_KEY: 'Inativação realizada com sucesso!',
    APPLICATIONS_CLIENTS_CHANGE_STATE_MODAL_TITLE_KEY:
      'Lista de clientes de {{app_name}} para alterar status',
    INCLUDE_CLIENT_KEY: 'Incluir cliente',
    INCLUDE_CLIENT_ACTIVE_KEY: 'Incluir ativo',
    INCLUDE_CLIENT_INACTIVE_KEY: 'Incluir inativo',
    INCLUDE_IN_ALL_CLIENTS_KEY: 'Incluir aplicação em todos os clientes',
    INCLUDE_SUCCESSFULLY_KEY: 'Incluído com sucesso!',
    INCLUDE_KEY: 'Incluir',
    APPLICATIONS_CLIENTS_INCLUDE_MODAL_TITLE_KEY:
      'Lista de clientes disponíveis para incluir em {{app_name}}',
    SUBDOMAIN_REGEX_RULE_KEY:
      'O campo deve conter apenas letras minúsculas, pode possuir letras, números e hífen, com a restrição de iniciar com uma letra, terminar com uma letra ou número e não ter mais de um hífen consecutivo.',

    APPLICATIONS_CLIENTS_REMOVE_CONFIRMATION_TITLE_KEY:
      'Confirmar remoção de {{app_name}}',
    APPLICATIONS_CLIENTS_REMOVE_CONFIRMATION_KEY:
      'Tem certeza que deseja remover a aplicação {{app_name}}?',
    CONFIRM_REMOVE_KEY: 'Confirmar remoção',
    APPLICATIONS_CLIENTS_RENAME_CONFIRMATION_TITLE_KEY:
      'Confirmar renomeação de {{app_name}}',
    APPLICATIONS_CLIENTS_RENAME_CONFIRMATION_KEY:
      'Tem certeza que deseja renomear a aplicação {{app_name}} para {{new_app_name}}?',
    CONFIRM_RENAME_KEY: 'Confirmar renomeação',
    APPLICATIONS_CLIENTS_ACTIVE_CONFIRMATION_TITLE_KEY:
      'Confirmar ativação em {{app_name}}',
    APPLICATIONS_CLIENTS_INACTIVE_CONFIRMATION_TITLE_KEY:
      'Confirmar inativação em {{app_name}}',
    APPLICATIONS_CLIENTS_ACTIVE_CONFIRMATION_KEY:
      'Tem certeza que deseja ativar {{app_name}} para estes clientes?',
    APPLICATIONS_CLIENTS_INACTIVE_CONFIRMATION_KEY:
      'Tem certeza que deseja inativar {{app_name}} para estes clientes?',
    CONFIRM_ACTIVE_KEY: 'Confirmar ativação',
    CONFIRM_INACTIVE_KEY: 'Confirmar inativação',
    APPLICATIONS_CLIENTS_INCLUDE_CONFIRMATION_TITLE_KEY:
      'Confirmar inclusão em {{app_name}}',
    APPLICATIONS_CLIENTS_INCLUDE_CONFIRMATION_KEY:
      'Tem certeza que deseja incluir estes clientes na aplicação {{app_name}}?',
    CONFIRM_INCLUDE_KEY: 'Confirmar inclusão',
    INCLUDE_NEW_APP_KEY: 'Incluir nova aplicação',
    APP_TO_BE_INCLUDED_KEY: 'Nome da aplicação a ser incluída',
    CONFIRM_INCLUSION_OF_TITLE_KEY: 'Confirmar inclusão de {{app_name}}',
    CONFIRM_INCLUSION_OF_KEY:
      'Tem certeza que deseja incluir a aplicação {{app_name}}?',
    ATTACHED_KEY: 'Vinculado',
    DETACHED_KEY: 'Desvinculado',
    ATTACH_SUCCESSFULLY_KEY: 'Vinculado com sucesso!',
    DETACH_SUCCESSFULLY_KEY: 'Desvinculado com sucesso!',
    ENVIRONMENT_ADMIN_TITLE_KEY: 'Administração do ambiente',
    CURRENT_ACCOUNT_KEY: 'Conta de origem:',
    NEW_ACCOUNT_KEY: 'Conta de destino:',
    MIGRATE_ENVIRONMENT_BUTTON_KEY: 'Alterar conta do ambiente',
    MIGRATE_ENVIRONMENT_KEY: 'Migração de ambiente',
    MIGRATION_OF_ENVIRONMENT_KEY: 'Migração do ambiente {{environment_name}}',
    MIGRATION_MODAL_TEXT_KEY: 'Tem certeza de que deseja migrar o ambiente: ',
    MIGRATION_ORIGIN_KEY: 'Origem',
    MIGRATION_DESTINATION_KEY: 'Destino',
    MIGRATION_PARTNER_KEY: 'Conta:',
    MIGRATION_COMPANY_KEY: 'Companhia:',
    MIGRATION_TO_CONFIRM_KEY:
      'Para confirmar a migração, informe no campo abaixo o motivo da ação:',
    CONFIRM_MIGRATION_KEY: 'Confirmar migração',
    MIGRATION_HISTORY_SUBTITLE_KEY: 'Histórico de migrações do ambiente',
    MIGRATION_DATE_KEY: 'Data de Migração',
    ORIGIN_COMPANY_KEY: 'Companhia Origem',
    DESTINATION_COMPANY_KEY: 'Companhia Destino',
    ORIGIN_PARTNER_KEY: 'Conta Origem',
    DESTINATION_PARTNER_KEY: 'Conta Destino',
    MIGRATE_ENVIRONMENT_BUTTON_BELLOW_KEY:
      'Clique no botão abaixo para configurar a migração deste ambiente',
    UNEQUAL_PARTNER_SETTINGS:
      'As configurações da conta destino não coincidem com as da conta atual',
    PROVIDER_AWS_SETTINGS_KEY:
      'Regra 1: As Configurações do Provedor de Nuvem AWS: Role arn, AWS Owner ID, External ID.',
    PROVIDER_OCI_SETTINGS_KEY:
      'Regra 2: As Configurações do Provedor de Nuvem OCI: Compartment ID.',
    ACTIVE_DIRECTORY_SETTINGS_KEY:
      'Regra 3: O tipo de LDAP da Conta e as Configurações de LDAP (Active Directory): LDAP Server, Admin bind pass, Admin DN, LDAP Server Backup, Base DN, Domínio.',
    SALT_SETTINGS_KEY:
      'Regra 4: A configuração de Salt: Ativar Salt nos usuários.',
    SSO_SETTINGS_KEY: 'Regra 5: A configuração de SSO: Permite configurar SSO.',
    NEW_FRONT_SETTINGS_KEY:
      'Regra 6: A configuração de Utilizar nova interface: Usar front novo.',
    ENVIRONMENT_SUCCESSFULLY_MIGRATED_KEY: 'Ambiente migrado com sucesso!',
    MIGRATION_REASON_KEY: 'Motivo da migração',
    WARN_MIGRATION_RULES_KEY:
      'As seguintes configurações, presentes na tela de edição de conta, precisam ser idênticas entre a conta de origem e destino:',
    RULE_MIGRATION_ONE_KEY:
      'As Configurações do Provedor de Nuvem AWS: Role arn, AWS Owner ID, External ID.',
    RULE_MIGRATION_TWO_KEY:
      'As Configurações do Provedor de Nuvem OCI: Compartment ID.',
    RULE_MIGRATION_THREE_KEY:
      'O tipo de LDAP da Conta e as Configurações de LDAP (Active Directory): LDAP Server, Admin bind pass, Admin DN, LDAP Server Backup, Base DN, Domínio.',
    RULE_MIGRATION_FOUR_KEY:
      'A configuração de Salt: Ativar Salt nos usuários.',
    RULE_MIGRATION_FIVE_KEY: 'A configuração de SSO: Permite configurar SSO.',
    RULE_MIGRATION_SIX_KEY:
      'A configuração de Utilizar nova interface: Usar front novo.',
    RULE_ONE_KEY: 'Regra 1: ',
    RULE_TWO_KEY: 'Regra 2: ',
    RULE_THREE_KEY: 'Regra 3: ',
    RULE_FOUR_KEY: 'Regra 4: ',
    RULE_FIVE_KEY: 'Regra 5: ',
    RULE_SIX_KEY: 'Regra 6: ',

    ERROR_MIGRATION_RULES_KEY:
      'Não foi possível migrar este ambiente para a conta selecionada devido às seguintes configurações divergentes da conta atual:',
    ERROR_MIGRATION_RULES_SOLUTION_KEY:
      'Por favor, configure a conta de destino para que atenda as mesmas configurações da conta atual, e tente novamente.',
    CHOOSE_ANOTHER_PARTNER: 'Escolher outra conta',
    DISMISS_KEY: 'Descartar',
    ORIGIN_AND_DESTINATION_PARTNER_CANT_BE_EQUAL:
      'As contas de origem e destino não podem ser iguais.',
    CURRENT_PARTNER_CONFIG_KEY: 'Configurações da conta atual',

    DYNAMIC_FILTER: {
      CLEAN_FILTERS_KEY: 'Limpar filtros',
      CLEAN_ALL_KEY: 'Limpar todos',
      SELECT_ALL_KEY: 'Selecionar todos',
      FILTER_BUTTON_KEY: 'Filtros dinâmicos',
      USER_UUID_KEY: 'ID do usuário',
      AD_USERNAME_KEY: 'Usuário AD',
      SALT_CONFIGURED_KEY: 'Salt configurado',
      YES_KEY: 'Sim',
      NO_KEY: 'Não',
      PARTNER_UUID_KEY: 'ID da conta',
      PARTNER_NAME_KEY: 'Nome da conta',
      MFA_CONFIGURED_KEY: 'MFA configurado',
      FIRST_NAME_KEY: 'Primeiro nome',
      LAST_NAME_KEY: 'Sobrenome',
      ENVIRONMENT_NAME_KEY: 'Nome do ambiente',
      ENVIRONMENT_UUID_KEY: 'ID do ambiente',
      EMAIL_KEY: 'Email',
      COMPANY_UUID_KEY: 'ID da companhia',
      COMPANY_NAME_KEY: 'Nome da companhia',
      CLIENT_UUID_KEY: 'ID do cliente',
      CLIENT_NAME_KEY: 'Nome do cliente',
      STATUS_KEY: 'Status',
      ACTIVE_KEY: 'Ativo',
      INACTIVE_KEY: 'Inativo',
      ALLOW_SSO_CONFIG_KEY: 'Permite configurar SSO',
      CUSTOM_FRONTEND_KEY: 'Possui front customizado',
      LDAP_SERVER_KEY: 'LDAP Server',
      LDAP_TYPE_KEY: 'Tipo de LDAP',
      OCI_COMPARTMENT_ID_KEY: 'OCI - Compartment ID',
      PARTNER_NEW_FRONT_ENABLED_KEY: 'Usa novo front',
      ROLE_AWS_KEY: 'AWS - Role ARN',
      INTERNAL_KEY: 'Interno',
      EXTERNAL_KEY: 'Externo',
      MANAGED_KEY: 'Gerenciado',
      PARTNER_ALIAS_KEY: 'Alias',
      COMPANY_TYPE_KEY: 'Tipo da companhia',
      COMPANY_STATUS_KEY: 'Status da companhia',
      RESPONSIBLE_EMAIL_KEY: 'Email do responsável',
      RESPONSIBLE_NAME_KEY: 'Nome do responsável',
      RESPONSIBLE_PHONE_KEY: 'Telefone do responsável',
      TRADING_NAME_KEY: 'Nome fantasia',
      ZOHO_ID_KEY: 'ID Zoho',
      CLIENT_KEY: 'Cliente',
      PARTNER_KEY: 'Conta',
      EXTERNAL_CLIENT_CODE_KEY: 'Código externo do cliente',
      IDENTIFICATION_KEY: 'Client ID',
      APPLICATIONS_REGISTRATION_MODE_KEY: 'Modo de cadastro',
      BACKUP_MODEL_ID_KEY: 'ID do modelo secundário',
      BEHAVIOR_TYPE_KEY: 'Tipo de comportamento',
      BLOCK_MULTIPLE_SESSION_KEY: 'Bloqueio de múltiplas sessões',
      CONNECTION_TYPE_KEY: 'Tipo de conexão',
      IN_MAINTENANCE_KEY: 'Em manutenção',
      LICENSE_LIMIT_KEY: 'Limite de licenças',
      LICENSE_LIMIT_PER_CLIENT_KEY: 'Possui limite de licenças por cliente',
      MAIN_MODEL_ID_KEY: 'ID do modelo primário',
      NUM_CLIENTS_KEY: 'Quantidade de clientes',
      NUM_USERS_KEY: 'Quantidade de usuários',
      PROVIDER_TYPE_KEY: 'Tipo de provedor',
      PUBLICATION_TYPE_KEY: 'Tipo de publicação',
      REGION_KEY: 'Região',
      USE_DNS_KEY: 'Utiliza DNS para conexão remota',
      VIRTUALIZER_KEY: 'Virtualizador',
      ZERO_TRUST_ENABLED_KEY: 'Zero Trust',
      SIMPLE_KEY: 'Simples',
      ADVANCED_KEY: 'Avançado',
      MANUAL_KEY: 'Manual',
      PERIOD_KEY: 'Períodos',
      MICRO_KEY: 'Micro',
      SPOT_PERIOD_KEY: 'Períodos (Spot)',
      HAAS_KEY: 'HaaS',
      CCC_KEY: 'CCC',
      PUBLIC_KEY: 'Pública',
      PRIVATE_KEY: 'Privada',
      AWS_KEY: 'AWS',
      OCI_KEY: 'OCI',
      MULTICLOUD_KEY: 'Multicloud',
      CUSTOM_IMAGE_KEY: 'Imagem customizada',
      BOOT_VOLUME_KEY: 'Volume de boot',
      BOOT_VOLUME_BACKUP_KEY: 'Backup de volume de boot',
      CONNECT_KEY: 'ConnectSky',
      CONNECT_DIRECT_KEY: 'ConnectSky (Direct Connect)',
      RDP_KEY: 'Microsoft Remote Desktop (Arquivo)',
      RDP_DIRECT_KEY: 'Microsoft Remote Desktop (Direct Connect)',
      RDP_APP_KEY: 'Microsoft Remote Desktop (RemoteApp)',
      TSPLUS_KEY: 'TSPlus (WebBrowser HTML5)',
      TSPLUS_REMOTE_APP_KEY: 'TSPlus (RemoteApp)',
      TSPLUS_ALL_KEY: 'TSPlus (WebBrowser HTML and RemoteApp)',
      SERVER_TYPE_KEY: 'Tipo de servidor',
      INSTANCE_STATE_KEY: 'Status do servidor',
      INSTANCE_ID_KEY: 'ID da instância',
      IMAGE_PUBLICATION_STATUS_KEY: 'Status da imagem',
      FLAVOR_KEY: 'Sabor',
      NAME_KEY: 'Nome',
      OPERATING_TIME_KEY: 'Tempo de operacionalização de instâncias',
      MONITORING_TYPE_KEY: 'Tipo de monitoramento',
      CLIENT_USE_NEW_FRONT_KEY: 'Utiliza nova interface',
      NO_ACCESS_KEY: 'Sem acesso',
      GREATER_THAN_OR_EQUAL_TO_30_DAYS_KEY: 'Maior ou igual a 1 mês',
      GREATER_THAN_OR_EQUAL_TO_60_DAYS_KEY: 'Maior ou igual a 2 meses',
      GREATER_THAN_OR_EQUAL_TO_90_DAYS_KEY: 'Maior ou igual a 3 meses',
      GREATER_THAN_OR_EQUAL_TO_180_DAYS_KEY: 'Maior ou igual a 6 meses',
    },
    LIST_PARTNER_SERVERS: 'Listar servidores da conta',
    START_PARTNER_SERVERS: 'Iniciar servidores da conta',
    STOP_PARTNER_SERVERS: 'Parar servidores da conta',
    PUBLISH_NEW_IMAGE_PARTNER_SERVERS:
      'Publicar imagem nos servidores na conta',
    LIST_IMAGE_PUBLICATION_SCHEDULE:
      'Listar agendamentos de publicações de imagem',
    CREATE_IMAGE_PUBLICATION_SCHEDULE:
      'Criar agendamento de publicação de imagem',
    CANCEL_IMAGE_PUBLICATION_SCHEDULE:
      'Cancelar agendamento de publicação de imagem',
    START_SERVERS_KEY: 'Iniciar servidores',
    START_SERVERS_CONFIRM_KEY: 'Deseja iniciar servidores selecionados?',
    STOP_SERVERS_KEY: 'Parar servidores',
    STOP_SERVERS_CONFIRM_KEY: 'Deseja parar servidores selecionados?',
    LIST_ALL_PARTNER_SERVERS_KEY:
      'Listagem de todos os servidores de preparação da conta',
    SERVERS_START_REQUESTED: 'Início dos servidores solicitado com sucesso!',
    SERVERS_STOP_REQUESTED: 'Parada dos servidores solicitada com sucesso!',
    LIST_DASHBOARD_PERFORMANCE: 'Ver dashboard de performance',
    CAN_MANAGE_ENVIRONMENT_STATUS: 'Gerenciar status do ambiente',
    PERFORMANCE_PAGE: {
      PERFORMANCE_KEY: 'Performance',
      PERFORMANCE_TITLE_KEY: 'Dados de perfomance deste ambiente',
      CPU_USE_KEY: 'Uso de CPU',
      MEMORY_USE_KEY: 'Uso de memória',
      AVG_KEY: 'Média',
      MAX_KEY: 'Máxima',
      OPERATIONAL_TIME_DETAILS_KEY:
        'Detalhes de tempo de operacionalização de instâncias',
      CPU_USE_DETAILS_KEY: 'Detalhes de uso de CPU',
      MEMORY_USE_DETAILS_KEY: 'Detalhes de uso de memória',
      COSTS_DETAILS_KEY: 'Detalhes de custos',
      ENVIRONMENT_COSTS_DETAILS_KEY: 'Detalhes de custos do ambiente',
      CPU_MEMORY_USE_KEY: 'Uso de CPU e memória',
      SESSIONS_VACANCIES_OPERATIONAL_KEY:
        'Sessões, vagas e tempo de operacionalização',
      SESSIONS_AND_VACANCIES_KEY: 'Sessões e vagas',
      SESSIONS_AND_VACANCIES_DETAILS_KEY: 'Detalhes de sessões e vagas',
      FILTERS_KEY: 'Filtros',
    },
    ACCESS_ENVIRONMENT_KEY: 'Acessar ambiente',
    CAN_EDIT_ENVIRONMENT_MONITORING_SETTINGS:
      'Editar monitoramento do ambiente',

    MONITORING_PAGE: {
      SUBTITLE_KEY:
        'Ative a opção abaixo para gerenciar o monitoramento de ambiente',
      SWITCH_TEXT_KEY: 'Ativar monitoramento de ambiente',
      EMAILS_TO_ALERT_KEY: 'Emails para receber resumo diário',
      OPERATING_TIME_KEY: 'Tempo de operacionalização de instâncias',
      OPERATING_TIME_IN_MINUTES_KEY:
        'Tempo máximo de operacionalização (em minutos):',
      HISTORY_SUBTITLE_KEY: 'Histórico de alertas do monitoramento',
      TYPE_KEY: 'Tipo',
      DATE_TIME_KEY: 'Data e Hora',
      INSTANCES_KEY: 'Instâncias',
      VACANCIES_KEY: 'Vagas',
      LICENSES_KEY: 'Licenças',
      SESSIONS_KEY: 'Sessões',
      DETAILS_KEY: 'Detalhes',
      MONITORING_SUCCESSFULLY_SET_KEY:
        'Monitoramento do ambiente configurado com sucesso!',
      CONFIGURED_OPERATING_TIME_KEY: 'Tempo de operacionalização configurado',
      AVERAGE_OPERATING_TIME_KEY: 'Tempo de operacionalização',
      ALERTED_INSTANCES_KEY: 'Instâncias alertadas',
      MINUTES_KEY: 'minutos',
      AVERAGE_OPERATING_TIME_IN_MINUTES_KEY:
        'Tempo médio de operacionalização (em minutos):',
    },
    INVALID_SCHEDULE_DATETIME:
      'A data e hora do agendamento de publicação de imagem devem ser maiores que a data e hora atuais.',
    SERVER_HAS_SCHEDULE_PUBLICATION_KEY:
      'Este servidor possui uma publicação agendada',
    SCHEDULE_PUBLICATION_MODAL_TITLE_KEY: 'Agendamento de publicação padrão',
    IDENTIFIER_KEY: 'Identificador',
    REQUESTER_KEY: 'Solicitante',
    SCHEDULE_DATETIME_KEY: 'Data e hora de agendamento',
    TIMEZONE_KEY: 'Fuso horário',
    EMAILS_TO_NOTIFY_CONCLUSION_KEY:
      'Emails para notificar conclusão da publicação',
    DATETIME_TO_SCHEDULE_KEY: 'Horário para agendamento',
    CANCEL_PUBLICATION_SCHEDULE_TITLE_KEY:
      'Cancelar agendamento de publicação de imagem',
    CONFIRM_PUBLICATION_SCHEDULE_CONTENT_KEY:
      'Tem certeza que deseja confirmar o agendamento para {{datetime}}?',
    CONFIRM_SCHEDULE_KEY: 'Confirmar agendamento',
    CONFIRM_PUBLICATION_SCHEDULE_TITLE_KEY:
      'Confirmar agendamento de publicação de imagem',
    CANCEL_PUBLICATION_SCHEDULE_CONTENT_KEY:
      'Tem certeza que deseja cancelar o agendamento de {{datetime}}?',
    CANCEL_SCHEDULE_KEY: 'Cancelar agendamento',
    NO_SCHEDULE_FOUND: 'Nenhum agendamento encontrado',
    PUBLICATION_SCHEDULE_CANCEL_SUCCESSFULLY_KEY:
      'Agendamento de publicação cancelado com sucesso!',
    PUBLICATION_SCHEDULE_SUCCESSFULLY_KEY: 'Publicação agendada com sucesso!',
    BULK_CREATE_KEY: 'Criação em massa',
    BULK_REMOVE_KEY: 'Remoção em massa',
    TIME_SET_KEY: 'Horário',
    APP_UUID_KEY: 'ID da aplicação',
    APP_NAME_KEY: 'Nome da aplicação',
    BULK_UPDATE_KEY: 'Edição em massa',
    CAN_EDIT_CLIENTS_IN_BULK: 'Gerenciar clientes em massa',
    REPLACE_KEY: 'Substituir',
    OR_KEY: 'Ou',
    BULK_CLIENTS: {
      CLIENTS_KEY: 'Clientes',
      CLIENTS_TITLE_KEY: 'Clientes do ambiente',
      CLIENTS_SUBTITLE_KEY:
        'Gerencie clientes do ambiente, configurando recursos em massa para todos os clientes do ambiente ou selecionando individualmente',
      NO_RESOURCE_FOUND_KEY: 'Nenhum recurso encontrado',
      ENVIRONMENT_KEY: 'Ambiente',
      EDIT_KEY: 'Editar',
      DETAILS_KEY: 'Detalhes',
      EMAIL_ADMIN_KEY: 'Email Admin',
      COPY_EMAIL_ADMIN_KEY: 'Copiar Admin por email',
      BLOCK_MULTIPLE_SESSIONS_KEY: 'Bloquear múltiplas sessões',
      IOS_DEVICES_KEY: 'Utilizar dispositivo iOS',
      ACTIVATE_MFA_KEY: 'Ativar MFA',
      LIMIT_LICENSES_KEY: 'Limitar licenças',
      LIMIT_CONFIG_KEY: 'Configurar limite de licenças',
      ENABLE_DISABLE_KEY: 'Ativar/Desativar',
      VIRTUALIZER_KEY: 'Virtualizador',
      CONNECTION_TYPE_KEY: 'Tipo de conexão',
      CHANGE_CONNECTION_TYPE_KEY: 'Configurar tipo de conexão',
      CONFIG_CONNECTION_TYPE_KEY: 'Configurar status do tipo de conexão',
      PORT_ONE_KEY: 'Porta 01 (Primária)',
      PORT_TWO_KEY: 'Porta 02 (Secundária)',
      QUALITY_KEY: 'Qualidade',
      ACTIVE_KEY: 'Ativo',
      TYPE_KEY: 'Tipo',
      PUBLIC_KEY: 'Público',
      PRIVATE_KEY: 'Privado',
      QUANTITY_KEY: 'Quantidade',
      LIMIT_LICENSES_STATUS_KEY: 'Status do limite de licenças',
      ACTIVATE_IN_ALL_CLIENTS_KEY:
        'Ativar limite de licenças em todos os clientes?',
      INACTIVATE_IN_ALL_CLIENTS_KEY:
        'Inativar limite de licenças em todos os clientes?',
      CONFIRM_ACTIVATE_IN_CLIENTS_KEY:
        'Tem certeza que deseja configurar o limite de licenças nestes clientes?',
      CONFIRM_INACTIVATE_IN_CLIENTS_KEY:
        'Tem certeza que deseja inativar o limite de licenças nestes clientes?',
      CONFIRM_ACTIVATE_KEY: 'Confirmar configuração de limite de licenças',
      CONFIRM_INACTIVATE_KEY: 'Confirmar inativação de limite de licenças',
      CONFIRM_ACTIVATE_IN_ALL_CLIENTS_CLIENTS_KEY:
        'Tem certeza que deseja ativar o limite de licenças em todos os clientes?',
      CONFIRM_INACTIVATE_IN_ALL_CLIENTS_CLIENTS_KEY:
        'Tem certeza que deseja inativar o limite de licenças em todos os clientes?',
      ACTIVATE_LIMIT_TO_CONFIRM_KEY:
        'Para confirmar a ativação, informe no campo abaixo o motivo da ação:',
      INACTIVATE_LIMIT_TO_CONFIRM_KEY:
        'Para confirmar a inativação, informe no campo abaixo o motivo da ação:',
      EDIT_SUCCESSFULLY_KEY: 'Alteração realizada com sucesso!',
      SET_PUBLIC_IN_ALL_CLIENTS_KEY:
        'Configurar o tipo de conexão como público em todos os clientes?',
      SET_PRIVATE_IN_ALL_CLIENTS_KEY:
        'Configurar o tipo de conexão como privado em todos os clientes?',
      SET_PRIVATE_KEY: 'Tornar privado',
      SET_PUBLIC_KEY: 'Tornar público',
      CONFIRM_SET_PUBLIC_KEY:
        'Confirmar alteração do tipo de conexão para público',
      CONFIRM_SET_PRIVATE_KEY:
        'Confirmar alteração do tipo de conexão para privado',
      CONFIRM_SET_CONNECTION_TYPE_KEY: 'Confirmar alteração do tipo de conexão',
      SET_CONNECTION_TYPE_TO_CONFIRM_KEY:
        'Para confirmar a alteração, informe no campo abaixo o motivo da ação:',
      CONFIRM_CHANGE_KEY: 'Confirmar alteração',
      CONFIRM_SET_PUBLIC_IN_ALL_CLIENTS_CLIENTS_KEY:
        'Tem certeza que deseja alterar o tipo de conexão para público em todos os clientes?',
      CONFIRM_SET_PRIVATE_IN_ALL_CLIENTS_CLIENTS_KEY:
        'Tem certeza que deseja alterar o tipo de conexão para privado em todos os clientes?',
      CURRENT_ENVIRONMENT_KEY: 'Ambiente atual',
      DESTINATION_ENVIRONMENT_KEY: 'Ambiente destino',
      CONFIRM_MIGRATION_BETWEEN_ENVIRONMENTS_KEY:
        'Confirmar migração de clientes entre ambientes',
      CLIENTS_TO_MIGRATE_KEY: 'Clientes para migrar',
      CONFIRMATION_KEY: 'Confirmação',
      CONFIRM_CLIENTS_MIGRATION_TO_ENVIRONMENT_KEY:
        'Tem certeza que deseja migrar os seguintes clientes para o ambiente ',
      CHOOSE_ENVIRONMENT_KEY: 'Escolha um ambiente',
      CONFIRM_CHANGE_VIRTUALIZER_KEY: 'Confirmar alteração de virtualizador',
      CONFIRM_CHANGE_VIRTUALIZER_IN_CLIENTS_KEY:
        'Confirmar alteração de virtualizador nestes clientes?',
      CONFIRM_CHANGE_VIRTUALIZER_IN_ALL_CLIENTS_KEY:
        'Confirmar alteração de virtualizador em todos os clientes?',
      CONFIG_VIRTUALIZER_IN_ALL_CLIENTS_KEY:
        'Configurar este virtualizador e portas para todos os clientes?',
      ACTIVATE_COPY_ADMIN_IN_ALL_CLIENTS_KEY:
        'Ativar Copiar Admin por email em todos os clientes?',
      INACTIVATE_COPY_ADMIN_IN_ALL_CLIENTS_KEY:
        'Inativar Copiar Admin por email em todos os clientes?',
      CONFIRM_ACTIVATE_COPY_ADMIN_IN_CLIENTS_KEY:
        'Tem certeza que deseja ativar o Copiar Admin por email nestes clientes?',
      CONFIRM_INACTIVATE_COPY_ADMIN_IN_CLIENTS_KEY:
        'Tem certeza que deseja inativar o Copiar Admin por email nestes clientes?',
      CONFIRM_ACTIVATE_COPY_ADMIN_KEY:
        'Confirmar ativação de Copiar Admin por email',
      CONFIRM_INACTIVATE_COPY_ADMIN_KEY:
        'Confirmar inativação de Copiar Admin por email',
      CONFIRM_ACTIVATE_COPY_ADMIN_IN_ALL_CLIENTS_CLIENTS_KEY:
        'Tem certeza que deseja ativar o Copiar Admin por email em todos os clientes?',
      CONFIRM_INACTIVATE_COPY_ADMIN_IN_ALL_CLIENTS_CLIENTS_KEY:
        'Tem certeza que deseja inativar o bloqueio de múltiplas sessões em todos os clientes?',
      ACTIVATE_BLOCK_MULTIPLE_SESSIONS_IN_ALL_CLIENTS_KEY:
        'Ativar bloqueio de múltiplas sessões em todos os clientes?',
      INACTIVATE_BLOCK_MULTIPLE_SESSIONS_IN_ALL_CLIENTS_KEY:
        'Inativar bloqueio de múltiplas sessões em todos os clientes?',
      CONFIRM_ACTIVATE_BLOCK_MULTIPLE_SESSIONS_IN_CLIENTS_KEY:
        'Tem certeza que deseja ativar o bloqueio de múltiplas sessões nestes clientes?',
      CONFIRM_INACTIVATE_BLOCK_MULTIPLE_SESSIONS_IN_CLIENTS_KEY:
        'Tem certeza que deseja inativar o bloqueio de múltiplas sessões nestes clientes?',
      CONFIRM_ACTIVATE_BLOCK_MULTIPLE_SESSIONS_KEY:
        'Confirmar ativação de bloqueio de múltiplas sessões',
      CONFIRM_INACTIVATE_BLOCK_MULTIPLE_SESSIONS_KEY:
        'Confirmar inativação de bloqueio de múltiplas sessões',
      CONFIRM_ACTIVATE_BLOCK_MULTIPLE_SESSIONS_IN_ALL_CLIENTS_CLIENTS_KEY:
        'Tem certeza que deseja ativar o bloqueio de múltiplas sessões em todos os clientes?',
      CONFIRM_INACTIVATE_BLOCK_MULTIPLE_SESSIONS_IN_ALL_CLIENTS_CLIENTS_KEY:
        'Tem certeza que deseja inativar o bloqueio de múltiplas sessões em todos os clientes?',
      ACTIVATE_USE_IOS_IN_ALL_CLIENTS_KEY:
        'Ativar uso de dispositvos iOS em todos os clientes?',
      INACTIVATE_USE_IOS_IN_ALL_CLIENTS_KEY:
        'Inativar uso de dispositvos iOS em todos os clientes?',
      CONFIRM_ACTIVATE_USE_IOS_IN_CLIENTS_KEY:
        'Tem certeza que deseja ativar o uso de dispositvos iOS nestes clientes?',
      CONFIRM_INACTIVATE_USE_IOS_IN_CLIENTS_KEY:
        'Tem certeza que deseja inativar o uso de dispositvos iOS nestes clientes?',
      CONFIRM_ACTIVATE_USE_IOS_KEY:
        'Confirmar ativação de uso de dispositvos iOS',
      CONFIRM_INACTIVATE_USE_IOS_KEY:
        'Confirmar inativação de uso de dispositvos iOS',
      CONFIRM_ACTIVATE_USE_IOS_IN_ALL_CLIENTS_CLIENTS_KEY:
        'Tem certeza que deseja ativar o uso de dispositvos iOS em todos os clientes?',
      CONFIRM_INACTIVATE_USE_IOS_IN_ALL_CLIENTS_CLIENTS_KEY:
        'Tem certeza que deseja inativar o uso de dispositvos iOS em todos os clientes?',
      ACTIVATE_MFA_IN_ALL_CLIENTS_KEY:
        'Ativar uso de MFA em todos os clientes?',
      INACTIVATE_MFA_IN_ALL_CLIENTS_KEY:
        'Inativar uso de MFA em todos os clientes?',
      CONFIRM_ACTIVATE_MFA_IN_CLIENTS_KEY:
        'Tem certeza que deseja ativar o uso de MFA nestes clientes?',
      CONFIRM_INACTIVATE_MFA_IN_CLIENTS_KEY:
        'Tem certeza que deseja inativar o uso de MFA nestes clientes?',
      CONFIRM_ACTIVATE_MFA_KEY: 'Confirmar ativação de uso de MFA',
      CONFIRM_INACTIVATE_MFA_KEY: 'Confirmar inativação de uso de MFA',
      CONFIRM_ACTIVATE_MFA_IN_ALL_CLIENTS_CLIENTS_KEY:
        'Tem certeza que deseja ativar o uso de MFA em todos os clientes?',
      CONFIRM_INACTIVATE_MFA_IN_ALL_CLIENTS_CLIENTS_KEY:
        'Tem certeza que deseja inativar o uso de MFA em todos os clientes?',
      ACTIVATE_CONNECTION_TYPE_IN_ALL_CLIENTS_KEY:
        'Ativar uso de tipo de conexão em todos os clientes?',
      INACTIVATE_CONNECTION_TYPE_IN_ALL_CLIENTS_KEY:
        'Inativar uso de tipo de conexão em todos os clientes?',
      CONFIRM_ACTIVATE_CONNECTION_TYPE_IN_CLIENTS_KEY:
        'Tem certeza que deseja configurar o uso de tipo de conexão nestes clientes?',
      CONFIRM_INACTIVATE_CONNECTION_TYPE_IN_CLIENTS_KEY:
        'Tem certeza que deseja inativar o uso de tipo de conexão nestes clientes?',
      CONFIRM_ACTIVATE_CONNECTION_TYPE_KEY:
        'Confirmar configuração de uso de tipo de conexão',
      CONFIRM_INACTIVATE_CONNECTION_TYPE_KEY:
        'Confirmar inativação de uso de tipo de conexão',
      CONFIRM_ACTIVATE_CONNECTION_TYPE_IN_ALL_CLIENTS_CLIENTS_KEY:
        'Tem certeza que deseja ativar o uso de tipo de conexão em todos os clientes?',
      CONFIRM_INACTIVATE_CONNECTION_TYPE_IN_ALL_CLIENTS_CLIENTS_KEY:
        'Tem certeza que deseja inativar o uso de tipo de conexão em todos os clientes?',
      MIGRATE_CLIENTS_BETWEEN_ENVIRONMENTS_KEY:
        'Migrar clientes entre ambientes',
      CONFIRM_CHANGE_EMAIL_ADMIN_KEY:
        'Confirmar alteração de email do administrador',
      CONFIRM_CHANGE_EMAIL_ADMIN_IN_CLIENTS_KEY:
        'Confirmar alteração de email do administrador nestes clientes?',
      CONFIRM_CHANGE_EMAIL_ADMIN_IN_ALL_CLIENTS_KEY:
        'Confirmar alteração de email do administrador em todos os clientes?',
      CONFIG_EMAIL_ADMIN_IN_ALL_CLIENTS_KEY:
        'Configurar este email do administrador para todos os clientes?',
      EMAILS_TO_ADD_KEY: 'Emails par adicionar:',
      EMAILS_TO_REPLACE_KEY: 'Emails par substituir:',
      ENVIRONMENTS_TOTAL_LICENSES_KEY: 'Total de licenças do ambiente',
      CONFIG_LIMIT_LICENSES_PASSWORD_AND_REASON_KEY:
        'Para ativar a edição da quantidade de licenças na tabela, preencha os campos abaixo com o motivo da ação e sua senha de operador:',
      SELECT_CLIENTS_TO_MIGRATE_KEY: 'Selecione os clientes para migrar:',
      UPDATE_KEY: 'Atualizar dados',
      ENVIRONMENT_DEFAULT_KEY: 'Default do ambiente',
      LICENSES_QUANTITY_KEY: 'Quantidade de licenças',
    },
    COMPLETION_DATE_KEY: 'Data de término',
    MAKE_ENVIRONMENT_PRODUCTIVE_KEY: 'Tornar produtivo',
    CONFIRM_MAKE_ENVIRONMENT_PRODUCTIVE_KEY:
      'Tem certeza que deseja configurar o status desde ambiente para "Produção"?',
    COMPLETION_DATE_STATUS_KEY: 'Data de término do status',
    PENDING_COMPLETION_DATE_KEY:
      'Este ambiente possui uma solicitação de prorrogação de data de término pendente para o dia: {{completion_date_proposed}}. Quando for aceita, esta data será a nova data de término para este status',
    PENDING_COMPLETION_DATE_NO_DATE_KEY:
      'Este ambiente possui uma solicitação de prorrogação de data de término pendente. Quando for aceita, a data solicitada substituirá a data atual',
    EXTEND_REQUEST_KEY: 'Solicitação de prorrogação',
    EXTEND_REASON_KEY: 'Motivo da prorrogação',
    VALIDATE_PENDENCIES_KEY: 'Avaliar pendências',
    COMPLETION_DATE_SOLICITATION_KEY: 'Solicitação de nova data de término',
    APPROVE_KEY: 'Aprovar',
    REQUEST_EXTEND_KEY: 'Solicitar prorrogação',
    EXTEND_COMPLETION_DATE_KEY: 'Prorrogar data de término do status',
    SELECT_NEW_COMPLETION_DATE_KEY: 'Selecione a nova data de término',
    APPROVE_EXTEND_DATE_KEY: 'Aprovar data de prorrogação',
    NEW_COMPLETION_DATE_WILL_BE_KEY: 'A nova data de término deste status será',
    EXTEND_REQUESTED_BY_KEY: 'Esta solicitação foi feita por',
    DAYS_TO_EXPIRE_KEY: 'Dias para expirar',
    ENVIRONMENTS_STATUS_TO_EXPIRE_KEY:
      'Ambientes com status para expirar nos próximos 7 dias',
    ENVIRONMENTS_STATUS_TO_EXPIRE_SHORT_KEY:
      'Ambientes com status para expirar',
    CAN_EDIT_COMPANY_ALIAS: 'Editar nome de exibição da conta',
    CONFIRM_COMPANY_ALIAS_KEY:
      'Tem certeza que deseja definir o nome de exibição {{alias}} para esta companhia?',
    CONFIRM_COMPANY_ALIAS_TITLE_KEY: 'Salvar nome de exibição da companhia',
    ALIAS_CREATED_SUCCESSFULLY_KEY: 'Nome alterado com sucesso!',
    ALIAS_NAME_KEY: 'Nome de exibição',
    CREATE_ALIAS_NAME_KEY: 'Criar nome de exibição',
    LEGAL_NAME_KEY: 'Nome fantasia',
    COMPANY_NAME_CRM_KEY: 'Nome da companhia (CRM)',
    APPROVED_REQUEST_KEY: 'Solicitação aprovada!',
    CAN_ACCEPT_PENDING_EXTENSION: 'Aprovar prorrogação de data de término',
    CLICK_TO_FILTER_ENV_STATUS_KEY:
      'Clique para filtrar os ambientes com este status na tabela',
    CLICK_TO_FILTER_PROVIDER_KEY:
      'Clique para filtrar os ambientes com este provedor na tabela',
    CLICK_TO_FILTER_ENV_DNS_KEY:
      'Clique para filtrar os ambientes com este status de DNS na tabela',
    CLICK_TO_FILTER_ENV_CONNECTION_TYPE_KEY:
      'Clique para filtrar os ambientes com este tipo de conexão na tabela',
    CLICK_TO_FILTER_ENV_BEHAVIOR_KEY:
      'Clique para filtrar os ambientes com este comportamento na tabela',
    CLICK_TO_FILTER_ENV_VIRTUALIZER_KEY:
      'Clique para filtrar os ambientes com este virtualizador na tabela',
    CLICK_TO_FILTER_ENV_PRODUCT_KEY:
      'Clique para filtrar os ambientes deste produto na tabela',
    CLICK_TO_FILTER_ENV_ZERO_TRUST_KEY:
      'Clique para filtrar os ambientes deste status de Zero Trust na tabela',
    CLICK_TO_FILTER_ENV_PRODUCT_TYPE_KEY:
      'Clique para filtrar os ambientes com este tipo de produto na tabela',
    CLICK_TO_FILTER_ENV_REGION_KEY:
      'Clique para filtrar os ambientes desta região na tabela',
    ENV_STATUS_GRAPHS_KEY: 'Gráficos de status dos ambientes',
    ENV_MAINTENANCE_GRAPHS_KEY:
      'Gráficos de manutenção e exibição de aviso dos ambientes',
    ENV_PRODUCT_GRAPHS_KEY: 'Gráficos de produto dos ambientes',
    ENV_ZERO_TRUST_GRAPHS_KEY: 'Gráficos de uso do Zero Trust dos ambientes',
    ENV_REGION_GRAPHS_KEY: 'Gráficos de regiões dos ambientes',
    ENV_BEHAVIOR_GRAPHS_KEY: 'Gráficos de comportamento dos ambientes',
    ENV_PRODUCT_TYPE_GRAPHS_KEY: 'Gráficos de tipo de produto dos ambientes',
    ENV_VIRTUALIZER_GRAPHS_KEY: 'Gráficos de virtualizador dos ambientes',
    ENV_PROVIDER_GRAPHS_KEY: 'Gráficos de provedor dos ambientes',
    ENV_DNS_GRAPHS_KEY: 'Gráficos de DNS dos ambientes',
    ENV_CONNECTION_TYPE_GRAPHS_KEY: 'Gráficos de tipo de conexão dos ambientes',
    POLAR_GRAPH_KEY: 'Gráfico Polar',
    DONUT_GRAPH_KEY: 'Gráfico Donut',
    BAR_GRAPH_KEY: 'Gráfico de Barras',
    CURRENT_TIMEZONE_TIME_KEY: 'Hora atual da zona horária selecionada',
    AVAILABLE_LICENSES_REACHED_KEY:
      'O número de licenças disponíveis foi ultrapassado',
    GET_ENVIRONMENT_MAINTENANCE: 'Ver detalhes de manutenção do ambiente',
    EDIT_ENVIRONMENT_MAINTENANCE: 'Configurar manutenção do ambiente',
    ENVIRONMENT_MAINTENANCE_HISTORY: 'Ver histórico de manutenção do ambiente',
    GET_CLIENT_MAINTENANCE: 'Ver detalhes de manutenção do cliente',
    EDIT_CLIENT_MAINTENANCE: 'Configurar manutenção do cliente',
    CLIENT_MAINTENANCE_HISTORY: 'Ver histórico de manutenção do cliente',
    REQUEST_NEW_COMPLETION_DATE_KEY:
      'Para solicitar uma nova data de término, selecione a data deseja no campo abaixo, e informe o motivo da solicitação.',
    CURRENT_COMPLETION_DATE_KEY: 'Data de término atual',
    NEW_COMPLETION_DATE_KEY: 'Nova data de término',
    CONFIRM_REQUEST_KEY: 'Confirmar solicitação',
    COMPLETION_DATE_PROPOSE_RULE_KEY:
      'A nova data de término não pode ser menor ou igual a data atual.',
    COMPLETION_DATE_EXTEND_REQUESTED_SUCCESSFULLY_KEY:
      'Nova data de término solicitada com sucesso!',
    REFUSE_KEY: 'Recusar',
    REFUSE_EXTEND_DATE_KEY: 'Recusar data de prorrogação',
    REFUSE_EXTEND_DATE_DETAILS_KEY:
      'A data de término solicitada ({{completion_date_proposed}}) será recusada, e a data atual ({{completion_date}}) será mantida.',
    MAINTENANCE_SET_SUCCESSFULLY_KEY: 'Manutenção configurada com sucesso!',
    CONFIRM_MAINTENANCE_CONFIG_KEY:
      'Para confirmar a configuração de manutenção, informe no campo abaixo o motivo da ação',
    MAINTENANCE_CONFIG_KEY: 'Configuração de manutenção',
    COMPLETION_DATE_EXPIRED_KEY: 'Data de término expirada',
    USE_LIMIT_DAILY: 'Utilizar limite de publicações diário',
    MAINTENANCE_HISTORY_KEY: 'Histórico de manutenção',
    DETAILS_MAINTENANCE_HISTORY_KEY: 'Detalhes do histórico de manutenção',
    MAINTENANCE_UPDATED_AT_KEY:
      "'Atualizado em' d 'de' MMMM 'de' yyyy 'às' HH:mm",
    MAINTENANCE_CHANGED_BY_KEY: 'Por {{first_name}} {{last_name}} ({{email}})',
    MAINTENANCE_REASON_KEY: 'Motivo: {{reason}}',
    UPDATED_BY_SCHEDULE_MAINTENANCE_KEY:
      'Alteração automática realizada pela manutenção programada',
    MODIFIED_BY_CUSTOMER_PORTAL_KEY:
      'Alteração realizada através do Portal do Cliente',
    MODIFIED_BY_API_V2_KEY:
      'Alteração realizada através da API Autosky Platform',
    MODIFIED_BY_SKYINONE_KEY: 'Alteração realizada através do Admin V1',
    NOT_ENOUGH_MAINTENANCE_HISTORY_DATA_KEY:
      'Sem dados suficientes de histórico de manutenção',
    FIELD_KEY: 'Campo',
    OLD_VALUE_KEY: 'Valor anterior',
    NEW_VALUE_KEY: 'Novo valor',
    PUBLICATION_WITH_BLOCKING_NOT_ENABLED:
      'A publicação mantendo usuários conectados não é permitida para este ambiente.',
    PUBLICATION_WITH_BLOCKING_MONTHLY_LIMIT_EXCEEDED:
      'Limite mensal de publicações atingido!',
    PUBLICATION_WITH_BLOCKING_DAILY_LIMIT_EXCEEDED:
      'Limite diário de publicações atingido!',
    EDIT_ENV_AUTO_BLOCK_INSTANCES_MAINTENANCE:
      'Configurar bloqueio diário de instâncias',
    LIST_ENV_AUTO_BLOCK_INSTANCES_DETAILS:
      'Ver detalhes de bloqueio diário de instâncias',
    AUTO_BLOCK_INSTANCES_KEY: 'Bloqueio diário de instâncias',
    AUTO_BLOCK_INSTANCES_TIME_KEY: 'Horário de execução do bloqueio',
    AVAILABLE_CLIENTS_LIST_KEY: 'Relação de clientes disponíveis',
    TEMPLATE_KEY: 'Template',
    CANNOT_CHANGE_MODE_FROM_MICRO_WITH_APPLICATION_SERVER_ATTACHED:
      'Não é possível alterar o modo de um ambiente Micro com o servidor de aplicação vinculado',
    DUPLICATED_ROLE_NAME: 'Nome do grupo de permissão já existe',
    REGIONS_KEY: 'Regiões',
    MAINTENANCE_AND_WARNING_KEY: 'Manutenção e Aviso',
    ZERO_TRUST_ENABLED_KEY: 'Zero Trust ativo',
    ZERO_TRUST_FAILED_KEY: 'Zero Trust falhou',
    ZERO_TRUST_GRACE_PERIOD_KEY:
      'Zero Trust aguardando inicialização. Este processo pode levar até 5 minutos',
    ZERO_TRUST_STARTING_KEY: 'Zero Trust inicializando',
    ZERO_TRUST_WRONG_VERSION_KEY: 'Status do Zero Trust não disponível',
    CONFIG_ENV_DASHBOARD_MODAL_KEY: 'Configuração de dashboard de ambientes',
    CONFIG_DASHBOARD_KEY: 'Configurar dashboard',
    EXPAND_DASHBOARD_KEY: 'Expandir dashboard',
    HIDE_DASHBOARD_KEY: 'Recolher dashboard',
    HIDE_SESSIONS_GRAPH_KEY: 'Recolher gráfico de sessões',
    EXPAND_SESSIONS_GRAPH_KEY: 'Expandir gráfico de sessões',
    ENV_DASHBOARD_KEY: 'Dashboard de ambientes',
    CLEAR_SELECTION_KEY: 'Limpar selecionados',
    EXPAND_CARDS_KEY: 'Expandir cards',
    MINIMIZE_CARDS_KEY: 'Minimizar cards',
    SELECT_CARDS_TITLE_CARDS_KEY:
      'Escolha até 3 cards para serem exibidos no dashboard',
    DONT_USE_ENV_DASHBOARD_KEY: 'Não utilizar dashboard de ambientes',
    SUCCESSFULLY_CONFIG_DASHBOARD_KEY: 'Dashboard configurado com sucesso!',
    ZERO_TRUST_DISABLED_KEY: 'Zero Trust desabilitado',
    NO_DASHBOARD_KEY: 'Sem dashboard',
    FILTERED_TOTAL_KEY: 'Total com filtros',
    MAINTENANCE_STATUS_KEY: 'Status da manutenção',
    RESTORE_DEFAULT_GRAPHS_KEY: 'Restaurar gráficos predefinidos',
    WANT_DEACTIVATE_ZERO_TRUST_KEY: 'Deseja desabilitar o Zero Trust?',
    WANT_ACTIVATE_ZERO_TRUST_KEY: 'Deseja habilitar o Zero Trust?',
    ACTIVATE_ZERO_TRUST_DESCRIPTION_KEY:
      'Ao habilitar o Zero Trust, usuários conectados à instância podem ser desconectados.',
    DEACTIVATE_ZERO_TRUST_DESCRIPTION_KEY:
      'A atualização do Zero Trust pode levar até 5 minutos para ter efeito. Nesse período, usuários que troquem de máquina ou acessem a instância podem ser bloqueados. Deseja continuar?',
    REMOVED_IPS_ZERO_TRUST_EXPLANATION_KEY:
      'IPs removidos da allow list só serão efetivamente excluídos após um período de 30 dias.',
    ALLOWED_SKYONE_IPS_ZERO_TRUST_KEY:
      'IPs da Skyone são liberados por padrão.',
    CONFIG_CLIENTS_DASHBOARD_MODAL_KEY: 'Configuração de dashboard de clientes',
    CLIENTS_DASHBOARD_KEY: 'Dashboard de clientes',
    CLICK_TO_FILTER_CLIENTS_STATUS_KEY:
      'Clique para filtrar os clientes com este status na tabela',
    CLICK_TO_FILTER_CLIENTS_VIRTUALIZER_KEY:
      'Clique para filtrar os clientes com este virtualizador na tabela',
    CLICK_TO_FILTER_CLIENTS_CONNECTION_TYPE_KEY:
      'Clique para filtrar os clientes com este tipo de conexão na tabela',
    CLIENTS_BLOCK_MULTIPLE_SESSION_GRAPHS_KEY:
      'Gráficos de bloqueio de múltiplas sessões dos clientes',
    CLIENTS_CONNECTION_TYPE_GRAPHS_KEY:
      'Gráficos de tipo de conexão dos clientes',
    CLIENTS_MFA_GRAPHS_KEY: 'Gráficos de MFA dos clientes',
    CLIENTS_USE_PROFILE_GRAPHS_KEY: 'Gráficos de perfil remoto dos clientes',
    CLIENTS_VIRTUALIZER_GRAPHS_KEY: 'Gráficos de virtualizador dos clientes',
    DONT_USE_CLIENTS_DASHBOARD_KEY: 'Não utilizar dashboard de clientes',
    MANAGE_ENV_LICENSE_LIMIT_KEY:
      'Permitir gerenciamento de licenças de clientes por ambiente',
    MANAGE_CHANGE_PASSWORD_KEY: 'Permitir alteração de senha para AD externo',
    LICENSE_MANAGEMENT_KEY: 'Gerenciamento de licenças',
    PASSWORD_MANAGEMENT_KEY: 'Gerenciamento de senha',
    ACTIVE_DUO_DESCRIPTION_KEY: 'Autenticação com DUO',
    DUO_CLIENT_ID: 'Client ID',
    DUO_CLIENT_SECRET: 'Client Secret',
    HOST_KEY: 'Host',
    BYPASS_IF_UNAVAILABLE_KEY: 'Permitir login em caso de indisponibilidade',
    BYPASS_IF_UNAVAILABLE_DESCRIPTION_KEY:
      'Ao ativar esta opção, caso ocorra indisponibilidade do serviço DUO, o login de usuários será realizado normalmente',
    OBSERVATIONS_KEY: 'Observações',
    AUTOSKY_ROUTINE: 'Rotina Autosky',
    FILTERS_APPLIED_KEY: 'Filtros aplicados',
    CONFIG_PARTNERS_DASHBOARD_MODAL_KEY: 'Configuração de dashboard de contas',
    PARTNERS_DASHBOARD_KEY: 'Dashboard de contas',
    DONT_USE_PARTNERS_DASHBOARD_KEY: 'Não utilizar dashboard de contas',
    CLICK_TO_FILTER_PARTNERS_STATUS_KEY:
      'Clique para filtrar as contas com este status na tabela',
    CLICK_TO_FILTER_PARTNERS_CONFIG_KEY:
      'Clique para filtrar as contas com esta configuração na tabela',
    CLICK_TO_FILTER_PARTNERS_PROVIDER_KEY:
      'Clique para filtrar as contas com este provedor na tabela',
    CLICK_TO_FILTER_PARTNERS_LDAP_KEY:
      'Clique para filtrar as contas com este LDAP na tabela',
    PARTNERS_LDAP_GRAPHS_KEY: 'Gráficos de tipo de LDAP das contas',
    PARTNERS_SSO_GRAPHS_KEY: 'Gráficos de configuração de SSO das contas',
    PARTNERS_PROVIDER_TYPE_GRAPHS_KEY:
      'Gráficos de tipo de provedor das contas',
    PARTNERS_NEW_FRONT_GRAPHS_KEY: 'Gráficos de uso do Portal 2.0 das contas',
    CONFIG_USERS_DASHBOARD_MODAL_KEY: 'Configuração de dashboard de usuários',
    USERS_DASHBOARD_KEY: 'Dashboard de usuários',
    DONT_USE_USERS_DASHBOARD_KEY: 'Não utilizar dashboard de usuários',
    CLICK_TO_FILTER_USERS_STATUS_KEY:
      'Clique para filtrar os usuários com este status na tabela',
    CLICK_TO_FILTER_USERS_CONFIG_KEY:
      'Clique para filtrar os usuários com esta configuração na tabela',
    USERS_MFA_GRAPHS_KEY: 'Gráficos de configuração de MFA dos usuários',
    USERS_SALT_GRAPHS_KEY: 'Gráficos de configuração de Salt dos usuários',
    USERS_ACTIVE_GRAPHS_KEY: 'Gráficos de status dos usuários',
    CHOOSE_DEFAULT_IMAGE_KEY: 'Escolher imagem de banner default',
    USE_NEW_PORTAL_KEY: 'Usa Portal 2.0',
    CLIENTS_TOTAL_KEY: 'Total de clientes',
    USERS_TOTAL_KEY: 'Total de usuários',
    PARTNERS_TOTAL_KEY: 'Total de parceiros',
    TEST_ZERO_TRUST_KEY: 'Validar Zero Trust',
    VALIDATE_INSTANCE_ZERO_TRUST: 'Validar Zero Trust por instância',
    ZERO_TRUST_CONFIG_AT_ENV_KEY: 'Ambiente com Zero Trust habilitado',
    ZERO_TRUST_CONFIG_WHITELIST_CLEANUP_INTERVAL_KEY:
      'Intervalo de limpeza da whitelist (em dias)',
    INTEGRATION_TEST_KEY: 'Teste de liberação de IP na instância',
    PROVIDER_RULE_KEY:
      'Confirmação da regra de segurança para o Zero Trust no provedor',
    PLATFORM_VERSION_KEY: 'Confirmação da versão do Platform',
    MINIMUM_VERSION_KEY: 'Versão mínima recomendada',
    CURRENT_VERSION_KEY: 'Versão atual',
    VALID_KEY: 'Válido',
    INVALID_KEY: 'Inválido',
    INCONSISTENT_ZERO_TRUST_KEY: 'Zero Trust com inconsistência',
    VALID_ZERO_TRUST_KEY: 'Zero Trust válido',
    INVALID_ZERO_TRUST_KEY: 'Zero Trust inválido',
    INFO_NOT_AVAILABLE_KEY: 'Informação não disponível',
    VALIDATE_AGAIN_KEY: 'Validar novamente',
    CLICK_ON_INSTANCE_KEY: 'Clique em uma instância para ver mais detalhes',
    PLATFORM_VERSION_NUMBER_KEY: 'Versão Platform',
    EXPAND_ACTIONS_KEY: 'Expandir ações',
    CLICK_HERE_TO_DETAILS_KEY: 'Clique para ver mais detalhes',
    REQUEST_ID_KEY: 'ID da requisição',
    RECOVERY_ID_KEY: 'ID da recuperação',
    CAN_EXPORT_PARTNER_SUMMARY_LIST:
      'Exportar listagem de contas em CSV ou PDF',
    CAN_EXPORT_ENVIRONMENT_SUMMARY_LIST:
      'Exportar listagem de ambientes em CSV ou PDF',
    CAN_EXPORT_CLIENT_SUMMARY_LIST:
      'Exportar listagem de clientes em CSV ou PDF',
    CAN_EXPORT_USER_SUMMARY_LIST: 'Exportar listagem de usuários em CSV ou PDF',
    PUBLISHING_STARTED_SUCCESSFULLY_KEY: 'Publicação iniciada com sucesso!',
    OPTIMIZED_KEY: 'Otimizado',
    PUBLICATIONS_PAGE_TITLE_KEY: 'Publicação e agendamento de novas versões',
    SELECT_PUBLICATION_MODE_KEY:
      'Selecione abaixo o modo de publicação desejado',
    EMAILS_TO_NOTIFY_KEY: 'Emails a serem notificados',
    BLOCK_INSTANCES_KEY: 'Bloquear instâncias',
    BLOCK_USERS_KEY: 'Terminar sessões',
    STOP_SERVER_KEY: 'Parar servidor de preparação ao criar imagem',
    NEW_KEY: 'NOVO',
    HOW_TO_OPTIMIZE_KEY: 'Como funciona a publicação otimizada?',
    RULE_TO_PUBLISH_KEY:
      'Para realizar uma nova publicação, é necessário haver um servidor de preparação',
    OPTIMIZED_PUBLICATION_DEFINITION_KEY:
      'O modo de publicação otimizado unifica as modalidades de publicação existentes em uma única abordagem. As publicações padrão, mantendo usuários conectados ou solicitando a reconexão dos usuários, podem ser realizadas no modo otimizado da seguinte maneira',
    HOW_TO_OPTIMIZE_DEFAULT_KEY:
      'O modo de publicação padrão é equivalente a não marcar as opções de bloquear instâncias nem de terminar sessões.',
    HOW_TO_OPTIMIZE_KEEP_KEY:
      'O modo de publicação que mantém usuários conectados é equivalente a marcar a opção de bloquear instâncias, mas não terminar sessões.',
    HOW_TO_OPTIMIZE_RECONNECTION_KEY:
      'O modo de publicação que solicita a reconexão dos usuários é equivalente a marcar as opções de bloquear instâncias e terminar sessões. Não é possível terminar as sessões sem bloquear as instâncias.',
    HOW_TO_OPTIMIZE_STOP_SERVER_KEY:
      'Esta opção permite definir se, ao criar a imagem, o servidor de preparação precisa ser parado. Ao não marcar, o servidor continuará disponível durante a criação.',
    SEE_EXAMPLE_KEY: 'Ver exemplo',
    OPTIMIZED_PUBLICATION_KEY: 'Publicação otimizada',
    OPTIMIZED_PUBLICATION_CONFIRM_KEY:
      'Deseja confirmar a publicação de uma nova imagem no modo otimizado?',
    DEFAULT_PUBLICATION_KEY: 'Publicação padrão',
    DEFAULT_PUBLICATION_CONFIRM_KEY:
      'Deseja confirmar a publicação de uma nova imagem no modo padrão?',
    KEEP_PUBLICATION_KEY: 'Publicação mantendo usuários conectados',
    KEEP_PUBLICATION_CONFIRM_KEY:
      'Deseja confirmar a publicação de uma nova imagem no modo mantendo usuários conectados?',
    RECONNECTION_PUBLICATION_KEY:
      'Publicação solicitando reconexão dos usuários',
    RECONNECTION_PUBLICATION_CONFIRM_KEY:
      'Deseja confirmar a publicação de uma nova imagem no modo solicitando reconexão dos usuários?',
    SCHEDULE_KEY: 'Agendar',
    UNAVAILABLE_VERSION_KEY: 'Versão indisponível',
    SEE_GENERATED_MODELS_KEY: 'Ver modelos gerados',
    LOGS_PUBLICATION_SUBSCRIPTION_KEY:
      'Logs e detalhes de publicações realizadas',
    SCHEDULES_KEY: 'Agendamentos',
    SCHEDULES_LISTING_KEY: 'Listagem de publicações agendadas',
    PUBLISH_NEW_IMAGE_OPTIMIZED_KEY: 'Publicar nova versão (Otimizado)',
    HISTORY_LOGS_PUBLISH_OPTIMIZED_KEY:
      'Histórico e acompanhamento de publicações',
    HISTORY_LOGS_PUBLISH_OPTIMIZED_DESCRIPTION_KEY:
      'Publicações realizadas e em andamento',
    AVERAGE_STEP_TIME_KEY: 'Tempo médio de cada etapa',
    AVERAGE_TOTAL_TIME_KEY: 'Média total do processo',
    STAGE_FAILED_KEY: 'Falhou',
    IN_PROGRESS_KEY: 'Em andamento...',
    PUBLICATION_DETAILS_KEY: 'Detalhes da publicação',
    SUCCESSFUL_PUBLICATION_KEY: 'Publicação finalizada com sucesso!',
    FAILED_PUBLICATION_KEY: 'A publicação falhou',
    WARNING_PUBLICATION_KEY: 'Incosistências ao realizar publicação',
    MADE_BY_KEY: 'Realizada por',
    START_END_KEY: 'Início/Fim',
    MODEL_VERSION_KEY: 'Versão do modelo',
    DURATION_KEY: 'Duração',
    PUBLICATION_IN_PROGRESS_KEY:
      'Publicação em andamento. Aguarde a finalização antes de publicar outra versão.',
    PUBLISH_SUCCESS_KEY: 'Sucesso',
    PUBLISH_FAILED_KEY: 'Falha',
    PUBLISH_TIMEOUT_KEY: 'Tempo esgotado',
    PUBLISH_WARNING_KEY: 'Inconsistência',
    PUBLISH_RUNNING_KEY: 'Em andamento',
    PUBLISH_SKIPPED_KEY: 'Não se aplica',
    PUBLICATION_STEP_DETAILS_KEY: 'Detalhes da etapa',
    WAIT_PROGRESS_PUBLISH_KEY:
      'Etapa em andamento. Aguarde a finalização para ver mais detalhes.',
    GENERATED_MODEL_KEY: 'Versão do modelo',
    UNAVAILABLE_MODEL_KEY: 'Modelo indisponível',
    BLOCK_INSTANCES_TOOLTIP_KEY:
      'Após concluir a criação dos modelos, instâncias com as versões atualizadas serão iniciadas, e as instâncias que utilizam as versões anteriores serão bloqueadas.',
    BLOCK_USERS_TOOLTIP_KEY:
      'Após as instâncias com as versões atualizadas serem iniciadas, envia uma mensagem de desconexão aos usuários conectados nas instâncias que utilizam as versões anteriores.',
    PUBLISH_IN_BULK_SUCCESS_KEY:
      "Publicação iniciada com sucesso! É possível ver o andamento e histórico de publicações de cada servidor clicando em 'Histórico e acompanhamento de publicações' nos ações do servidor",
    NOT_ENOUGH_DATA_PUBLISH_LOGS_KEY:
      'Sem dados suficientes. Realize uma publicação otimizada para mais detalhes.',
    MULTIPLE_EXPIRED_SESSIONS: 'Múltiplas sessões expiradas',
    USER_ALREADY_HAS_EXTERNAL_AD: 'Usuário já possui uma conta AD externa',
    LIST_WEB_APPLICATIONS: 'Listar aplicações web',
    CREATE_NEW_WEB_APPLICATION: 'Adicionar aplicações web',
    EDIT_WEB_APPLICATION: 'Editar aplicações web',
    DELETE_WEB_APPLICATION: 'Remover aplicações web',
    CAN_VIEW_ALL_RESOURCES: 'Listagem geral dos recursos',
    CAN_BLOCK_ACTIONS_PREPARATION_SERVER:
      'Bloquear ações do servidor de preparação',
    CAN_UNBLOCK_ACTIONS_PREPARATION_SERVER:
      'Desbloquear ações do servidor de preparação',
    CAN_BLOCK_ACTIONS_PARTNER_SERVERS:
      'Bloquear ações do servidor de preparação na conta',
    CAN_UNBLOCK_ACTIONS_PARTNER_SERVERS:
      'Desbloquear ações do servidor de preparação na conta',
    BLOCK_SERVER_ACTIONS_SUCCESSFULLY_KEY:
      'Ações do servidor bloqueadas com sucesso!',
    BLOCK_ACTIONS_SERVER_KEY: 'Bloquear ações do servidor',
    BLOCKING_TIME_SERVER_KEY: 'Tempo de bloqueio das ações do servidor',
    BLOCKING_REASON_KEY: 'Motivo do bloqueio',
    BLOCKING_ACTIONS_KEY: 'Bloquear ações',
    BLOCKING_SERVER_ACTIONS_DESCRIPTION_KEY:
      'Bloquear as ações do servidor impede os usuários de realizar as seguintes operações: vincular, desvincular, ligar, parar, publicar novas imagens e conectar, durante o período selecionado abaixo.',
    BLOCKED_PUBLICATIONS_DESCRIPTION_KEY:
      'A publicação de novas versões está bloqueada temporariamente devido ao bloqueio de ações no servidor realizado por {{name}} às {{time}}.',
    BLOCKED_PUBLICATIONS_RELEASE_KEY:
      'A publicação estará disponível às {{unblockDate}} ou caso as ações sejam desbloqueadas.',
    BLOCKED_ACTIONS_ALERT_DESCRIPTION_KEY:
      'A ações no servidor estão bloqueadas temporariamente devido ao bloqueio de ações no servidor realizado por {{name}} às {{time}}.',
    BLOCKED_ACTIONS_RELEASE_KEY:
      'As ações estarão disponíveis às {{unblockDate}} ou caso as ações sejam desbloqueadas.',
    SERVER_MAINTENANCE_ACTIONS_RELEASE_KEY:
      'Este servidor está em manutenção até as {{unblockDate}}. Não é possível realizar ações no servidor ou publicar novas imagens nesse período.',
    UNBLOCK_ACTIONS_SERVER_KEY: 'Desbloquear ações do servidor',
    UNBLOCKING_ACTIONS_KEY: 'Desbloquear ações',
    UNBLOCKING_SERVER_ACTIONS_DESCRIPTION_KEY:
      'Deseja desbloquear as ações do servidor?',
    UNBLOCKING_SERVER_ACTIONS_RESPONSIBLE_KEY:
      'O bloqueio das ações foi realizado por {{name}} às {{time}} e será encerrado às {{unblockDate}}',
    UNBLOCK_SERVER_ACTIONS_SUCCESSFULLY_KEY:
      'Ações do servidor desbloqueadas com sucesso!',
    UNBLOCKING_REASON_KEY: 'Motivo do desbloqueio',
    BLOCK_ACTIONS_TOOLTIP_SERVER_KEY:
      'Ações liberadas. Clique para bloquear as ações do servidor',
    UNBLOCK_ACTIONS_TOOLTIP_SERVER_KEY:
      'Ações bloqueadas. Clique para desbloquear as ações do servidor',
    BLOCKED_ACTIONS_PARTNER_KEY: 'Ações bloqueadas',
    MODAL_ACTIONS_BLOCKED_KEY:
      'A ação não será executada em servidores com ações bloqueadas (indicados pelo ícone de cadeado ao lado do botão de ações). Para executar nestes servidores, desbloqueie individualmente ou use a opção de desbloqueio em massa nas ações gerais.',
    DISABLE_RECAPTCHA_TOGGLE_KEY:
      'Inativar reCAPTCHA temporariamente no Portal 2.0',
    LAST_RECAPTCHA_INACTIVE_KEY: 'Inativação realizada por: ',
    BY_AT_KEY: '{{name}} em {{date}}.',
    INACTIVATING_REASON_KEY: 'Motivo da inativação',
    INACTIVATING_REASON_DETAIL_KEY: 'Motivo da inativação: ',
    INACTIVATE_RECAPTCHA_KEY: 'Inativação de reCAPTCHA',
    INACTIVATE_RECAPTCHA_DESCRIPTION_KEY:
      'O reCAPTCHA será inativado nas páginas "Esqueci minha senha", "Cadastre sua senha" e "Modificar minha senha" por 30 dias após a data de inativação.',
    EDIT_BLOCK_INSTANCES_WITH_SESSIONS_TIMEOUT:
      'Configurar monitoramento de bloqueio das instâncias com múltiplas sessões expiradas',
    BLOCK_INSTANCES_WITH_SESSIONS_TIMEOUT_KEY:
      'Bloqueio das instâncias com múltiplas sessões expiradas',
    BLOCK_INSTANCES_WITH_SESSIONS_TIMEOUT_ALERT_KEY:
      'O bloqueio de instâncias não é realizado em ambientes dos modos de comportamento: MANUAL e MICRO.',
    BLOCKED_BY_MONITORING_KEY: 'Bloqueado pelo monitoramento',
    STATUS_ZERO_TRUST_KEY: 'Status do Zero Trust',
    SPENT_SECONDS_TO_OPERATIONAL_ALERT_KEY:
      'Tempo até ficar operacional ou até alertar',
    EXPIRED_SESSIONS_KEY: 'Sessões expiradas',
    CONTINUE_KEY: 'Continuar',
    VERIFICATION_CODE_KEY: 'Código de verificação',
    HELP_VERIFICATION_CODE_ONE_KEY:
      "O código de segurança enviado em seu email foi feito para garantir a segurança das ações realizadas. Para confirmar a ação, é necessário inserir o código no campo 'Código de verificação'. Se você não recebeu o email, você pode tentar reenviar, clicando na opção de reenvio abaixo do campo do código, após 60 segundos da última solicitação.",
    HELP_VERIFICATION_CODE_TWO_KEY:
      "Se não estiver recebendo o código, verifique a caixa de spam ou lixo eletrônico do seu e-mail. Confirme também o e-mail cadastrado em sua conta clicando em seu nome no menu do canto superior direito >  Perfil > Campo 'Email'.",
    MORE_INFO_KEY: 'Saiba mais',
    WAIT_KEY: 'Aguarde...',
    VERIFICATION_CODE_RETRY_SECONDS_KEY:
      'Caso não tenha recebido o código em seu email, você pode tentar novamente em {{seconds}} segundos.',
    VERIFICATION_CODE_RETRY_SECOND_KEY:
      'Caso não tenha recebido o código em seu email, você pode tentar novamente em {{seconds}} segundo.',
    VERIFICATION_CODE_RETRY_KEY:
      'Caso não tenha recebido o código, você pode reenviar o email.',
    VERIFICATION_CODE_DESCRIPTION_KEY:
      'Um código de verificação foi enviado para seu e-mail. Por favor, insira-o abaixo para confirmar a ação:',
    INVALID_RESTRICTED_ACTION_TOKEN: 'Código de verificação incorreto',
    RELEASE_RECAPTCHA_KEY:
      'O reCAPTCHA será reativado automaticamente em {{date}}.',
    REACTIVATION_KEY: 'Reativação: ',
    LDAP_TEST_RESULT: {
      AUTHENTICATE_ADMIN: 'Autenticação do administrador',
      CREATE_GROUP: 'Criação de grupo',
      CREATE_USER: 'Criação de usuário',
      ACTIVATE_USER: 'Ativação de usuário',
      RESET_USER_PASSWORD: 'Redefinição de senha do usuário',
      AUTHENTICATE_USER: 'Autenticação do usuário',
      CHANGE_USER_PASSWORD: 'Alteração de senha do usuário',
      REMOVE_USER_FROM_GROUP: 'Remoção de usuário do grupo',
      DELETE_USER: 'Exclusão de usuário',
      DELETE_GROUP: 'Exclusão de grupo',
    },
    CONNECTED_SUCCESSFULLY_KEY: 'Teste realizado com sucesso!',
    CONNECTION_FAILED_KEY: 'Teste realizado com falha',
    CUSTOM_APP_COLOR_DETAILS_KEY: 'Detalhes de aplicações web',
    CUSTOM_DETAILS_COLOR_DETAILS_KEY: 'Detalhes na página de login',
    LIST_LICENSE_GROUPS: 'Listar grupos de licença',
    CREATE_LICENSE_GROUP: 'Criar grupo de licença',
    EDIT_LICENSE_GROUP: 'Editar grupo de licença',
    DELETE_LICENSE_GROUP: 'Excluir grupo de licença',
    EDIT_LICENSE_GROUP_CLIENTS: 'Editar clientes do grupo de licença',
    LICENSE_GROUP_KEY: 'Grupo de licenças',
    LICENSE_GROUP_SUBTITLE_KEY: 'Listagem e gerenciamento de grupos de licença',
    CREATE_LICENSE_GROUP_KEY: 'Criar grupo de licença',
    GROUP_CREATED_SUCCESSFULLY_KEY: 'Grupo criado com sucesso!',
    GROUP_DELETED_SUCCESSFULLY_KEY: 'Grupo excluído com sucesso!',
    DELETE_LICENSE_GROUP_KEY: 'Excluir grupo de licença',
    DELETE_LICENSE_GROUP_CONFIRM_KEY:
      'Tem certeza que deseja excluir este grupo de licenças?',
    ADD_CLIENTS_TO_GROUP_KEY: 'Adicionar clientes ao grupo',
    ADD_CLIENTS_TO_GROUP_DESCRIPTION_KEY:
      'Selecione os clientes que deseja adicionar a este grupo de licenças',
    LICENSE_LIMIT_NOT_AVAILABLE: 'Quantidade de licenças não disponível',
    ENVIRONMENT_NOT_ALLOW_PER_CLIENT_LICENSES:
      'Este ambiente não permite licenças por cliente',
    CLIENTS_ADDED_SUCCESSFULLY_KEY: 'Clientes adicionados com sucesso!',
    CLIENTS_UPDATED_SUCCESSFULLY_KEY: 'Clientes editados com sucesso!',
    GROUP_DETAILS_KEY: 'Detalhes do grupo',
    LICENSES_QUANTITY_KEY: 'Quantidade de licenças',
    CLIENTS_QUANTITY_KEY: 'Quantidade de clientes',
    EDIT_GROUP_INFO_KEY: 'Editar nome e licenças',
    EDIT_CLIENTS_KEY: 'Editar clientes',
    GROUP_UPDATED_SUCCESSFULLY_KEY: 'Grupo editado com sucesso!',
    UPDATE_LICENSE_GROUP_KEY: 'Editar grupo de licença',
    EDIT_CLIENTS_IN_GROUP_KEY: 'Editar clientes do grupo',
    EDIT_CLIENTS_DESCRIPTION_KEY:
      'Selecione os clientes que deseja adicionar ao grupo, ou desmarque os que deseja remover',
    ACCESS_GROUP_KEY: 'Acessar grupo',
    LICENSE_LIMIT_GROUP_KEY: 'Quantidade de licenças do grupo',
    THIS_CLIENT_IS_IN_GROUP_KEY: 'Este cliente faz parte do grupo de licenças',
    CLIENT_IN_GROUP_TOOLTIP_KEY:
      'Para configurar licenças por cliente, é necessário remover este cliente do grupo de licenças',
    ZERO_TRUST_CARD_INFO_TEXT_KEY:
      'Apenas ambientes com conexão pública são contabilizados.',
    ZERO_TRUST_CONFIG_INFO_TEXT_KEY:
      'Apenas ambientes com conexão pública são elegíveis.',
    NOT_IDENTIFIED_KEY: 'Não identificada',
    ENVIRONMENT_NOT_ELIGIBLE_FOR_TEST_KEY:
      'Ambiente não elegível para este teste',
    AVAILABLE_LICENSES_ENVIRONMENT_KEY: 'Licenças disponíveis no ambiente',
    AVAILABLE_LICENSES_GROUP_KEY: 'Licenças disponíveis para este grupo',
    REMOVED_PERMANENTLY_KEY: 'Removido permanentemente',
    CONDITION_OPERATORS: {
      ICONTAINS_KEY: '~ (contém)',
      ICONTAINS_NOT_KEY: '!~ (não contém)',
      IS_KEY: '= (é igual)',
      IS_NOT_KEY: '!= (não é igual)',
    },
    FILTERS_KEY: 'Filtros',
    SEARCH_FILTERS_KEY: 'Pesquisar filtros',
    NO_OPTIONS_KEY: 'Sem opções',
    CLIENT_ALREADY_IN_LICENSE_GROUP_KEY:
      'Você selecionou um cliente que já está em um grupo de licença. Ao confirmar, o cliente selecionado será removido do grupo anterior e adicionado a este grupo.',
    MALFORMED_X509_PUBLIC_CERTIFICATE: 'Certificado x509 do IdP inválido',
    TITLE_FONTS_LOGIN_KEY: 'Textos e fontes login',
    TITLE_FONTS_MFA_KEY: 'Textos e fontes MFA',
    LOGIN_PAGE_TITLE_TEXT_PTBR_KEY: 'Título da página de login em português',
    LOGIN_PAGE_SUBTITLE_TEXT_PTBR_KEY:
      'Subtítulo da página de login em português',
    MFA_PAGE_TITLE_TEXT_PTBR_KEY: 'Título da página de MFA em português',
    MFA_PAGE_SUBTITLE_TEXT_PTBR_KEY: 'Subtítulo da página de MFA em português',
    MFA_FONT_SIZE_KEY: 'Tamanho da fonte do título de MFA',
    DESCRIPTION_MFA_FONT_SIZE_KEY: 'Tamanho da fonte da descrição de MFA',
    LOGIN_PAGE_TITLE_TEXT_EN_KEY: 'Título da página de login em inglês',
    LOGIN_PAGE_SUBTITLE_TEXT_EN_KEY: 'Subtítulo da página de login em inglês',
    MFA_PAGE_TITLE_TEXT_EN_KEY: 'Título da página de MFA em inglês',
    MFA_PAGE_SUBTITLE_TEXT_EN_KEY: 'Subtítulo da página de MFA em inglês',
    LOGIN_PAGE_TITLE_TEXT_ES_KEY: 'Título da página de login em espanhol',
    LOGIN_PAGE_SUBTITLE_TEXT_ES_KEY: 'Subtítulo da página de login em espanhol',
    MFA_PAGE_TITLE_TEXT_ES_KEY: 'Título da página de MFA em espanhol',
    MFA_PAGE_SUBTITLE_TEXT_ES_KEY: 'Subtítulo da página de MFA em espanhol',
    USER_NOT_SOFT_DELETED:
      'Não é possível excluir este usuário, pois ele está vinculado a outros clientes.',
    APPLICATION_SERVER_KEY: 'Servidor de aplicação',
    SEE_MORE_KEY: '+ Ver mais',
    SEE_LESS_KEY: '- Ver menos',
    BENCHMARK_INSTANCES_KEY: 'Métricas das instâncias',
    BENCHMARK_INTERVAL_KEY: 'Intervalo entre as métricas (em minutos):',
    BENCHMARK_DURATION_KEY: 'Duração de cada métrica (em segundos):',
    SECONDS_KEY: 'Segundos',
    BENCHMARK_DURATION_TOOLTIP_KEY:
      'Tempo, em segundos, que a rotina de verificação utilizará para coletar as informações.',
    BENCHMARK_INTERVAL_TOOLTIP_KEY:
      'Intervalo, em minutos, que o sistema aguardará para executar a rotina de verificação da capacidade de processamento da instância.',
    BENCHMARK_NULL_KEY: 'Status de métricas não disponível',
    MATRIX_KEY: 'Matriz:',
    LOW_PERFORMANCE_MATRIX_KEY: 'Até 7.000 - Performance Baixa',
    MODERATE_PERFORMANCE_MATRIX_KEY: '7.001 a 11.000 - Performance Moderada',
    MODERATE_TO_HIGH_PERFORMANCE_MATRIX_KEY:
      '11.001 a 12.500 - Performance Moderada/Alta',
    HIGH_PERFORMANCE_MATRIX_KEY: '12.501 a 30.000 - Alta Performance',
    LOW_PERFORMANCE_KEY: 'Baixa',
    MODERATE_PERFORMANCE_KEY: 'Moderada',
    MODERATE_TO_HIGH_PERFORMANCE_KEY: 'Moderada/Alta',
    HIGH_PERFORMANCE_KEY: 'Alta',
    BENCHMARK_INSTANCE_KEY: 'Métrica da instância',
    OPERATIONS_KEY: 'Operações',
    BENCHMARK_CONFIG_KEY: 'Métrica da análise de performance',
    INTERVAL_IN_MINUTES_KEY: 'Intervalo: {{interval}} minutos',
    PROCESS_TIME_KEY: 'Tempo de processamento: {{seconds}} segundos',
    BENCHMARK_DATE_AT_KEY: 'Métrica realizada ás: {{date}}',
    PLATFORM_OLD_VERSION_KEY:
      'Versão do Platform não é compátivel para a coleta de métricas (>= 4.1.1.6)',
    SHOULD_APPLY_ADVISOR_AUTOMATICALLY_KEY:
      'Aplicar otimizações automaticamente',
    HIGH_RISK_ENVIRONMENT_KEY: 'Ambiente de alto risco ou com particularidades',
    HIGH_RISK_ENVIRONMENT_ALERT_KEY:
      'Ao ativar esta opção, o ambiente será classificado como de alto risco, o que impedirá a criação e aplicação automática de otimizações.',
    SHOULD_APPLY_ADVISOR_AUTOMATICALLY_DESCRIPTION_KEY:
      'Habilita a aplicação automática de otimizações conforme a utilização do ambiente pelos usuários, com foco na otimização e redução de custos.',
    SHOULD_APPLY_ADVISOR_AUTOMATICALLY_ALERT_KEY:
      'Otimizações de alto risco exigem confirmação manual e não serão aplicadas automaticamente.',
    HIGH_RISK_ENVIRONMENT_DESCRIPTION_KEY:
      'Ative esta opção para impedir que a aplicação de advisors seja realizada automaticamente.',
    SUGGEST_APPLY_ADVISOR_AUTOMATICALLY_TITLE_KEY:
      'Ativação de aplicação automática de otimizações',
    SUGGEST_APPLY_ADVISOR_AUTOMATICALLY_DESCRIPTION_KEY:
      'Deseja ativar a aplicação automática de otimizações de baixo e médio risco nesse ambiente?',
    ADVISORS_CONFIGURATIONS_KEY: 'Configurações de otimizações',
    RISK_KEY: 'Risco',
    LOW_IMPACT_KEY: 'Baixo',
    MEDIUM_IMPACT_KEY: 'Médio',
    HIGH_IMPACT_KEY: 'Alto',
    DYNAMIC_ADVISOR_WEEKDAY_START_KEY: 'Advisor semanal início',
    DYNAMIC_ADVISOR_WEEKDAY_END_KEY: 'Advisor semanal término',
    MONTH_KEY: 'Mês',
    ANNUAL_KEY: 'Anual',
    AUTOSKY_SYSTEM_KEY: 'Sistema Autosky',
    SCALING_ADVISOR_REVERT_HISTORY_NOT_FOUND:
      'A otimização não tem histórico armazenado para ser revertido',
    ADVISORS_HISTORY_KEY: 'Histórico de otimizações',
    ADVISORS_KEY: 'Otimizações',
    CHECK_PASSWORD_HISTORY_KEY: 'Validar histórico de senhas',
    CHECK_PASSWORD_COMPLEXITY_KEY: 'Validar complexidade de senhas',
    SECURE_DEVICE_VALIDATION_KEY: 'Validação de dispositivos seguros',
    ENABLE_DEVICE_VALIDATION_KEY: 'Ativar validação de dispositivo',
    DEVICE_VALIDATION_TOOLTIP_KEY:
      'Habilita a autenticação com Token de segurança por dispositivo.',
    ADMIN_PIN_KEY: 'Token administrativo',
    COPY_PIN_KEY: 'Copiar Token',
    REGENERATE_PIN_KEY: 'Trocar Token',
    GET_ADMINISTRATIVE_PIN: 'Obter Token administrativo',
    RESET_ADMINISTRATIVE_PIN: 'Trocar Token administrativo',
    DEVICE_VALIDATION_ENABLED_MESSAGE:
      'A validação de dispositivo seguro está ativa no ambiente',
    DEVICE_VALIDATION_DISABLED_MESSAGE:
      'A validação de dispositivo seguro está inativa no ambiente',
    SECURE_DEVICE_VALIDATION_AT_ENVIRONMENT_KEY:
      'Validação de dispositivos seguros no ambiente',
    PIN_COPIED_KEY: 'Token copiado!',
    PIN_RESET_KEY: 'Token trocado!',
    FORCE_RESET_PASSWORD_NEXT_LOGIN_KEY:
      'Forçar troca de senha no próximo login',
    FORCE_RESET_PASSWORD_NEXT_LOGIN_DESCRIPTION_KEY:
      'O usuário {{name}} será obrigado a redefinir sua senha no próximo login',
    FORCE_RESET_PASSWORD_NEXT_LOGIN_SELECTED_KEY:
      'Forçar troca de senha no próximo login',
    WANT_FORCE_RESET_PASSWORD_NEXT_LOGIN_SELECTED_KEY:
      'Deseja forçar a troca de senha para os usuários selecionados?',
    FORCE_RESET_PASSWORD_NEXT_LOGIN_SELECTED_DESCRIPTION_KEY:
      'Os usuários selecionados serão obrigados a redefinir suas senhas no próximo login',
    REMOVE_FORCE_RESET_PASSWORD_SELECTED_KEY:
      'Remover obrigatoriedade de troca de senha',
    WANT_REMOVE_FORCE_RESET_PASSWORD_SELECTED_KEY:
      'Deseja remover a obrigatoriedade de troca de senha no próximo login para os usuários selecionados?',
    REMOVE_FORCE_RESET_PASSWORD_SELECTED_DESCRIPTION_KEY:
      'Os usuários selecionados não serão mais obrigados a redefinir suas senhas no próximo login',
    REMOVE_FORCE_RESET_PASSWORD_NEXT_LOGIN_KEY:
      'Remover obrigatoriedade de troca de senha no próximo login',
    REMOVE_FORCE_RESET_PASSWORD_NEXT_LOGIN_DESCRIPTION_KEY:
      'O usuário {{name}} não será mais obrigado a redefinir sua senha no próximo login',

    ACTIVE_FORCE_RESET_PASSWORD_SUCCESS_KEY:
      'Os usuários selecionados são obrigados a alterar a senha no próximo login',
    INACTIVE_FORCE_RESET_PASSWORD_SUCCESS_KEY:
      'Os usuários selecionados não são mais obrigados a alterar a senha no próximo login',
    PASSWORD_CHANGE_REQUIRED_KEY:
      'O usuário precisa alterar a senha no próximo login',

    TRUSTED_DEVICES_KEY: 'Dispositivos verificados',
    ENABLE_DEVICE_VALIDATION_BYPASS_KEY: 'Ignorar validação de dispositivo',
    DISABLE_DEVICE_VALIDATION_BYPASS_KEY: 'Exigir validação de dispositivo',
    ENABLE_DEVICE_VALIDATION_BYPASS_SUCCESS_KEY:
      'Validação de dispositivo ignorada com sucesso',
    DISABLE_DEVICE_VALIDATION_BYPASS_SUCCESS_KEY:
      'Validação de dispositivo exigida com sucesso',
    ENABLE_DEVICE_VALIDATION_BYPASS_MODAL_TITLE_KEY:
      'Ignorar a validação de dispositivo para esse usuário?',
    DISABLE_DEVICE_VALIDATION_BYPASS_MODAL_TITLE_KEY:
      'Exigir a validação de dispositivo para esse usuário?',
    ENABLE_DEVICE_VALIDATION_BYPASS_MODAL_CONTENT_KEY:
      'Ao confirmar, não será validado o dispositivo no momento do login para o usuário.',
    DISABLE_DEVICE_VALIDATION_BYPASS_MODAL_CONTENT_KEY:
      'Este usuário voltará a ser submetido à validação de dispositivo ao tentar acessar o sistema.',
    DEVICE_HASH_KEY: 'Hash',
    DEVICE_TYPE_KEY: 'Tipo',
    OPERATING_SYSTEM_KEY: 'Sistema Operacional',
    BROWSER_KEY: 'Navegador',
    DISABLED_DEVICE_KEY: 'Dispositivo desabilitado',
    DELETE_TRUSTED_DEVICE_KEY: 'Desabilitar dispositivo',
    CONFIRM_DELETE_TRUSTED_DEVICE_KEY: 'Deseja desabilitar o dispositivo?',
    CONFIRM_DELETE_TRUSTED_DEVICE_MESSAGE_KEY:
      'Tem certeza de que deseja desabilitar este dispositivo verificado? O usuário precisará se autenticar novamente neste dispositivo.',
    TRUSTED_DEVICE_DELETED_SUCCESSFULLY_KEY:
      'Dispositivo desabilitado com sucesso!',
    ERROR_DELETING_TRUSTED_DEVICE_KEY:
      'Erro ao desabilitar dispositivo. Tente novamente.',
    NO_TRUSTED_DEVICES_KEY: 'Nenhum dispositivo encontrado.',
    LAST_VALIDATED_IP_KEY: 'Último IP validado',
    EMAIL_PIN_VALIDATION_KEY: 'Token por e-mail',
    ADM_PIN_VALIDATION_KEY: 'Token do administrador',
    ZERO_TRUST_ALLOWLIST_VALIDATION_KEY: 'Lista de permissões do Zero Trust',
    IP_HISTORY_VALIDATION_KEY: 'Histórico de IP',
    MFA_ACTIVE_TOOLTIP: 'MFA ativo',
    MFA_INACTIVE_TOOLTIP: 'MFA inativo',
    MFA_CONFIGURED_TOOLTIP: 'MFA configurado',
    MFA_NOT_CONFIGURED_TOOLTIP: 'MFA não configurado',
    SAFE_DEVICE_ENABLED_TOOLTIP: 'Possui dispositivo verificado',
    SAFE_DEVICE_DISABLED_TOOLTIP: 'Não possui dispositivo verificado',
    DEVICE_VALIDATION_BYPASS_ENABLED:
      'A verificação de dispositivo está sendo ignorada para este usuário.',
    PASSWORD_RESET_VALIDATION_KEY: 'Registro de senha',
    AUTO_REGISTER_NEXT_DEVICE_VALIDATION_KEY: 'Registro automático',
    SECURE_DEVICE_VALIDATION_TOOLTIP:
      'Ative esta opção para exigir validação segura do dispositivo via Token Administrativo. Essa medida adiciona uma camada extra de segurança no acesso ao ambiente.',
    CAN_ENABLE_SERVER_MONITORING_MANAGEMENT:
      'Ativar gerenciamento do monitoramento do servidor',
    CAN_DISABLE_SERVER_MONITORING_MANAGEMENT:
      'Desativar gerenciamento do monitoramento do servidor',
    ENABLE_SERVER_MONITORING_MANAGEMENT_INFO_TEXT_KEY:
      'Ativa o gerenciamento do monitoramento no 24x7. Ao ligar ou desligar o servidor, o monitoramento será ajustado automaticamente.',
    ENABLE_SERVER_MONITORING_MANAGEMENT_MODAL_TITLE_KEY:
      'Ativar gerenciamento do monitoramento no 24x7',
    ENABLE_SERVER_MONITORING_MANAGEMENT_MODAL_DESCRIPTION_KEY:
      'Deseja ativar o gerenciamento do monitoramento no 24x7 para este servidor? Ao ligar ou desligar o servidor, o monitoramento será ajustado automaticamente.',
    ENABLE_SERVER_MONITORING_MANAGEMENT_SUCCESSFULLY_KEY:
      'Gerenciamento do monitoramento do servidor ativado com sucesso!',
    DISABLE_SERVER_MONITORING_MANAGEMENT_MODAL_TITLE_KEY:
      'Desativar gerenciamento do monitoramento no 24x7',
    DISABLE_SERVER_MONITORING_MANAGEMENT_MODAL_DESCRIPTION_KEY:
      'Deseja desativar o gerenciamento do monitoramento no 24x7 para este servidor? O monitoramento não será mais ajustado automaticamente quando o servidor for ligado ou desligado.',
    DISABLE_SERVER_MONITORING_MANAGEMENT_SUCCESSFULLY_KEY:
      'Gerenciamento do monitoramento do servidor desativado com sucesso!',
    CAN_VIEW_SERVER_MONITORING_STATUS:
      'Ver status do monitoramento do servidor',

    SERVER_MONITORING_STATUS: {
      DOWN_KEY: 'Indisponível',
      UP_KEY: 'Ligado',
      TROUBLE_KEY: 'Com problemas',
      CRITICAL_KEY: 'Problemas críticos',
      SUSPENDED_KEY: 'Suspenso',
      MAINTENANCE_KEY: 'Em manutenção',
      DISCOVERY_KEY: 'Em descoberta',
      CONFIGURATION_ERROR_KEY: 'Erro de configuração',
      WITHOUT_MONITOR_KEY: 'Sem monitoramento',
      UNAVAILABLE_KEY: 'Sem informação',
    },
    STOPPING_KEY: 'Parando...',
    USERNAME_REQUIRED_FOR_EXTERNAL_AD:
      'O campo de Código no AD é obrigatório para contas de AD externo.',
    MANAGED_EXTERNALLY:
      'Usuário de gerenciamento externo. Para alterar a senha, contate o administrador do sistema.',
    SUSPEND_MONITORING_ERROR: 'Erro ao suspender monitoramento do servidor.',
    NO_AD_AUTH_TITLE: 'AD na autenticação',
    USE_ENVIRONMENT_SETTING_KEY: 'Usar configuração do ambiente',
    AUTH_WITHOUT_AD_KEY: 'Autenticação sem AD',
    AUTH_WITH_AD_KEY: 'Autenticação com AD',
    AD_AUTH_CONFIG_KEY: 'Configuração da autenticação',
    PERFORMANCE_ANALYSIS_TITLE_KEY: 'Análise de performance das instâncias',
    PERFORMANCE_ANALYSIS_SUBTITLE_KEY:
      'As informações são atualizadas a cada minuto',
    SEARCH_PLACEHOLDER_KEY: 'Procurar',
    CPU_CURRENT_KEY: 'CPU atual',
    CPU_AVERAGE_KEY: 'CPU média',
    MEMORY_CURRENT_KEY: 'Memória atual',
    SESSIONS_CURRENT_KEY: 'Sessões atuais',
    COLLECTION_TIME_KEY: 'Horário da coleta',
    LIST_PARTNER_INSTANCES: 'Listar instâncias da conta',
    SHOW_INSTANCES_LIST_KEY: 'Exibir lista de instâncias da conta',
    ACTIVE_SALT_KEY: 'Usuário com salt ativo',
    INACTIVE_SALT_KEY: 'Usuário com salt inativo',
    DEVICE_VALIDATION_KEY: 'Ambiente com validação de dispositivos seguros',
    USER_MFA_ACTIVE_TOOLTIP: 'Usuário com MFA ativo',
    USER_MFA_INACTIVE_TOOLTIP: 'Usuário com MFA inativo',
    COPY_INFORMATION_KEY: 'Copiar informações',
  },
};
